import { ReadStream } from 'fs';
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { z } from 'zod'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
interface GraphQLFileUpload {
  filename: string;
  mimetype: string;
  encoding: string;
  createReadStream( options?:{ encoding?: string, highWaterMark?: number } ): ReadStream;
}
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: Date;
  JSON: any;
  JSONObject: any;
  Upload: File;
};

export type ActivityLevel = {
  __typename?: 'ActivityLevel';
  minutes: Scalars['Float'];
  name: Scalars['String'];
};

export type ArchiveOutput = {
  __typename?: 'ArchiveOutput';
  createdAt: Scalars['Float'];
  duration: Scalars['String'];
  hasAudio: Scalars['String'];
  hasVideo: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  outputMode: Scalars['String'];
  partnerId: Scalars['String'];
  projectId: Scalars['String'];
  reason: Scalars['String'];
  resolution: Scalars['String'];
  sessionId: Scalars['String'];
  size: Scalars['Float'];
  status: Scalars['String'];
  streamMode: Scalars['String'];
  streams: Array<Stream>;
  url: Scalars['String'];
};

export type AssessmentAnswerEntity = {
  __typename?: 'AssessmentAnswerEntity';
  answerDate?: Maybe<Scalars['DateTime']>;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  question?: Maybe<AssessmentQuestionEntity>;
  updatedAt: Scalars['DateTime'];
  value?: Maybe<Scalars['JSONObject']>;
  values?: Maybe<Array<Scalars['String']>>;
};

export type AssessmentAnswerInputType = {
  answerDate?: InputMaybe<Scalars['DateTime']>;
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  questionId: Scalars['Float'];
  value?: InputMaybe<Scalars['JSONObject']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type AssessmentQuestionEntity = {
  __typename?: 'AssessmentQuestionEntity';
  automation?: Maybe<Scalars['JSONObject']>;
  category?: Maybe<QuestionCategoryEntity>;
  conditions?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  isAnswered?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  meta?: Maybe<Scalars['JSONObject']>;
  options?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Float']>;
  questions?: Maybe<Array<AssessmentQuestionEntity>>;
  symptomName?: Maybe<Scalars['String']>;
  symptomNameEs?: Maybe<Scalars['String']>;
  tooltip?: Maybe<TooltipEntity>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  variableName?: Maybe<Scalars['String']>;
};

export type AssessmentQuestionInputType = {
  automation?: InputMaybe<Scalars['JSONObject']>;
  category?: InputMaybe<QuestionCategoryInputType>;
  conditions?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  identifier?: InputMaybe<Scalars['String']>;
  isAnswered?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['JSONObject']>;
  options?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  questions?: InputMaybe<Array<AssessmentQuestionInputType>>;
  symptomName?: InputMaybe<Scalars['String']>;
  symptomNameEs?: InputMaybe<Scalars['String']>;
  tooltip?: InputMaybe<TooltipInputType>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variableName?: InputMaybe<Scalars['String']>;
};

export type AssessmentQuestionOutputType = {
  __typename?: 'AssessmentQuestionOutputType';
  count: Scalars['Int'];
  items: Array<AssessmentQuestionEntity>;
};

export type AssessmentQuestionWhereInputType = {
  id?: InputMaybe<Scalars['Float']>;
  identifier?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  variableName?: InputMaybe<Scalars['String']>;
};

export type AssessmentResponseEntity = {
  __typename?: 'AssessmentResponseEntity';
  answerDate?: Maybe<Scalars['DateTime']>;
  answers?: Maybe<Array<AssessmentAnswerEntity>>;
  conversationUUID?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  incrementFollowupQuestionsCount?: Maybe<Scalars['Float']>;
  library: LibraryEntity;
  libraryId: Scalars['Int'];
  preIVRQuestionsRequired?: Maybe<Scalars['Boolean']>;
  skippedQuestionCount?: Maybe<Scalars['Float']>;
  skippedQuestionsBySystemCount?: Maybe<Scalars['Float']>;
  study?: Maybe<StudyEntity>;
  studyArm?: Maybe<StudyArmEntity>;
  triggeredAutomationIndexes: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: UserEntity;
  userId: Scalars['Int'];
};

export type AssessmentResponseInputType = {
  answerDate?: InputMaybe<Scalars['DateTime']>;
  answers: Array<AssessmentAnswerInputType>;
  conversationUUID?: InputMaybe<Scalars['String']>;
  library: Scalars['Float'];
  preIVRQuestionsRequired?: InputMaybe<Scalars['Boolean']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  user?: InputMaybe<Scalars['Float']>;
};

export type AssessmentResponseOutputType = {
  __typename?: 'AssessmentResponseOutputType';
  count: Scalars['Int'];
  items: Array<AssessmentResponseEntity>;
};

export type AssessmentResponseWithTokenInputType = {
  answers: Array<AssessmentAnswerInputType>;
};

export type AssessmentResponsesWhereInputType = {
  answerDate?: InputMaybe<Scalars['DateTime']>;
  conversationUUID?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  libraryId?: InputMaybe<Scalars['Float']>;
  libraryIds?: InputMaybe<Array<Scalars['Float']>>;
  userId?: InputMaybe<Scalars['Float']>;
};

export type AssessmentsAnsweredResponseOutputType = {
  __typename?: 'AssessmentsAnsweredResponseOutputType';
  date: Scalars['DateTime'];
  isAnswered: Scalars['Boolean'];
};

export type AssignedStaffInputType = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<RoleAutoCompleteInputType>;
};

export type AuditEntity = {
  __typename?: 'AuditEntity';
  action: Scalars['String'];
  id: Scalars['Float'];
  newData?: Maybe<Scalars['String']>;
  notify: Scalars['Boolean'];
  oldData?: Maybe<Scalars['String']>;
  study?: Maybe<StudyEntity>;
  studyArm?: Maybe<StudyArmEntity>;
  tableName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserEntity>;
};

export type AuditInput = {
  action?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  newData?: InputMaybe<Scalars['String']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  oldData?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  tableName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['Float']>;
};

export type AuditOutput = {
  __typename?: 'AuditOutput';
  count: Scalars['Int'];
  items: Array<AuditEntity>;
};

export type AuthOutputType = {
  __typename?: 'AuthOutputType';
  token?: Maybe<Scalars['String']>;
};

export type AutomationActionType = {
  data?: InputMaybe<Scalars['String']>;
  do: Scalars['String'];
  where: Scalars['String'];
  who: Array<AutomationActionWhoType>;
};

export type AutomationActionWhoType = {
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AutomationConditionType = {
  logic: Scalars['String'];
  operator: Scalars['String'];
  question: Scalars['String'];
  value: Scalars['String'];
  what: Scalars['String'];
};

export type AutomationInputType = {
  actions: Array<AutomationActionType>;
  conditions: Array<AutomationConditionType>;
};

export type AutomationWhoOutputType = {
  __typename?: 'AutomationWhoOutputType';
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CallRecordingOutputType = {
  __typename?: 'CallRecordingOutputType';
  createdAt: Scalars['DateTime'];
  durationSeconds?: Maybe<Scalars['Int']>;
  format: Scalars['String'];
  recordingId: Scalars['Int'];
  url: Scalars['String'];
};

export type CanDeleteLibraryOutputType = {
  __typename?: 'CanDeleteLibraryOutputType';
  canDelete: Scalars['Boolean'];
  message: Scalars['String'];
};

export type ChartEntity = {
  __typename?: 'ChartEntity';
  category: ChartTabEntity;
  categoryId?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  dataSource: AssessmentQuestionEntity;
  dataSource1?: Maybe<AssessmentQuestionEntity>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  fullWidth: Scalars['Boolean'];
  id: Scalars['ID'];
  meta?: Maybe<Scalars['JSONObject']>;
  plots: Array<Scalars['String']>;
  plots1?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  title1?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  type1?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserEntity;
  xAxis: Scalars['String'];
  yAxis: Scalars['String'];
  yAxis1?: Maybe<Scalars['String']>;
};

export type ChartTabEntity = {
  __typename?: 'ChartTabEntity';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  order?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Float']>;
};

export type ChartTabInputType = {
  id?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
};

export type ChartTabOutputType = {
  __typename?: 'ChartTabOutputType';
  chartCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  order?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Float']>;
};

export type ChatMessageDetailOutputType = {
  __typename?: 'ChatMessageDetailOutputType';
  attachments?: Maybe<Array<Scalars['JSONObject']>>;
  conversationId: Scalars['String'];
  isRead: Scalars['Boolean'];
  messageDate: Scalars['DateTime'];
  messageId: Scalars['Int'];
  recipientId: Scalars['Int'];
  recipientName: Scalars['String'];
  recipientRole: Scalars['String'];
  senderId: Scalars['Int'];
  senderName: Scalars['String'];
  senderRole: Scalars['String'];
  text: Scalars['String'];
};

export type ClinicEntity = {
  __typename?: 'ClinicEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  doctorName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber?: Maybe<PhoneNumberEntity>;
  updatedAt: Scalars['DateTime'];
};

export type ClinicInputType = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  doctorName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<PhoneNumberInputType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CoachingAssessmentForNotesOutput = {
  __typename?: 'CoachingAssessmentForNotesOutput';
  hasCoachingAssessment: Scalars['Boolean'];
  noteId?: Maybe<Scalars['Int']>;
};

export type CoachingCallDetailOutputType = {
  __typename?: 'CoachingCallDetailOutputType';
  assessmentQuestions?: Maybe<Array<IvrQuestionAnswerOutputType>>;
  callDate: Scalars['DateTime'];
  coachId: Scalars['Int'];
  coachName: Scalars['String'];
  coachingCallId: Scalars['Int'];
  durationMinutes?: Maybe<Scalars['Int']>;
  libraryDetails?: Maybe<Scalars['JSONObject']>;
  noteAttachments?: Maybe<Array<Scalars['JSONObject']>>;
  noteIds?: Maybe<Array<Scalars['Int']>>;
  notes?: Maybe<Scalars['String']>;
  recording?: Maybe<CallRecordingOutputType>;
};

export type CoachingEvents = {
  __typename?: 'CoachingEvents';
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  libraryId?: Maybe<Scalars['Int']>;
  start: Scalars['DateTime'];
  status?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CommunicationCallDetailOutputType = {
  __typename?: 'CommunicationCallDetailOutputType';
  callDate: Scalars['DateTime'];
  callParticipants: Array<CommunicationCallParticipantType>;
  callType: Scalars['String'];
  communicationCallId: Scalars['Int'];
  durationMinutes?: Maybe<Scalars['Int']>;
  recording?: Maybe<CallRecordingOutputType>;
};

export type CommunicationCallParticipantType = {
  __typename?: 'CommunicationCallParticipantType';
  role: Scalars['String'];
  userId: Scalars['Int'];
  userName: Scalars['String'];
};

export type ConferenceEntity = {
  __typename?: 'ConferenceEntity';
  answerTimestamp?: Maybe<Scalars['String']>;
  conversationUuid?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dtmf: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  fromUserId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  machineDetectionMeta?: Maybe<Scalars['String']>;
  machineDetectionStatus?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<NoteEntity>>;
  officialTouchpoint?: Maybe<Scalars['Boolean']>;
  recording?: Maybe<RecordingEntity>;
  sessionId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studyId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  toUserId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ConferenceInputType = {
  noteId?: InputMaybe<Scalars['Float']>;
  officialTouchpoint?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  studyId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ConferenceOutputType = {
  __typename?: 'ConferenceOutputType';
  count: Scalars['Int'];
  items: Array<ConferenceEntity>;
};

export type ConferenceWhereInputType = {
  conversationUuid?: InputMaybe<Scalars['String']>;
  fromUserId?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Float']>;
  sessionId?: InputMaybe<Scalars['String']>;
  studyId?: InputMaybe<Scalars['Float']>;
  toUserId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ConferenceWithUsersOutputType = {
  __typename?: 'ConferenceWithUsersOutputType';
  count: Scalars['Int'];
  items: Array<ConferenceWithUsersRelation>;
};

export type ConferenceWithUsersRelation = {
  __typename?: 'ConferenceWithUsersRelation';
  answerTimestamp?: Maybe<Scalars['String']>;
  conversationUuid?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dtmf: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  fromUser: UserEntity;
  fromUserId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  machineDetectionMeta?: Maybe<Scalars['String']>;
  machineDetectionStatus?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<NoteEntity>>;
  officialTouchpoint?: Maybe<Scalars['Boolean']>;
  recording?: Maybe<RecordingEntity>;
  sessionId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studyId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  toUser: UserEntity;
  toUserId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CountryInputType = {
  countryCallingCode: Scalars['String'];
  countryCode: Scalars['String'];
  nationalNumber: Scalars['String'];
  numberValue: Scalars['String'];
};

export type CountryPhoneNumberEntity = {
  __typename?: 'CountryPhoneNumberEntity';
  countryCallingCode: Scalars['String'];
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  nationalNumber: Scalars['String'];
  numberValue: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CountryPhoneNumberInput = {
  countryCallingCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  nationalNumber?: InputMaybe<Scalars['String']>;
  numberValue?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CreateChartInput = {
  categoryId: Scalars['Int'];
  dataSourceId: Scalars['Int'];
  dataSourceId1?: InputMaybe<Scalars['Int']>;
  fullWidth: Scalars['Boolean'];
  meta?: InputMaybe<Scalars['JSONObject']>;
  plots: Array<Scalars['String']>;
  plots1?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  title1?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  type1?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
  xAxis: Scalars['String'];
  yAxis: Scalars['String'];
  yAxis1?: InputMaybe<Scalars['String']>;
};

export type CreateEmailInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['Float']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type CreateEventInput = {
  actions?: InputMaybe<Scalars['String']>;
  azureEventQueueScheduledMessageId?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Float']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  emailMessageContent?: InputMaybe<Scalars['JSONObject']>;
  end: Scalars['DateTime'];
  hostId?: InputMaybe<Scalars['Float']>;
  labels?: InputMaybe<Scalars['String']>;
  libraryConfigId?: InputMaybe<Scalars['Float']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  pushNotificationMessageContent?: InputMaybe<Scalars['JSONObject']>;
  rescheduleTimeInMinutes?: InputMaybe<Scalars['Float']>;
  resource?: InputMaybe<Scalars['String']>;
  schedulingStatus?: InputMaybe<EventSchedulingStatus>;
  shouldReschedule?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['DateTime'];
  status?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  studyIds: Array<Scalars['Float']>;
  textMessageContent?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  userIds: Array<Scalars['Float']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type CreateMessageInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  user: Scalars['Float'];
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type CreateNoteInput = {
  actions?: InputMaybe<Scalars['String']>;
  conferenceId?: InputMaybe<Scalars['Float']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  editorId?: InputMaybe<Scalars['Float']>;
  entity?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  libraryId?: InputMaybe<Scalars['Float']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Float']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type CreateNotificationInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  user: Scalars['Float'];
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type CreateStudyPermissionInput = {
  permissionId: Scalars['Float'];
  studyId: Scalars['Float'];
};

export type CreateStudyRoleInput = {
  id?: InputMaybe<Scalars['Float']>;
  roleId: Scalars['Float'];
  studyId: Scalars['Float'];
};

export type CreateSuggestedDateInput = {
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  startTime: Scalars['DateTime'];
};

export type CreateUserSubscriptionInput = {
  notificationPreference: Scalars['String'];
  userId: Scalars['Float'];
};

export type CreateVoiceInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  user: Scalars['Float'];
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type EmailDetailOutputType = {
  __typename?: 'EmailDetailOutputType';
  attachments?: Maybe<Array<Scalars['JSONObject']>>;
  content: Scalars['String'];
  emailDate: Scalars['DateTime'];
  emailId: Scalars['Int'];
  emailType?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  recipientId: Scalars['Int'];
  recipientName: Scalars['String'];
  recipientRole: Scalars['String'];
  senderId: Scalars['Int'];
  senderName: Scalars['String'];
  senderRole: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
};

export type EmailEntity = {
  __typename?: 'EmailEntity';
  actions?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  labels?: Maybe<Scalars['String']>;
  liked: Scalars['Boolean'];
  receiver?: Maybe<UserEntity>;
  receiverId?: Maybe<Scalars['Float']>;
  sender?: Maybe<UserEntity>;
  senderId?: Maybe<Scalars['Float']>;
  study?: Maybe<StudyEntity>;
  studyArm?: Maybe<StudyArmEntity>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  viewed: Scalars['Boolean'];
};

export type EmailsInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type EmailsOutput = {
  __typename?: 'EmailsOutput';
  count: Scalars['Int'];
  isGroupChat: Scalars['Boolean'];
  items: Array<EmailEntity>;
};

export type EventEntity = {
  __typename?: 'EventEntity';
  actions?: Maybe<Scalars['String']>;
  azureEventQueueScheduledMessageId?: Maybe<Scalars['String']>;
  confirmed: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailMessageContent?: Maybe<Scalars['String']>;
  end: Scalars['DateTime'];
  id: Scalars['Float'];
  labels?: Maybe<Scalars['String']>;
  libraryConfigId?: Maybe<Scalars['Float']>;
  liked: Scalars['Boolean'];
  pushNotificationMessageContent?: Maybe<Scalars['String']>;
  receiver?: Maybe<UserEntity>;
  rescheduleTimeInMinutes?: Maybe<Scalars['Float']>;
  resource?: Maybe<Scalars['String']>;
  schedulingStatus: Scalars['String'];
  sender?: Maybe<UserEntity>;
  shouldReschedule: Scalars['Boolean'];
  start: Scalars['DateTime'];
  startForIVR?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  study?: Maybe<StudyEntity>;
  studyArm?: Maybe<StudyArmEntity>;
  textMessageContent?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  viewed: Scalars['Boolean'];
};

export type EventMetricsInputType = {
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
};

export type EventMetricsOutputType = {
  __typename?: 'EventMetricsOutputType';
  completedCount: Scalars['Int'];
  completedCountMonth: Scalars['Int'];
  incompleteCount: Scalars['Int'];
  incompleteCountMonth: Scalars['Int'];
  missedCount: Scalars['Int'];
  missedCountMonth: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalCountMonth: Scalars['Int'];
};

export enum EventSchedulingStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type EventWithTimeWindow = {
  __typename?: 'EventWithTimeWindow';
  event: EventEntity;
  libraryConfig?: Maybe<StudyArmLibraryConfigsEntity>;
  windowEndTime: Scalars['DateTime'];
  windowStartTime: Scalars['DateTime'];
};

export type EventsInput = {
  actions?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Float']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Float']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  resource?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type EventsOutput = {
  __typename?: 'EventsOutput';
  count: Scalars['Int'];
  items: Array<EventEntity>;
};

export type ExportContentMetadataType = {
  __typename?: 'ExportContentMetadataType';
  dataTypesIncluded: Array<Scalars['String']>;
  dateRangeFrom: Scalars['String'];
  dateRangeTo: Scalars['String'];
  exportedAt: Scalars['String'];
  studyArmName: Scalars['String'];
  studyName: Scalars['String'];
  totalDataPoints: Scalars['Int'];
  totalParticipants: Scalars['Int'];
};

/** The types of data to include in the export. */
export enum ExportDataTypesEnum {
  ChatMessages = 'CHAT_MESSAGES',
  CoachingCalls = 'COACHING_CALLS',
  CommunicationCalls = 'COMMUNICATION_CALLS',
  Emails = 'EMAILS',
  Fitbit = 'FITBIT',
  IvrCalls = 'IVR_CALLS',
  Journals = 'JOURNALS'
}

export type ExportFileContentMetadataType = {
  __typename?: 'ExportFileContentMetadataType';
  contentType: Scalars['String'];
  dataTypeDisplay: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  exportRequestId: Scalars['Int'];
  fetchedAt: Scalars['String'];
  fileName: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
};

export type ExportFileContentResponseType = {
  __typename?: 'ExportFileContentResponseType';
  content: Scalars['JSON'];
  metadata: ExportFileContentMetadataType;
};

/** The specific content type of an exported file for type-safe access. */
export enum ExportFileContentType {
  ChatMessagesOnly = 'CHAT_MESSAGES_ONLY',
  CoachingCallsOnly = 'COACHING_CALLS_ONLY',
  CommunicationCallsOnly = 'COMMUNICATION_CALLS_ONLY',
  EmailsOnly = 'EMAILS_ONLY',
  FitbitDataOnly = 'FITBIT_DATA_ONLY',
  FullParticipantData = 'FULL_PARTICIPANT_DATA',
  IvrCallsOnly = 'IVR_CALLS_ONLY',
  JournalEntriesOnly = 'JOURNAL_ENTRIES_ONLY',
  SummaryMetrics = 'SUMMARY_METRICS'
}

export type ExportRequestOutputType = {
  __typename?: 'ExportRequestOutputType';
  completedAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  exportParameters: Scalars['JSONObject'];
  generatedFiles?: Maybe<Array<ExportedFileRecordType>>;
  id: Scalars['Int'];
  requestedAt: Scalars['DateTime'];
  requestedById: Scalars['Int'];
  status: ExportRequestStatus;
  studyId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

/** The status of a data export request. */
export enum ExportRequestStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type ExportStudyInput = {
  dataTypes: Array<ExportDataTypesEnum>;
  fromDate: Scalars['String'];
  participantIds: Array<Scalars['Int']>;
  studyArmId: Scalars['Int'];
  studyId: Scalars['Int'];
  toDate: Scalars['String'];
};

export type ExportedFileRecordType = {
  __typename?: 'ExportedFileRecordType';
  contentType: ExportFileContentType;
  dataTypeDisplay: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  expectedDataStructure?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  format: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type FamilyMemberEntity = {
  __typename?: 'FamilyMemberEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber?: Maybe<PhoneNumberEntity>;
  relationship: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FamilyMemberInputType = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<PhoneNumberInputType>;
  relationship?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FileEntity = {
  __typename?: 'FileEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  path?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

export type FilesInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  path?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilesOutput = {
  __typename?: 'FilesOutput';
  count: Scalars['Int'];
  items: Array<FileEntity>;
};

export type FitbitActivityEntity = {
  __typename?: 'FitbitActivityEntity';
  activityLevel?: Maybe<Array<ActivityLevel>>;
  averageHeartRate?: Maybe<Scalars['Float']>;
  calories?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Array<Scalars['JSONObject']>>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  distance?: Maybe<Scalars['Float']>;
  distanceUnit?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
  elivation?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pace?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  startTime: Scalars['String'];
  steps?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserEntity>;
  version: Scalars['String'];
};

export type FitbitActivityTrendData = {
  __typename?: 'FitbitActivityTrendData';
  dateTime: Scalars['String'];
  value: Scalars['Float'];
};

export type FitbitActivityTrendInputType = {
  date?: InputMaybe<Scalars['String']>;
  period: Scalars['String'];
  resource: Scalars['String'];
  userId: Scalars['Float'];
};

export type FitbitChartsData = {
  __typename?: 'FitbitChartsData';
  activity: Array<FitbitActivityEntity>;
  distance: Array<FitbitDistanceEntity>;
  heartRate: Array<FitbitHeartRateEntity>;
  sleep: Array<FitbitSleepEntity>;
  steps: Array<FitbitStepsEntity>;
};

export type FitbitDistanceEntity = {
  __typename?: 'FitbitDistanceEntity';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Array<Scalars['JSONObject']>>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserEntity>;
  value: Scalars['String'];
  version: Scalars['String'];
};

export type FitbitEntity = {
  __typename?: 'FitbitEntity';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSONObject']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  hash?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type FitbitHeartRateEntity = {
  __typename?: 'FitbitHeartRateEntity';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Array<Scalars['JSONObject']>>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  restingHeartRate: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserEntity>;
  version: Scalars['String'];
};

export type FitbitHistoryEntity = {
  __typename?: 'FitbitHistoryEntity';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  statusCode?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
};

export type FitbitLifetimeStats = {
  __typename?: 'FitbitLifetimeStats';
  label: Scalars['String'];
  metric: Scalars['String'];
};

export type FitbitSleepEntity = {
  __typename?: 'FitbitSleepEntity';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Array<Scalars['JSONObject']>>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration: Scalars['Float'];
  endTime: Scalars['String'];
  id: Scalars['ID'];
  startTime: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserEntity>;
  version: Scalars['String'];
};

export type FitbitStepsEntity = {
  __typename?: 'FitbitStepsEntity';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Array<Scalars['JSONObject']>>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserEntity>;
  value: Scalars['String'];
  version: Scalars['String'];
};

export type FitbitWeightEntity = {
  __typename?: 'FitbitWeightEntity';
  bmi: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  data?: Maybe<Array<Scalars['JSONObject']>>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fat: Scalars['Float'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserEntity>;
  version: Scalars['String'];
  weight: Scalars['Float'];
};

export type GraphDataPointsInput = {
  fromDate: Scalars['String'];
  questionsId: Array<Scalars['Float']>;
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};

export type GraphDataPointsOutput = {
  __typename?: 'GraphDataPointsOutput';
  items: Array<AssessmentAnswerEntity>;
};

export type InviteParticipantInputType = {
  age?: InputMaybe<Scalars['String']>;
  clinicId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  numbersForCalls?: InputMaybe<Array<CountryInputType>>;
  numbersForMessages?: InputMaybe<Array<CountryInputType>>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  sexualOrientation?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  studyArm?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type InviteStaffInputType = {
  email: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['Float'];
  studyArmIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type InviteStaffOutputType = {
  __typename?: 'InviteStaffOutputType';
  errors?: Maybe<Array<Scalars['String']>>;
  users: Array<UserEntity>;
};

export type IvrCallDetailOutputType = {
  __typename?: 'IvrCallDetailOutputType';
  callDate: Scalars['DateTime'];
  durationSeconds?: Maybe<Scalars['Int']>;
  ivrCallId: Scalars['Int'];
  libraryDetails?: Maybe<Scalars['JSONObject']>;
  questionsAndAnswers: Array<IvrQuestionAnswerOutputType>;
  status: Scalars['String'];
};

export type IvrQuestionAnswerOutputType = {
  __typename?: 'IvrQuestionAnswerOutputType';
  answerValue?: Maybe<Scalars['String']>;
  answeredAt: Scalars['DateTime'];
  questionDetails?: Maybe<Scalars['JSONObject']>;
  questionId: Scalars['Int'];
  questionText: Scalars['String'];
};

export type JournalEntryDetailOutputType = {
  __typename?: 'JournalEntryDetailOutputType';
  actions?: Maybe<Array<Scalars['JSONObject']>>;
  attachments?: Maybe<Array<Scalars['JSONObject']>>;
  authorId?: Maybe<Scalars['Int']>;
  authorName?: Maybe<Scalars['String']>;
  entryDate: Scalars['DateTime'];
  journalEntryId: Scalars['Int'];
  lastEditorId?: Maybe<Scalars['Int']>;
  lastEditorName?: Maybe<Scalars['String']>;
  libraryDetails?: Maybe<Scalars['JSONObject']>;
  questionsAndAnswers?: Maybe<Array<IvrQuestionAnswerOutputType>>;
  status?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  updatedAtDate?: Maybe<Scalars['DateTime']>;
};

export type LibraryEntity = {
  __typename?: 'LibraryEntity';
  assessmentResponses?: Maybe<Array<AssessmentResponseEntity>>;
  automations?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creator?: Maybe<UserEntity>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initialMessage?: Maybe<Scalars['String']>;
  libraryConfigs?: Maybe<Array<StudyArmLibraryConfigsEntity>>;
  preIVRDuration?: Maybe<Scalars['Float']>;
  preIVRDurationType?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<AssessmentQuestionEntity>>;
  studies?: Maybe<Array<StudyEntity>>;
  studyArms?: Maybe<Array<StudyArmEntity>>;
  subsets?: Maybe<Array<LibraryEntity>>;
  superset?: Maybe<LibraryEntity>;
  title: Scalars['String'];
  tooltip?: Maybe<TooltipEntity>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type LibraryOutputType = {
  __typename?: 'LibraryOutputType';
  count: Scalars['Int'];
  items: Array<LibraryEntity>;
  types: Array<Scalars['String']>;
};

export type LibraryWhereInputType = {
  id?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<Scalars['String']>>;
};

export type LimitInput = {
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};

export type ManageChartTabInputType = {
  create?: Array<ChartTabInputType>;
  delete?: Array<Scalars['Int']>;
  update?: Array<ChartTabInputType>;
};

export type ManageChartTabResponseType = {
  __typename?: 'ManageChartTabResponseType';
  success: Scalars['Boolean'];
};

export type MedicationEntity = {
  __typename?: 'MedicationEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  treatment: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type MedicationInputType = {
  description: Scalars['String'];
  label: Scalars['String'];
  treatment?: InputMaybe<Scalars['Boolean']>;
};

export type MedicationOutputType = {
  __typename?: 'MedicationOutputType';
  count: Scalars['Int'];
  items: Array<MedicationEntity>;
};

export type MedicationWhereInputType = {
  creatorId?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  label?: InputMaybe<Scalars['String']>;
  treatment?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['Float']>;
};

export type MemberInputType = {
  address?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['String']>;
  clinicId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fitbitAccessToken?: InputMaybe<Scalars['String']>;
  fitbitId?: InputMaybe<Scalars['String']>;
  fitbitRefreshToken?: InputMaybe<Scalars['String']>;
  fitbitScopes?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  idNumber?: InputMaybe<Scalars['String']>;
  isSubscribed?: InputMaybe<Scalars['Boolean']>;
  lastMessageAt?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationPreferenceType?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredTime?: InputMaybe<Scalars['String']>;
  privateNotes?: InputMaybe<Scalars['Boolean']>;
  sexualOrientation?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  studyArmsId?: InputMaybe<Array<Scalars['Float']>>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vonageName?: InputMaybe<Scalars['String']>;
  vonageUuid?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type MessageEntity = {
  __typename?: 'MessageEntity';
  actions?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  labels?: Maybe<Scalars['String']>;
  liked: Scalars['Boolean'];
  receiver?: Maybe<UserEntity>;
  receiverId?: Maybe<Scalars['Float']>;
  sender?: Maybe<UserEntity>;
  senderId?: Maybe<Scalars['Float']>;
  study?: Maybe<StudyEntity>;
  studyArm?: Maybe<StudyArmEntity>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  viewed: Scalars['Boolean'];
  vonageId?: Maybe<Scalars['String']>;
};

export type MessagesInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type MessagesOutput = {
  __typename?: 'MessagesOutput';
  count: Scalars['Int'];
  isGroupChat: Scalars['Boolean'];
  items: Array<MessageEntity>;
};

export type MetricsAdherence = {
  __typename?: 'MetricsAdherence';
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  receiver: UserEntity;
  startDate: Scalars['DateTime'];
  status?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type MetricsAdherenceOutput = {
  __typename?: 'MetricsAdherenceOutput';
  adherenceItems: Array<MetricsAdherence>;
  completedJournals?: Maybe<Scalars['Int']>;
  libraries?: Maybe<Array<LibraryEntity>>;
};

export type MetricsInputType = {
  fromUserId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  toUserId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type MetricsOutputType = {
  __typename?: 'MetricsOutputType';
  count: Scalars['Int'];
  enrolledCount: Scalars['Int'];
  increasedCountRate: Scalars['Float'];
  increasedDurationRate: Scalars['Float'];
  increasedEnrollRate: Scalars['Float'];
  totalDuration: Scalars['Float'];
};

export type MetricsUsersOutputType = {
  __typename?: 'MetricsUsersOutputType';
  participantCount: Scalars['Int'];
  participantCountMonth: Scalars['Int'];
};

export type ModuleInputType = {
  automations?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator?: InputMaybe<MemberInputType>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Float']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  initialMessage?: InputMaybe<Scalars['String']>;
  preIVRDuration?: InputMaybe<Scalars['Float']>;
  preIVRDurationType?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Array<AssessmentQuestionInputType>>;
  subsets?: InputMaybe<Array<ModuleInputType>>;
  superset?: InputMaybe<ModuleInputType>;
  title?: InputMaybe<Scalars['String']>;
  tooltip?: InputMaybe<TooltipInputType>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAssessmentAnswer?: Maybe<AssessmentResponseEntity>;
  addMedication?: Maybe<MedicationEntity>;
  addSymptom?: Maybe<SymptomEntity>;
  chartTab: ChartTabEntity;
  confirmEvent?: Maybe<EventEntity>;
  confirmProposedTimeForEvent?: Maybe<EventEntity>;
  createAssessmentQuestion?: Maybe<AssessmentQuestionEntity>;
  createAssessmentResponse?: Maybe<AssessmentResponseEntity>;
  createAssessmentResponseWithToken?: Maybe<AssessmentResponseEntity>;
  createChart?: Maybe<ChartEntity>;
  createChartTab: ChartTabEntity;
  createEmail?: Maybe<EmailEntity>;
  createEvent?: Maybe<Array<EventEntity>>;
  createFile?: Maybe<FileEntity>;
  createFiles?: Maybe<Array<FileEntity>>;
  createLibrary?: Maybe<LibraryEntity>;
  createLibrarySubset?: Maybe<LibraryEntity>;
  createMessage?: Maybe<MessageEntity>;
  createModule?: Maybe<LibraryEntity>;
  createNote?: Maybe<NoteEntity>;
  createNotification?: Maybe<NotificationEntity>;
  createPermission?: Maybe<PermissionEntity>;
  createRole?: Maybe<RoleEntity>;
  createStudy?: Maybe<StudyEntity>;
  createStudyPermission?: Maybe<StudyPermissionEntity>;
  createStudyRole?: Maybe<StudyRoleEntity>;
  createSuggestedDate: SuggestedDateEntity;
  createUser?: Maybe<UserEntity>;
  createUserSubscription?: Maybe<UserSubscriptionEntity>;
  createVoice?: Maybe<VoiceEntity>;
  deleteChart?: Maybe<ChartEntity>;
  deleteChartTab: ChartTabEntity;
  deleteEmail?: Maybe<EmailEntity>;
  deleteEvent?: Maybe<EventEntity>;
  deleteFile?: Maybe<FileEntity>;
  deleteLibrary?: Maybe<Scalars['String']>;
  deleteMessage?: Maybe<MessageEntity>;
  deleteNote?: Maybe<NoteEntity>;
  deleteNotification?: Maybe<NotificationEntity>;
  deletePermission?: Maybe<PermissionEntity>;
  deleteRole?: Maybe<Array<RoleEntity>>;
  deleteStudy?: Maybe<StudyEntity>;
  deleteStudyPermission?: Maybe<StudyPermissionEntity>;
  deleteStudyRole?: Maybe<StudyRoleEntity>;
  deleteUser?: Maybe<Array<UserEntity>>;
  deleteVoice?: Maybe<VoiceEntity>;
  inviteParticipant?: Maybe<UserEntity>;
  inviteStaff?: Maybe<InviteStaffOutputType>;
  likeAllEmails?: Maybe<Scalars['Float']>;
  likeAllEvents?: Maybe<Scalars['Float']>;
  likeAllMessages?: Maybe<Scalars['Float']>;
  likeAllNotes?: Maybe<Scalars['Float']>;
  likeAllNotifications?: Maybe<Scalars['Float']>;
  likeAllVoices?: Maybe<Scalars['Float']>;
  manageChartTabs: ManageChartTabResponseType;
  requestStudyExport: ExportRequestOutputType;
  resetPassword?: Maybe<Scalars['Boolean']>;
  sendInviteEmail?: Maybe<Scalars['Boolean']>;
  sendMMS?: Maybe<Array<MessageEntity>>;
  sendResetPasswordLink?: Maybe<Scalars['Boolean']>;
  sendSMS?: Maybe<MessageEntity>;
  sendVideoConferenceSMS?: Maybe<MessageEntity>;
  shortenString: Scalars['String'];
  startConference?: Maybe<ConferenceEntity>;
  stopVideoCall?: Maybe<ConferenceEntity>;
  testOutboundCall?: Maybe<Scalars['Boolean']>;
  unsubscribeUser?: Maybe<Scalars['Boolean']>;
  updateAssessmentAnswer?: Maybe<AssessmentResponseEntity>;
  updateAssessmentQuestion?: Maybe<AssessmentQuestionEntity>;
  updateAssessmentResponse?: Maybe<AssessmentResponseEntity>;
  updateChart?: Maybe<ChartEntity>;
  updateChartTab: ChartTabEntity;
  updateCoachingEventStatus?: Maybe<EventEntity>;
  updateConference: ConferenceEntity;
  updateEmail?: Maybe<EmailEntity>;
  updateEvent?: Maybe<EventEntity>;
  updateFile?: Maybe<FileEntity>;
  updateLibrary?: Maybe<LibraryEntity>;
  updateMessage?: Maybe<MessageEntity>;
  updateNote?: Maybe<NoteEntity>;
  updateNotification?: Maybe<NotificationEntity>;
  updateNotificationPreference?: Maybe<NotificationpPreferencesEntity>;
  updatePermission?: Maybe<PermissionEntity>;
  updateRole?: Maybe<RoleEntity>;
  updateStudy?: Maybe<StudyEntity>;
  updateStudyPermission?: Maybe<StudyPermissionEntity>;
  updateStudyRole?: Maybe<StudyRoleEntity>;
  updateUser?: Maybe<UserEntity>;
  updateUserPermissions?: Maybe<UserEntity>;
  updateUserProfileDetail?: Maybe<UserEntity>;
  updateUserProfileInfoDetails?: Maybe<UserEntity>;
  updateUserProfileInformation?: Maybe<UserEntity>;
  updateVoice?: Maybe<VoiceEntity>;
  uploadIcon?: Maybe<Scalars['String']>;
  validateDirectSignin?: Maybe<UserEntity>;
  verifyUser?: Maybe<UserEntity>;
  viewAllEmails?: Maybe<Scalars['Float']>;
  viewAllEvents?: Maybe<Scalars['Float']>;
  viewAllMessages?: Maybe<Scalars['Float']>;
  viewAllNotes?: Maybe<Scalars['Float']>;
  viewAllNotifications?: Maybe<Scalars['Float']>;
  viewAllVoices?: Maybe<Scalars['Float']>;
};


export type MutationAddAssessmentAnswerArgs = {
  id: Scalars['Float'];
  updateAssessmentAnswerInput: AssessmentAnswerInputType;
};


export type MutationAddMedicationArgs = {
  data: MedicationInputType;
  userId: Scalars['Float'];
};


export type MutationAddSymptomArgs = {
  data: SymptomInputType;
  userId: Scalars['Float'];
};


export type MutationChartTabArgs = {
  id: Scalars['ID'];
};


export type MutationConfirmEventArgs = {
  confirmEventInput: UpdateEventInput;
  id: Scalars['Float'];
};


export type MutationConfirmProposedTimeForEventArgs = {
  id: Scalars['Float'];
  updateEventInput: UpdateEventInput;
};


export type MutationCreateAssessmentQuestionArgs = {
  question: AssessmentQuestionInputType;
};


export type MutationCreateAssessmentResponseArgs = {
  assessmentResponse: AssessmentResponseInputType;
};


export type MutationCreateAssessmentResponseWithTokenArgs = {
  assessmentResponse: AssessmentResponseWithTokenInputType;
  token: Scalars['String'];
};


export type MutationCreateChartArgs = {
  payload: CreateChartInput;
};


export type MutationCreateChartTabArgs = {
  title: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationCreateEmailArgs = {
  createEmailInput: CreateEmailInput;
  files?: InputMaybe<Array<Scalars['Upload']>>;
};


export type MutationCreateEventArgs = {
  createEventInput: CreateEventInput;
};


export type MutationCreateFileArgs = {
  file: Scalars['Upload'];
};


export type MutationCreateFilesArgs = {
  files: Array<Scalars['Upload']>;
};


export type MutationCreateLibraryArgs = {
  automations?: InputMaybe<Array<InputMaybe<AutomationInputType>>>;
  duration?: InputMaybe<Scalars['Float']>;
  icon?: InputMaybe<Scalars['String']>;
  iconFile?: InputMaybe<Array<Scalars['Upload']>>;
  initialMessage?: InputMaybe<Scalars['String']>;
  preIVRDuration?: InputMaybe<Scalars['Float']>;
  preIVRDurationType?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Array<InputMaybe<AssessmentQuestionInputType>>>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationCreateLibrarySubsetArgs = {
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supersetId: Scalars['Float'];
  title: Scalars['String'];
};


export type MutationCreateMessageArgs = {
  createMessageInput: CreateMessageInput;
};


export type MutationCreateModuleArgs = {
  module: ModuleInputType;
};


export type MutationCreateNoteArgs = {
  createNoteInput: CreateNoteInput;
  files?: InputMaybe<Array<Scalars['Upload']>>;
};


export type MutationCreateNotificationArgs = {
  createNotificationInput: CreateNotificationInput;
};


export type MutationCreatePermissionArgs = {
  permission: PermissionInputType;
};


export type MutationCreateRoleArgs = {
  permissions?: InputMaybe<Array<PermissionPartialInputType>>;
  role: RoleInputType;
  userStudyList?: InputMaybe<Array<UserStudyInputType>>;
};


export type MutationCreateStudyArgs = {
  arms?: InputMaybe<Array<InputMaybe<StudyArmInputType>>>;
  moduleId?: InputMaybe<Scalars['String']>;
  staff?: InputMaybe<Array<InputMaybe<StudyStaffInputType>>>;
  study: StudyInputType;
};


export type MutationCreateStudyPermissionArgs = {
  createStudyPermissionInput: CreateStudyPermissionInput;
};


export type MutationCreateStudyRoleArgs = {
  createStudyRoleInput: CreateStudyRoleInput;
};


export type MutationCreateSuggestedDateArgs = {
  createSuggestedDateInput: CreateSuggestedDateInput;
};


export type MutationCreateUserArgs = {
  user: UserInputType;
};


export type MutationCreateUserSubscriptionArgs = {
  createUserSubscriptionInput: CreateUserSubscriptionInput;
};


export type MutationCreateVoiceArgs = {
  createVoiceInput: CreateVoiceInput;
};


export type MutationDeleteChartArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteChartTabArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEmailArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteLibraryArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteMessageArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['Float'];
};


export type MutationDeletePermissionArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteRoleArgs = {
  ids: Array<Scalars['Float']>;
};


export type MutationDeleteStudyArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteStudyPermissionArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteStudyRoleArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteUserArgs = {
  ids: Array<Scalars['Float']>;
};


export type MutationDeleteVoiceArgs = {
  id: Scalars['Float'];
};


export type MutationInviteParticipantArgs = {
  data: InviteParticipantInputType;
};


export type MutationInviteStaffArgs = {
  data: Array<InviteStaffInputType>;
  studyId?: InputMaybe<Scalars['Float']>;
};


export type MutationLikeAllEmailsArgs = {
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationLikeAllEventsArgs = {
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationLikeAllMessagesArgs = {
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationLikeAllNotificationsArgs = {
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationLikeAllVoicesArgs = {
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationManageChartTabsArgs = {
  data: ManageChartTabInputType;
  userId: Scalars['ID'];
};


export type MutationRequestStudyExportArgs = {
  input: ExportStudyInput;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSendInviteEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendMmsArgs = {
  files: Array<Scalars['Upload']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  text: Scalars['String'];
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationSendResetPasswordLinkArgs = {
  email: Scalars['String'];
};


export type MutationSendSmsArgs = {
  phoneNumber?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  text: Scalars['String'];
  user: Scalars['Float'];
};


export type MutationSendVideoConferenceSmsArgs = {
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  user: Scalars['Float'];
  vonageSessionId: Scalars['String'];
};


export type MutationShortenStringArgs = {
  originalString: Scalars['String'];
};


export type MutationStartConferenceArgs = {
  conversationUuid?: InputMaybe<Scalars['String']>;
  fromUserId?: InputMaybe<Scalars['Float']>;
  sessionId?: InputMaybe<Scalars['String']>;
  studyId?: InputMaybe<Scalars['Float']>;
  toUserId?: InputMaybe<Scalars['Float']>;
  type: Scalars['String'];
};


export type MutationStopVideoCallArgs = {
  sessionId: Scalars['String'];
};


export type MutationUnsubscribeUserArgs = {
  userId: Scalars['Float'];
};


export type MutationUpdateAssessmentAnswerArgs = {
  id: Scalars['Float'];
  updateAssessmentAnswerInput: AssessmentAnswerInputType;
};


export type MutationUpdateAssessmentQuestionArgs = {
  id: Scalars['Float'];
  question: AssessmentQuestionInputType;
};


export type MutationUpdateAssessmentResponseArgs = {
  assessmentResponse: AssessmentResponseInputType;
  id: Scalars['Float'];
};


export type MutationUpdateChartArgs = {
  id: Scalars['Float'];
  payload: UpdateChartInput;
};


export type MutationUpdateChartTabArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationUpdateCoachingEventStatusArgs = {
  date: Scalars['DateTime'];
  id: Scalars['Float'];
  status: Scalars['String'];
};


export type MutationUpdateConferenceArgs = {
  id: Scalars['Float'];
  updateConferenceInput: ConferenceInputType;
};


export type MutationUpdateEmailArgs = {
  id: Scalars['Float'];
  updateEmailInput: UpdateEmailInput;
};


export type MutationUpdateEventArgs = {
  id: Scalars['Float'];
  updateEventInput: UpdateEventInput;
};


export type MutationUpdateFileArgs = {
  id: Scalars['Float'];
  updateFileInput: UpdateFileInput;
};


export type MutationUpdateLibraryArgs = {
  automations?: InputMaybe<Array<InputMaybe<AutomationInputType>>>;
  duration?: InputMaybe<Scalars['Float']>;
  iconFile?: InputMaybe<Array<Scalars['Upload']>>;
  id: Scalars['Float'];
  initialMessage?: InputMaybe<Scalars['String']>;
  preIVRDuration?: InputMaybe<Scalars['Float']>;
  preIVRDurationType?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Array<InputMaybe<AssessmentQuestionInputType>>>;
  title: Scalars['String'];
};


export type MutationUpdateMessageArgs = {
  id: Scalars['Float'];
  updateMessageInput: UpdateMessageInput;
};


export type MutationUpdateNoteArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  id: Scalars['Float'];
  updateNoteInput: UpdateNoteInput;
};


export type MutationUpdateNotificationArgs = {
  id: Scalars['Float'];
  updateNotificationInput: UpdateNotificationInput;
};


export type MutationUpdateNotificationPreferenceArgs = {
  notificationPreference: Scalars['String'];
  userId: Scalars['Float'];
};


export type MutationUpdatePermissionArgs = {
  id: Scalars['Float'];
  permission: PermissionInputType;
};


export type MutationUpdateRoleArgs = {
  id: Scalars['Float'];
  permissions?: InputMaybe<Array<PermissionPartialInputType>>;
  role: RoleInputType;
  userStudyList?: InputMaybe<Array<UserStudyInputType>>;
};


export type MutationUpdateStudyArgs = {
  arms?: InputMaybe<Array<InputMaybe<StudyArmInputType>>>;
  id: Scalars['Float'];
  moduleId?: InputMaybe<Scalars['String']>;
  staff?: InputMaybe<Array<InputMaybe<StudyStaffInputType>>>;
  study: StudyInputType;
  updatedAtTimestamp: Scalars['DateTime'];
};


export type MutationUpdateStudyPermissionArgs = {
  id: Scalars['Float'];
  updateStudyPermissionInput: UpdateStudyPermissionInput;
};


export type MutationUpdateStudyRoleArgs = {
  id: Scalars['Float'];
  updateStudyRoleInput: UpdateStudyRoleInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['Float'];
  user: UserUpdateInputType;
};


export type MutationUpdateUserPermissionsArgs = {
  userId: Scalars['Float'];
  userPermissions: Array<UserPermissionInputType>;
};


export type MutationUpdateUserProfileDetailArgs = {
  data: UserProfileDetailInputType;
  id: Scalars['Float'];
};


export type MutationUpdateUserProfileInfoDetailsArgs = {
  data: UserProfileDetailsInputType;
  id: Scalars['Float'];
};


export type MutationUpdateUserProfileInformationArgs = {
  data: UserProfileInfoInputType;
  id: Scalars['Float'];
};


export type MutationUpdateVoiceArgs = {
  id: Scalars['Float'];
  updateVoiceInput: UpdateVoiceInput;
};


export type MutationUploadIconArgs = {
  iconFile?: InputMaybe<Array<Scalars['Upload']>>;
};


export type MutationValidateDirectSigninArgs = {
  token: Scalars['String'];
};


export type MutationVerifyUserArgs = {
  id: Scalars['Float'];
};


export type MutationViewAllEmailsArgs = {
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationViewAllEventsArgs = {
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationViewAllMessagesArgs = {
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationViewAllNotificationsArgs = {
  user?: InputMaybe<Scalars['Float']>;
};


export type MutationViewAllVoicesArgs = {
  user?: InputMaybe<Scalars['Float']>;
};

export type NoteEntity = {
  __typename?: 'NoteEntity';
  actions?: Maybe<Scalars['String']>;
  assessmentResponse?: Maybe<AssessmentResponseEntity>;
  conference?: Maybe<ConferenceEntity>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  editor?: Maybe<UserEntity>;
  entity?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  isPinned: Scalars['Boolean'];
  labels?: Maybe<Scalars['String']>;
  liked: Scalars['Boolean'];
  parentId?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserEntity;
  userId?: Maybe<Scalars['Float']>;
  viewed: Scalars['Boolean'];
};

export type NotesInput = {
  actions?: InputMaybe<Scalars['String']>;
  assessmentResponseId?: InputMaybe<Scalars['Float']>;
  conferenceId?: InputMaybe<Scalars['Float']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  editor?: InputMaybe<Scalars['Float']>;
  entity?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['Float']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type NotesOutput = {
  __typename?: 'NotesOutput';
  count: Scalars['Int'];
  items: Array<NoteEntity>;
};

export type NotificationEntity = {
  __typename?: 'NotificationEntity';
  actions?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  isSubscribed?: Maybe<Scalars['Boolean']>;
  labels?: Maybe<Scalars['String']>;
  liked: Scalars['Boolean'];
  study?: Maybe<StudyEntity>;
  studyArm?: Maybe<StudyArmEntity>;
  studyId?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  viewed: Scalars['Boolean'];
};

export type NotificationpPreferencesEntity = {
  __typename?: 'NotificationpPreferencesEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  subscription: UserSubscriptionEntity;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NotificationsInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  receiverId?: InputMaybe<Scalars['Float']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationsOutput = {
  __typename?: 'NotificationsOutput';
  count: Scalars['Int'];
  items: Array<NotificationEntity>;
};

export type OpentokAuthOutputType = {
  __typename?: 'OpentokAuthOutputType';
  apiKey?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type ParticipantExportDataOutputType = {
  __typename?: 'ParticipantExportDataOutputType';
  avgActiveMinutes?: Maybe<Scalars['Float']>;
  avgSteps?: Maybe<Scalars['Float']>;
  chatMessages: Array<ChatMessageDetailOutputType>;
  coachingCalls: Array<CoachingCallDetailOutputType>;
  communicationCalls: Array<CommunicationCallDetailOutputType>;
  dateAddedToArm: Scalars['DateTime'];
  emails: Array<EmailDetailOutputType>;
  fitbitData?: Maybe<Array<Scalars['JSONObject']>>;
  hoursOfCall?: Maybe<Scalars['Float']>;
  isFitbitSyncedInPeriod?: Maybe<Scalars['Boolean']>;
  ivrCalls: Array<IvrCallDetailOutputType>;
  journalEntries: Array<JournalEntryDetailOutputType>;
  numberOfEmails?: Maybe<Scalars['Int']>;
  numberOfMessages?: Maybe<Scalars['Int']>;
  participantExternalId?: Maybe<Scalars['String']>;
  participantId: Scalars['Int'];
  participantName: Scalars['String'];
  studyArmId: Scalars['Int'];
  studyArmName: Scalars['String'];
  studyId: Scalars['Int'];
  studyName: Scalars['String'];
};

export type PermissionEntity = {
  __typename?: 'PermissionEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PermissionInputType = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type PermissionOutputType = {
  __typename?: 'PermissionOutputType';
  count: Scalars['Int'];
  items: Array<PermissionEntity>;
};

export type PermissionPartialInputType = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  name?: InputMaybe<Scalars['String']>;
};

export type PermissionWhereType = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PhoneNumberEntity = {
  __typename?: 'PhoneNumberEntity';
  country?: Maybe<CountryPhoneNumberEntity>;
  countryId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isPreferred: Scalars['Boolean'];
  label: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PhoneNumberInputType = {
  country?: InputMaybe<CountryPhoneNumberInput>;
  countryId?: InputMaybe<Scalars['ID']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  isPreferred?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type Query = {
  __typename?: 'Query';
  adherenceMetrics: MetricsAdherenceOutput;
  allJournals: LibraryOutputType;
  archiveSession?: Maybe<ArchiveOutput>;
  assessmentAnsweredResponse: Array<AssessmentsAnsweredResponseOutputType>;
  assessmentAnsweredResponses: Array<AssessmentsAnsweredResponseOutputType>;
  assessmentQuestion?: Maybe<AssessmentQuestionEntity>;
  assessmentQuestions: AssessmentQuestionOutputType;
  assessmentResponse?: Maybe<AssessmentResponseEntity>;
  assessmentResponses: AssessmentResponseOutputType;
  audit?: Maybe<AuditEntity>;
  audits: AuditOutput;
  callConferences: ConferenceWithUsersOutputType;
  canDeleteLibrary?: Maybe<CanDeleteLibraryOutputType>;
  chartTabs: Array<ChartTabOutputType>;
  clinicIds: Array<Scalars['String']>;
  coachingAssessmentForNotes: CoachingAssessmentForNotesOutput;
  coachingEvents: Array<CoachingEvents>;
  conference?: Maybe<ConferenceEntity>;
  conferences: ConferenceOutputType;
  countEmails: Scalars['Float'];
  countEvents: Scalars['Float'];
  countFiles: Scalars['Float'];
  countMessages: Scalars['Float'];
  countNotes: Scalars['Float'];
  countNotifications: Scalars['Float'];
  countVoices: Scalars['Float'];
  dailyAssessments: LibraryOutputType;
  dailyJournals: LibraryOutputType;
  email?: Maybe<EmailEntity>;
  emails: EmailsOutput;
  event?: Maybe<EventEntity>;
  events: EventsOutput;
  exportMessages: Scalars['Boolean'];
  fetchOriginalString: StringShortenOutputType;
  file?: Maybe<FileEntity>;
  files: FilesOutput;
  fitbitActivities: FitbitEntity;
  fitbitActivitiesList: Array<FitbitActivityEntity>;
  fitbitActivitiesTrend: Array<FitbitActivityTrendData>;
  fitbitChartsData: FitbitChartsData;
  fitbitDistanceList: Array<FitbitDistanceEntity>;
  fitbitHeartRateList: Array<FitbitHeartRateEntity>;
  fitbitHistory: Array<FitbitHistoryEntity>;
  fitbitHistoryByUser: Array<FitbitHistoryEntity>;
  fitbitLifetimeStats: Array<FitbitLifetimeStats>;
  fitbitSleepList: Array<FitbitSleepEntity>;
  fitbitStepsList: Array<FitbitStepsEntity>;
  fitbitWeightList: Array<FitbitWeightEntity>;
  getCharts?: Maybe<Array<ChartEntity>>;
  getExportFileContent: ExportFileContentResponseType;
  getExportRequestDetails: ExportRequestOutputType;
  getProfileEvents: Array<EventWithTimeWindow>;
  getScheduledEvents: Array<EventWithTimeWindow>;
  graphDataPoints: GraphDataPointsOutput;
  hello: Scalars['String'];
  libraries: LibraryOutputType;
  library?: Maybe<LibraryEntity>;
  libraryWithToken?: Maybe<LibraryEntity>;
  medication?: Maybe<MedicationEntity>;
  medications: MedicationOutputType;
  message?: Maybe<MessageEntity>;
  messages: MessagesOutput;
  metricsConferences: MetricsOutputType;
  metricsEvents: EventMetricsOutputType;
  metricsUsers: MetricsUsersOutputType;
  myExportRequests: Array<ExportRequestOutputType>;
  note?: Maybe<NoteEntity>;
  notes: NotesOutput;
  notification?: Maybe<NotificationEntity>;
  notifications: NotificationsOutput;
  opentokAuth: OpentokAuthOutputType;
  participantCoachingLibrariesForDate: LibraryOutputType;
  permission?: Maybe<PermissionEntity>;
  permissions: PermissionOutputType;
  questionCategories: QuestionCategoryOutputType;
  questionCategory?: Maybe<QuestionCategoryEntity>;
  role?: Maybe<RoleEntity>;
  roles: RolesOutputType;
  searchAutomationWho: Array<AutomationWhoOutputType>;
  searchRoles: Array<RoleEntity>;
  studies: StudyOutputType;
  studiesWithStudyArms: StudyOutputType;
  study?: Maybe<StudyEntity>;
  studyArm?: Maybe<StudyArmEntity>;
  studyArmLibraryConfigs?: Maybe<StudyArmLibraryConfigsEntity>;
  studyArms: StudyArmOutputType;
  studyArmsByStaff: Array<StudyArmEntity>;
  studyPermission?: Maybe<StudyPermissionEntity>;
  studyPermissions: StudyPermissionsOutput;
  studyRole?: Maybe<StudyRoleEntity>;
  studyRoles: StudyRoleOutput;
  suggestedDate?: Maybe<SuggestedDateEntity>;
  symptom?: Maybe<SymptomEntity>;
  symptoms: SymptomOutputType;
  syncFitbitData: Scalars['Boolean'];
  tooltip?: Maybe<TooltipEntity>;
  tooltips: TooltipOutputType;
  translate?: Maybe<TranslateOutputType>;
  user?: Maybe<UserEntity>;
  userConferences: UserConferencesOutputType;
  userLogin: UserLoginOutputType;
  userProfileGeneralDetails?: Maybe<UserProfileDetailType>;
  userProfileInfoDetails?: Maybe<UserInfoDetailsOutputType>;
  userProfileInformation?: Maybe<UserEntity>;
  userRegistration: UserEntity;
  userVerified: UserVerifiedInputType;
  users: UsersOutputType;
  usersEmails: UsersOutputType;
  usersEvents: UsersOutputType;
  usersMessages: UsersOutputType;
  usersVoices: UsersOutputType;
  voice?: Maybe<VoiceEntity>;
  voices: VoicesOutput;
  vonageAuth: AuthOutputType;
};


export type QueryAdherenceMetricsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  studyArmsId?: InputMaybe<Scalars['Float']>;
  toDate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Float']>;
};


export type QueryAllJournalsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<LibraryWhereInputType>;
};


export type QueryArchiveSessionArgs = {
  sessionId: Scalars['String'];
  value: Scalars['Boolean'];
};


export type QueryAssessmentAnsweredResponseArgs = {
  endDate: Scalars['DateTime'];
  libraryId: Scalars['Float'];
  startDate: Scalars['DateTime'];
  userId: Scalars['Float'];
};


export type QueryAssessmentAnsweredResponsesArgs = {
  endDate: Scalars['DateTime'];
  libraryIds: Array<Scalars['Float']>;
  startDate: Scalars['DateTime'];
  userId: Scalars['Float'];
};


export type QueryAssessmentQuestionArgs = {
  id: Scalars['Float'];
};


export type QueryAssessmentQuestionsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<AssessmentQuestionWhereInputType>;
};


export type QueryAssessmentResponseArgs = {
  id: Scalars['Float'];
};


export type QueryAssessmentResponsesArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<AssessmentResponsesWhereInputType>;
};


export type QueryAuditArgs = {
  id: Scalars['Float'];
};


export type QueryAuditsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<AuditInput>;
};


export type QueryCallConferencesArgs = {
  correspondingUser?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyId?: InputMaybe<Scalars['Float']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<ConferenceWhereInputType>;
};


export type QueryCanDeleteLibraryArgs = {
  id: Scalars['Float'];
};


export type QueryChartTabsArgs = {
  chartCount?: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type QueryCoachingAssessmentForNotesArgs = {
  userId: Scalars['ID'];
};


export type QueryCoachingEventsArgs = {
  userId: Scalars['Float'];
};


export type QueryConferenceArgs = {
  id: Scalars['Float'];
};


export type QueryConferencesArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<ConferenceWhereInputType>;
};


export type QueryCountEmailsArgs = {
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<EmailsInput>;
};


export type QueryCountEventsArgs = {
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<EventsInput>;
};


export type QueryCountFilesArgs = {
  where?: InputMaybe<FilesInput>;
};


export type QueryCountMessagesArgs = {
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<MessagesInput>;
};


export type QueryCountNotesArgs = {
  where?: InputMaybe<NotesInput>;
};


export type QueryCountNotificationsArgs = {
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<NotificationsInput>;
};


export type QueryCountVoicesArgs = {
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<VoicesInput>;
};


export type QueryEmailArgs = {
  id: Scalars['Float'];
};


export type QueryEmailsArgs = {
  correspondingUser?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<EmailsInput>;
};


export type QueryEventArgs = {
  id: Scalars['Float'];
};


export type QueryEventsArgs = {
  correspondingUser?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<EventsInput>;
};


export type QueryFetchOriginalStringArgs = {
  token: Scalars['String'];
};


export type QueryFileArgs = {
  id: Scalars['Float'];
};


export type QueryFilesArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<FilesInput>;
};


export type QueryFitbitActivitiesArgs = {
  date: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryFitbitActivitiesListArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryFitbitActivitiesTrendArgs = {
  parameters: FitbitActivityTrendInputType;
};


export type QueryFitbitChartsDataArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryFitbitDistanceListArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryFitbitHeartRateListArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryFitbitHistoryArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
};


export type QueryFitbitHistoryByUserArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryFitbitLifetimeStatsArgs = {
  userId: Scalars['Float'];
};


export type QueryFitbitSleepListArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryFitbitStepsListArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryFitbitWeightListArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryGetChartsArgs = {
  categoryId: Scalars['Float'];
  userId: Scalars['Float'];
};


export type QueryGetExportFileContentArgs = {
  exportRequestId: Scalars['Int'];
  fileName: Scalars['String'];
};


export type QueryGetExportRequestDetailsArgs = {
  id: Scalars['Int'];
};


export type QueryGetProfileEventsArgs = {
  limit?: InputMaybe<LimitInput>;
  studyId?: InputMaybe<Scalars['Float']>;
  user: Scalars['Float'];
  where?: InputMaybe<EventsInput>;
};


export type QueryGetScheduledEventsArgs = {
  studyArmsIds: Array<Scalars['Float']>;
};


export type QueryGraphDataPointsArgs = {
  payload: GraphDataPointsInput;
};


export type QueryHelloArgs = {
  name: Scalars['String'];
};


export type QueryLibrariesArgs = {
  limit?: InputMaybe<LimitInput>;
  showOnlyQuestions?: InputMaybe<Scalars['Boolean']>;
  studyId?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<LibraryWhereInputType>;
};


export type QueryLibraryArgs = {
  id: Scalars['Float'];
};


export type QueryLibraryWithTokenArgs = {
  token: Scalars['String'];
};


export type QueryMedicationArgs = {
  id: Scalars['Float'];
};


export type QueryMedicationsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<MedicationWhereInputType>;
};


export type QueryMessageArgs = {
  id: Scalars['Float'];
};


export type QueryMessagesArgs = {
  correspondingUser?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<MessagesInput>;
};


export type QueryMetricsConferencesArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<MetricsInputType>;
};


export type QueryMetricsEventsArgs = {
  where?: InputMaybe<EventMetricsInputType>;
};


export type QueryMetricsUsersArgs = {
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
};


export type QueryNoteArgs = {
  conferenceId?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['Float']>;
};


export type QueryNotesArgs = {
  editor?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<LimitInput>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<NotesInput>;
};


export type QueryNotificationArgs = {
  id: Scalars['Float'];
};


export type QueryNotificationsArgs = {
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<NotificationsInput>;
};


export type QueryOpentokAuthArgs = {
  joinSessionId?: InputMaybe<Scalars['String']>;
};


export type QueryParticipantCoachingLibrariesForDateArgs = {
  date: Scalars['String'];
  limit?: InputMaybe<LimitInput>;
  studyId?: InputMaybe<Scalars['Float']>;
  userId: Scalars['Float'];
  where?: InputMaybe<LibraryWhereInputType>;
};


export type QueryPermissionArgs = {
  id: Scalars['Float'];
};


export type QueryPermissionsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<PermissionWhereType>;
};


export type QueryQuestionCategoriesArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<QuestionCategoryWhereInputType>;
};


export type QueryQuestionCategoryArgs = {
  id: Scalars['Float'];
};


export type QueryRoleArgs = {
  id: Scalars['Float'];
};


export type QueryRolesArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<RoleWhereInputType>;
};


export type QuerySearchAutomationWhoArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchRolesArgs = {
  name?: InputMaybe<Scalars['String']>;
  staff?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStudiesArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<StudyWhereInputType>;
};


export type QueryStudiesWithStudyArmsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<StudyWhereInputType>;
};


export type QueryStudyArgs = {
  id: Scalars['Float'];
  showCoachesStudyArms?: InputMaybe<Scalars['Boolean']>;
  showLibraryConfigs?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStudyArmArgs = {
  id: Scalars['Float'];
};


export type QueryStudyArmLibraryConfigsArgs = {
  id: Scalars['Float'];
};


export type QueryStudyArmsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<StudyArmWhereInputType>;
};


export type QueryStudyArmsByStaffArgs = {
  studyId: Scalars['Float'];
  userId: Scalars['Float'];
};


export type QueryStudyPermissionArgs = {
  id: Scalars['Float'];
};


export type QueryStudyPermissionsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<StudyPermissionWhereInput>;
};


export type QueryStudyRoleArgs = {
  id: Scalars['Float'];
};


export type QueryStudyRolesArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<StudyRoleWhereInput>;
};


export type QuerySuggestedDateArgs = {
  where?: InputMaybe<SuggestedDateWhereInputType>;
};


export type QuerySymptomArgs = {
  id: Scalars['Float'];
};


export type QuerySymptomsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<SymptomWhereInputType>;
};


export type QuerySyncFitbitDataArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['Float'];
};


export type QueryTooltipArgs = {
  id: Scalars['Float'];
};


export type QueryTooltipsArgs = {
  limit?: InputMaybe<LimitInput>;
  where?: InputMaybe<TooltipWhereInputType>;
};


export type QueryTranslateArgs = {
  languageCode: Scalars['String'];
  texts: Array<Scalars['String']>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
};


export type QueryUserConferencesArgs = {
  limit?: InputMaybe<LimitInput>;
  studyId?: InputMaybe<Scalars['Float']>;
};


export type QueryUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type QueryUserProfileGeneralDetailsArgs = {
  id: Scalars['Float'];
};


export type QueryUserProfileInfoDetailsArgs = {
  id: Scalars['Float'];
  studyId?: InputMaybe<Scalars['Float']>;
};


export type QueryUserProfileInformationArgs = {
  id: Scalars['Float'];
};


export type QueryUserRegistrationArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
};


export type QueryUserVerifiedArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  filterAssigned?: InputMaybe<Scalars['Boolean']>;
  filterParticipants?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  sortByLatestMessages?: InputMaybe<Scalars['Boolean']>;
  staff?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  studyId?: InputMaybe<Scalars['Float']>;
};


export type QueryUsersEmailsArgs = {
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryUsersEventsArgs = {
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryUsersMessagesArgs = {
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryUsersVoicesArgs = {
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryVoiceArgs = {
  id: Scalars['Float'];
};


export type QueryVoicesArgs = {
  correspondingUser?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<LimitInput>;
  search?: InputMaybe<Scalars['String']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  user?: InputMaybe<Scalars['Float']>;
  where?: InputMaybe<VoicesInput>;
};


export type QueryVonageAuthArgs = {
  userId: Scalars['Float'];
};

export type QuestionCategoryEntity = {
  __typename?: 'QuestionCategoryEntity';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  questions?: Maybe<Array<AssessmentQuestionEntity>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type QuestionCategoryInputType = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type QuestionCategoryOutputType = {
  __typename?: 'QuestionCategoryOutputType';
  count: Scalars['Int'];
  items: Array<QuestionCategoryEntity>;
};

export type QuestionCategoryWhereInputType = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

export type RecordingEntity = {
  __typename?: 'RecordingEntity';
  archiveId: Scalars['String'];
  conversationUuid: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  recordingUrl: Scalars['String'];
  recordingUuid: Scalars['String'];
  sessionId: Scalars['String'];
  size: Scalars['String'];
  startTime: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type RoleAutoCompleteInputType = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RoleEntity = {
  __typename?: 'RoleEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions?: Maybe<Array<PermissionEntity>>;
  updatedAt: Scalars['DateTime'];
};

export type RoleInputType = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type RoleWhereInputType = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

export type RolesOutputType = {
  __typename?: 'RolesOutputType';
  count: Scalars['Int'];
  items: Array<RoleEntity>;
};

export type StaffEntity = {
  __typename?: 'StaffEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  role: RoleEntity;
  updatedAt: Scalars['DateTime'];
  user: UserEntity;
};

export type Stream = {
  __typename?: 'Stream';
  hasAudio: Scalars['Boolean'];
  hasVideo: Scalars['Boolean'];
  streamId: Scalars['String'];
};

export type StringShortenOutputType = {
  __typename?: 'StringShortenOutputType';
  originalString: Scalars['String'];
  token: Scalars['String'];
};

export type StudyArmEntity = {
  __typename?: 'StudyArmEntity';
  coaches?: Maybe<Array<UserEntity>>;
  communications?: Maybe<Scalars['JSONObject']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  libraryConfigs?: Maybe<Array<StudyArmLibraryConfigsEntity>>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  users?: Maybe<Array<UserEntity>>;
};

export type StudyArmInputType = {
  communications?: InputMaybe<Array<Scalars['JSONObject']>>;
  libraryConfigs?: InputMaybe<Array<StudyArmLibraryConfigsInputType>>;
  name: Scalars['String'];
  studyArmId: Scalars['String'];
  userIds: Array<Scalars['Float']>;
};

export type StudyArmLibraryConfigsEntity = {
  __typename?: 'StudyArmLibraryConfigsEntity';
  afterStart?: Maybe<Scalars['Float']>;
  beforeStart?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration: Scalars['Float'];
  id: Scalars['ID'];
  library: LibraryEntity;
  offset: Scalars['Float'];
  order?: Maybe<Scalars['Float']>;
  repeat?: Maybe<Scalars['Float']>;
  repeatText?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type StudyArmLibraryConfigsInputType = {
  afterStart?: InputMaybe<Scalars['Float']>;
  beforeStart?: InputMaybe<Scalars['Float']>;
  duration: Scalars['Float'];
  id?: InputMaybe<Scalars['Float']>;
  libraryId: Scalars['Float'];
  offset: Scalars['Float'];
  order?: InputMaybe<Scalars['Float']>;
  repeat?: InputMaybe<Scalars['Float']>;
  repeatText?: InputMaybe<Scalars['String']>;
  time: Scalars['String'];
};

export type StudyArmOutputType = {
  __typename?: 'StudyArmOutputType';
  count: Scalars['Int'];
  items: Array<StudyArmEntity>;
};

export type StudyArmWhereInputType = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

export type StudyEntity = {
  __typename?: 'StudyEntity';
  createdAt: Scalars['DateTime'];
  creator?: Maybe<UserEntity>;
  creatorId?: Maybe<Scalars['Float']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  id: Scalars['Float'];
  irb: Scalars['String'];
  moduleId?: Maybe<Scalars['String']>;
  modules?: Maybe<Array<LibraryEntity>>;
  name: Scalars['String'];
  staff?: Maybe<Array<UserEntity>>;
  studyArms?: Maybe<Array<StudyArmEntity>>;
  updatedAt: Scalars['DateTime'];
};

export type StudyInputType = {
  displayName: Scalars['String'];
  irb: Scalars['String'];
  name: Scalars['String'];
};

export type StudyOutputType = {
  __typename?: 'StudyOutputType';
  count: Scalars['Int'];
  items: Array<StudyEntity>;
};

export type StudyPermissionEntity = {
  __typename?: 'StudyPermissionEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  permission: PermissionEntity;
  permissionId: Scalars['ID'];
  study: StudyEntity;
  studyId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type StudyPermissionWhereInput = {
  id?: InputMaybe<Scalars['Float']>;
  permissionId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
};

export type StudyPermissionsOutput = {
  __typename?: 'StudyPermissionsOutput';
  count: Scalars['Int'];
  items: Array<StudyPermissionEntity>;
};

export type StudyRoleEntity = {
  __typename?: 'StudyRoleEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  role: RoleEntity;
  study: StudyEntity;
  updatedAt: Scalars['DateTime'];
};

export type StudyRoleOutput = {
  __typename?: 'StudyRoleOutput';
  count: Scalars['Int'];
  items: Array<StudyRoleEntity>;
};

export type StudyRoleWhereInput = {
  id?: InputMaybe<Scalars['Float']>;
};

export type StudyStaffInputType = {
  roleId: Scalars['Float'];
  studyArmsIds?: InputMaybe<Array<Scalars['Float']>>;
  userId: Scalars['Float'];
};

export type StudyWhereInputType = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SuggestedDateEntity = {
  __typename?: 'SuggestedDateEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventEntity;
  id: Scalars['Float'];
  startTime: Scalars['DateTime'];
  suggester: UserEntity;
  updatedAt: Scalars['DateTime'];
};

export type SuggestedDateWhereInputType = {
  eventId?: InputMaybe<Scalars['Float']>;
};

export type SymptomEntity = {
  __typename?: 'SymptomEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  frequency?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type SymptomInputType = {
  description: Scalars['String'];
  frequency?: InputMaybe<Scalars['Float']>;
  label: Scalars['String'];
};

export type SymptomOutputType = {
  __typename?: 'SymptomOutputType';
  count: Scalars['Int'];
  items: Array<SymptomEntity>;
};

export type SymptomWhereInputType = {
  creatorId?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Float']>;
  label?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Float']>;
};

export type TooltipEntity = {
  __typename?: 'TooltipEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TooltipInputType = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TooltipOutputType = {
  __typename?: 'TooltipOutputType';
  count: Scalars['Int'];
  items: Array<TooltipEntity>;
};

export type TooltipWhereInputType = {
  id?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type TranslateOutputType = {
  __typename?: 'TranslateOutputType';
  texts: Array<Scalars['String']>;
};

export type TreatmentEntity = {
  __typename?: 'TreatmentEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  disease: Scalars['String'];
  id: Scalars['ID'];
  treatmentType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TreatmentInputType = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  disease?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  treatmentType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TypedExportFileContentType = {
  __typename?: 'TypedExportFileContentType';
  exportMetadata: ExportContentMetadataType;
  participants: Array<ParticipantExportDataOutputType>;
};

export type TypedExportedFileRecordType = {
  __typename?: 'TypedExportedFileRecordType';
  contentType: Scalars['String'];
  dataTypeDisplay: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  expectedDataStructure: Scalars['String'];
  fileName: Scalars['String'];
  format: Scalars['String'];
  schemaVersion?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type UpdateChartInput = {
  categoryId?: InputMaybe<Scalars['Int']>;
  dataSourceId?: InputMaybe<Scalars['Int']>;
  dataSourceId1?: InputMaybe<Scalars['Int']>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<Scalars['JSONObject']>;
  plots?: InputMaybe<Array<Scalars['String']>>;
  plots1?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  title1?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type1?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  xAxis?: InputMaybe<Scalars['String']>;
  yAxis?: InputMaybe<Scalars['String']>;
  yAxis1?: InputMaybe<Scalars['String']>;
};

export type UpdateEmailInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEventInput = {
  actions?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Float']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  resource?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateFileInput = {
  description?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateMessageInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateNoteInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  editorId?: InputMaybe<Scalars['Float']>;
  entity?: InputMaybe<Scalars['String']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['Float']>;
  privateNotes?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Float']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateNotificationInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateStudyPermissionInput = {
  permissionId: Scalars['Float'];
  studyId: Scalars['Float'];
};

export type UpdateStudyRoleInput = {
  id?: InputMaybe<Scalars['Float']>;
  roleId: Scalars['Float'];
  studyId: Scalars['Float'];
};

export type UpdateVoiceInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type UserConferencesOutputType = {
  __typename?: 'UserConferencesOutputType';
  count: Scalars['Int'];
  items: Array<UserEntity>;
};

export type UserEntity = {
  __typename?: 'UserEntity';
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  assignedStaff?: Maybe<StaffEntity>;
  clinicId?: Maybe<Scalars['String']>;
  clinics?: Maybe<Array<ClinicEntity>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  familyMembers?: Maybe<Array<FamilyMemberEntity>>;
  fitbitAccessToken?: Maybe<Scalars['String']>;
  fitbitId?: Maybe<Scalars['String']>;
  fitbitRefreshToken?: Maybe<Scalars['String']>;
  fitbitScopes?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idNumber?: Maybe<Scalars['String']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notes?: Maybe<Array<NoteEntity>>;
  notificationPreferenceType?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<StudyPermissionEntity>>;
  phoneNumbers?: Maybe<Array<PhoneNumberEntity>>;
  preferredLanguage?: Maybe<Scalars['String']>;
  preferredTime?: Maybe<Scalars['String']>;
  primaryRole?: Maybe<RoleEntity>;
  privateNotes?: Maybe<Scalars['Boolean']>;
  receiverEmails?: Maybe<Array<EmailEntity>>;
  receiverMessages?: Maybe<Array<MessageEntity>>;
  receiverNotifications?: Maybe<Array<NotificationEntity>>;
  receiverVoices?: Maybe<Array<VoiceEntity>>;
  roles?: Maybe<Array<StudyRoleEntity>>;
  senderEmails?: Maybe<Array<EmailEntity>>;
  senderMessages?: Maybe<Array<MessageEntity>>;
  senderNotifications?: Maybe<Array<NotificationEntity>>;
  senderVoices?: Maybe<Array<VoiceEntity>>;
  sexualOrientation?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  studies?: Maybe<Array<StudyEntity>>;
  studyArmsId?: Maybe<Array<Scalars['Float']>>;
  timezone?: Maybe<Scalars['String']>;
  treatments?: Maybe<Array<TreatmentEntity>>;
  updatedAt: Scalars['DateTime'];
  vonageName?: Maybe<Scalars['String']>;
  vonageUuid?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type UserInfoDetailsOutputType = {
  __typename?: 'UserInfoDetailsOutputType';
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  assignedStaff?: Maybe<StaffEntity>;
  clinicId?: Maybe<Scalars['String']>;
  clinics?: Maybe<Array<ClinicEntity>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyMembers?: Maybe<Array<FamilyMemberEntity>>;
  fitbitAccessToken?: Maybe<Scalars['String']>;
  fitbitId?: Maybe<Scalars['String']>;
  fitbitRefreshToken?: Maybe<Scalars['String']>;
  fitbitScopes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  idNumber?: Maybe<Scalars['String']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<NoteEntity>>;
  notificationPreferenceType?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<StudyPermissionEntity>>;
  phoneNumbers?: Maybe<Array<PhoneNumberEntity>>;
  preferredLanguage?: Maybe<Scalars['String']>;
  preferredTime?: Maybe<Scalars['String']>;
  primaryRole?: Maybe<RoleEntity>;
  privateNotes?: Maybe<Scalars['Boolean']>;
  receiverEmails?: Maybe<Array<EmailEntity>>;
  receiverMessages?: Maybe<Array<MessageEntity>>;
  receiverNotifications?: Maybe<Array<NotificationEntity>>;
  receiverVoices?: Maybe<Array<VoiceEntity>>;
  roles?: Maybe<Array<StudyRoleEntity>>;
  senderEmails?: Maybe<Array<EmailEntity>>;
  senderMessages?: Maybe<Array<MessageEntity>>;
  senderNotifications?: Maybe<Array<NotificationEntity>>;
  senderVoices?: Maybe<Array<VoiceEntity>>;
  sexualOrientation?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  studies?: Maybe<Array<StudyEntity>>;
  studyArm?: Maybe<Scalars['String']>;
  studyArmsId?: Maybe<Array<Scalars['Float']>>;
  timezone?: Maybe<Scalars['String']>;
  treatments?: Maybe<Array<TreatmentEntity>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vonageName?: Maybe<Scalars['String']>;
  vonageUuid?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type UserInputType = {
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  roleId: Scalars['Float'];
  status: Scalars['String'];
};

export type UserLoginOutputType = {
  __typename?: 'UserLoginOutputType';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserEntity>;
};

export type UserPermissionInputType = {
  permissions: Array<Scalars['Int']>;
  roleId: Scalars['Float'];
  studyArmIds?: InputMaybe<Array<Scalars['Int']>>;
  studyId: Scalars['Float'];
};

export type UserProfileDetailInputType = {
  assignedStaff?: InputMaybe<AssignedStaffInputType>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type UserProfileDetailType = {
  __typename?: 'UserProfileDetailType';
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['String']>;
  assignedStaff?: Maybe<StaffEntity>;
  clinicId?: Maybe<Scalars['String']>;
  clinics?: Maybe<Array<ClinicEntity>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyMembers?: Maybe<Array<FamilyMemberEntity>>;
  fitbitAccessToken?: Maybe<Scalars['String']>;
  fitbitId?: Maybe<Scalars['String']>;
  fitbitRefreshToken?: Maybe<Scalars['String']>;
  fitbitScopes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  idNumber?: Maybe<Scalars['String']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  lastMessageAt?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<NoteEntity>>;
  notificationPreferenceType?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<StudyPermissionEntity>>;
  phoneNumbers?: Maybe<Array<PhoneNumberEntity>>;
  preferredLanguage?: Maybe<Scalars['String']>;
  preferredTime?: Maybe<Scalars['String']>;
  primaryRole?: Maybe<RoleEntity>;
  privateNotes?: Maybe<Scalars['Boolean']>;
  receiverEmails?: Maybe<Array<EmailEntity>>;
  receiverMessages?: Maybe<Array<MessageEntity>>;
  receiverNotifications?: Maybe<Array<NotificationEntity>>;
  receiverVoices?: Maybe<Array<VoiceEntity>>;
  roles?: Maybe<Array<StudyRoleEntity>>;
  senderEmails?: Maybe<Array<EmailEntity>>;
  senderMessages?: Maybe<Array<MessageEntity>>;
  senderNotifications?: Maybe<Array<NotificationEntity>>;
  senderVoices?: Maybe<Array<VoiceEntity>>;
  sexualOrientation?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  studies?: Maybe<Array<StudyEntity>>;
  studyArmsId?: Maybe<Array<Scalars['Float']>>;
  timezone?: Maybe<Scalars['String']>;
  treatments?: Maybe<Array<TreatmentEntity>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vonageName?: Maybe<Scalars['String']>;
  vonageUuid?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type UserProfileDetailsInputType = {
  address?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['String']>;
  assignedStaff?: InputMaybe<AssignedStaffInputType>;
  clinicId?: InputMaybe<Scalars['String']>;
  clinics: Array<ClinicInputType>;
  familyMembers: Array<FamilyMemberInputType>;
  idNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumbers: Array<PhoneNumberInputType>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  preferredTime?: InputMaybe<Scalars['String']>;
  sexualOrientation?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  treatments: Array<TreatmentInputType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UserProfileInfoInputType = {
  address?: InputMaybe<Scalars['String']>;
  clinicId?: InputMaybe<Scalars['String']>;
  clinics: Array<ClinicInputType>;
  familyMembers: Array<FamilyMemberInputType>;
  idNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumbers: Array<PhoneNumberInputType>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  treatments: Array<TreatmentInputType>;
};

export type UserStudyInputType = {
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId: Scalars['Float'];
  userId: Scalars['Float'];
};

export type UserSubscriptionEntity = {
  __typename?: 'UserSubscriptionEntity';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fromUser: UserEntity;
  id: Scalars['ID'];
  isSubscribed: Scalars['Boolean'];
  notificationPreference: NotificationpPreferencesEntity;
  toUser: UserEntity;
  updatedAt: Scalars['DateTime'];
};

export type UserUpdateInputType = {
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  privateNotes?: InputMaybe<Scalars['Boolean']>;
  roleId?: InputMaybe<Scalars['Float']>;
  status: Scalars['String'];
};

export type UserVerifiedInputType = {
  __typename?: 'UserVerifiedInputType';
  verified: Scalars['Boolean'];
};

export type UsersOutputType = {
  __typename?: 'UsersOutputType';
  count: Scalars['Int'];
  items: Array<UserEntity>;
};

export type VoiceEntity = {
  __typename?: 'VoiceEntity';
  actions?: Maybe<Scalars['String']>;
  audioUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  labels?: Maybe<Scalars['String']>;
  liked: Scalars['Boolean'];
  receiver?: Maybe<UserEntity>;
  receiverId?: Maybe<Scalars['Float']>;
  sender?: Maybe<UserEntity>;
  senderId?: Maybe<Scalars['Float']>;
  study?: Maybe<StudyEntity>;
  studyArm?: Maybe<StudyArmEntity>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  viewed: Scalars['Boolean'];
};

export type VoicesInput = {
  actions?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  labels?: InputMaybe<Scalars['String']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  studyArmId?: InputMaybe<Scalars['Float']>;
  studyId?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type VoicesOutput = {
  __typename?: 'VoicesOutput';
  count: Scalars['Int'];
  items: Array<VoiceEntity>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ActivityLevel: ResolverTypeWrapper<ActivityLevel>;
  ArchiveOutput: ResolverTypeWrapper<ArchiveOutput>;
  AssessmentAnswerEntity: ResolverTypeWrapper<AssessmentAnswerEntity>;
  AssessmentAnswerInputType: AssessmentAnswerInputType;
  AssessmentQuestionEntity: ResolverTypeWrapper<AssessmentQuestionEntity>;
  AssessmentQuestionInputType: AssessmentQuestionInputType;
  AssessmentQuestionOutputType: ResolverTypeWrapper<AssessmentQuestionOutputType>;
  AssessmentQuestionWhereInputType: AssessmentQuestionWhereInputType;
  AssessmentResponseEntity: ResolverTypeWrapper<AssessmentResponseEntity>;
  AssessmentResponseInputType: AssessmentResponseInputType;
  AssessmentResponseOutputType: ResolverTypeWrapper<AssessmentResponseOutputType>;
  AssessmentResponseWithTokenInputType: AssessmentResponseWithTokenInputType;
  AssessmentResponsesWhereInputType: AssessmentResponsesWhereInputType;
  AssessmentsAnsweredResponseOutputType: ResolverTypeWrapper<AssessmentsAnsweredResponseOutputType>;
  AssignedStaffInputType: AssignedStaffInputType;
  AuditEntity: ResolverTypeWrapper<AuditEntity>;
  AuditInput: AuditInput;
  AuditOutput: ResolverTypeWrapper<AuditOutput>;
  AuthOutputType: ResolverTypeWrapper<AuthOutputType>;
  AutomationActionType: AutomationActionType;
  AutomationActionWhoType: AutomationActionWhoType;
  AutomationConditionType: AutomationConditionType;
  AutomationInputType: AutomationInputType;
  AutomationWhoOutputType: ResolverTypeWrapper<AutomationWhoOutputType>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  CallRecordingOutputType: ResolverTypeWrapper<CallRecordingOutputType>;
  CanDeleteLibraryOutputType: ResolverTypeWrapper<CanDeleteLibraryOutputType>;
  ChartEntity: ResolverTypeWrapper<ChartEntity>;
  ChartTabEntity: ResolverTypeWrapper<ChartTabEntity>;
  ChartTabInputType: ChartTabInputType;
  ChartTabOutputType: ResolverTypeWrapper<ChartTabOutputType>;
  ChatMessageDetailOutputType: ResolverTypeWrapper<ChatMessageDetailOutputType>;
  ClinicEntity: ResolverTypeWrapper<ClinicEntity>;
  ClinicInputType: ClinicInputType;
  CoachingAssessmentForNotesOutput: ResolverTypeWrapper<CoachingAssessmentForNotesOutput>;
  CoachingCallDetailOutputType: ResolverTypeWrapper<CoachingCallDetailOutputType>;
  CoachingEvents: ResolverTypeWrapper<CoachingEvents>;
  CommunicationCallDetailOutputType: ResolverTypeWrapper<CommunicationCallDetailOutputType>;
  CommunicationCallParticipantType: ResolverTypeWrapper<CommunicationCallParticipantType>;
  ConferenceEntity: ResolverTypeWrapper<ConferenceEntity>;
  ConferenceInputType: ConferenceInputType;
  ConferenceOutputType: ResolverTypeWrapper<ConferenceOutputType>;
  ConferenceWhereInputType: ConferenceWhereInputType;
  ConferenceWithUsersOutputType: ResolverTypeWrapper<ConferenceWithUsersOutputType>;
  ConferenceWithUsersRelation: ResolverTypeWrapper<ConferenceWithUsersRelation>;
  CountryInputType: CountryInputType;
  CountryPhoneNumberEntity: ResolverTypeWrapper<CountryPhoneNumberEntity>;
  CountryPhoneNumberInput: CountryPhoneNumberInput;
  CreateChartInput: CreateChartInput;
  CreateEmailInput: CreateEmailInput;
  CreateEventInput: CreateEventInput;
  CreateMessageInput: CreateMessageInput;
  CreateNoteInput: CreateNoteInput;
  CreateNotificationInput: CreateNotificationInput;
  CreateStudyPermissionInput: CreateStudyPermissionInput;
  CreateStudyRoleInput: CreateStudyRoleInput;
  CreateSuggestedDateInput: CreateSuggestedDateInput;
  CreateUserSubscriptionInput: CreateUserSubscriptionInput;
  CreateVoiceInput: CreateVoiceInput;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  EmailDetailOutputType: ResolverTypeWrapper<EmailDetailOutputType>;
  EmailEntity: ResolverTypeWrapper<EmailEntity>;
  EmailsInput: EmailsInput;
  EmailsOutput: ResolverTypeWrapper<EmailsOutput>;
  EventEntity: ResolverTypeWrapper<EventEntity>;
  EventMetricsInputType: EventMetricsInputType;
  EventMetricsOutputType: ResolverTypeWrapper<EventMetricsOutputType>;
  EventSchedulingStatus: EventSchedulingStatus;
  EventWithTimeWindow: ResolverTypeWrapper<EventWithTimeWindow>;
  EventsInput: EventsInput;
  EventsOutput: ResolverTypeWrapper<EventsOutput>;
  ExportContentMetadataType: ResolverTypeWrapper<ExportContentMetadataType>;
  ExportDataTypesEnum: ExportDataTypesEnum;
  ExportFileContentMetadataType: ResolverTypeWrapper<ExportFileContentMetadataType>;
  ExportFileContentResponseType: ResolverTypeWrapper<ExportFileContentResponseType>;
  ExportFileContentType: ExportFileContentType;
  ExportRequestOutputType: ResolverTypeWrapper<ExportRequestOutputType>;
  ExportRequestStatus: ExportRequestStatus;
  ExportStudyInput: ExportStudyInput;
  ExportedFileRecordType: ResolverTypeWrapper<ExportedFileRecordType>;
  FamilyMemberEntity: ResolverTypeWrapper<FamilyMemberEntity>;
  FamilyMemberInputType: FamilyMemberInputType;
  FileEntity: ResolverTypeWrapper<FileEntity>;
  FilesInput: FilesInput;
  FilesOutput: ResolverTypeWrapper<FilesOutput>;
  FitbitActivityEntity: ResolverTypeWrapper<FitbitActivityEntity>;
  FitbitActivityTrendData: ResolverTypeWrapper<FitbitActivityTrendData>;
  FitbitActivityTrendInputType: FitbitActivityTrendInputType;
  FitbitChartsData: ResolverTypeWrapper<FitbitChartsData>;
  FitbitDistanceEntity: ResolverTypeWrapper<FitbitDistanceEntity>;
  FitbitEntity: ResolverTypeWrapper<FitbitEntity>;
  FitbitHeartRateEntity: ResolverTypeWrapper<FitbitHeartRateEntity>;
  FitbitHistoryEntity: ResolverTypeWrapper<FitbitHistoryEntity>;
  FitbitLifetimeStats: ResolverTypeWrapper<FitbitLifetimeStats>;
  FitbitSleepEntity: ResolverTypeWrapper<FitbitSleepEntity>;
  FitbitStepsEntity: ResolverTypeWrapper<FitbitStepsEntity>;
  FitbitWeightEntity: ResolverTypeWrapper<FitbitWeightEntity>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  GraphDataPointsInput: GraphDataPointsInput;
  GraphDataPointsOutput: ResolverTypeWrapper<GraphDataPointsOutput>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  InviteParticipantInputType: InviteParticipantInputType;
  InviteStaffInputType: InviteStaffInputType;
  InviteStaffOutputType: ResolverTypeWrapper<InviteStaffOutputType>;
  IvrCallDetailOutputType: ResolverTypeWrapper<IvrCallDetailOutputType>;
  IvrQuestionAnswerOutputType: ResolverTypeWrapper<IvrQuestionAnswerOutputType>;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']>;
  JournalEntryDetailOutputType: ResolverTypeWrapper<JournalEntryDetailOutputType>;
  LibraryEntity: ResolverTypeWrapper<LibraryEntity>;
  LibraryOutputType: ResolverTypeWrapper<LibraryOutputType>;
  LibraryWhereInputType: LibraryWhereInputType;
  LimitInput: LimitInput;
  ManageChartTabInputType: ManageChartTabInputType;
  ManageChartTabResponseType: ResolverTypeWrapper<ManageChartTabResponseType>;
  MedicationEntity: ResolverTypeWrapper<MedicationEntity>;
  MedicationInputType: MedicationInputType;
  MedicationOutputType: ResolverTypeWrapper<MedicationOutputType>;
  MedicationWhereInputType: MedicationWhereInputType;
  MemberInputType: MemberInputType;
  MessageEntity: ResolverTypeWrapper<MessageEntity>;
  MessagesInput: MessagesInput;
  MessagesOutput: ResolverTypeWrapper<MessagesOutput>;
  MetricsAdherence: ResolverTypeWrapper<MetricsAdherence>;
  MetricsAdherenceOutput: ResolverTypeWrapper<MetricsAdherenceOutput>;
  MetricsInputType: MetricsInputType;
  MetricsOutputType: ResolverTypeWrapper<MetricsOutputType>;
  MetricsUsersOutputType: ResolverTypeWrapper<MetricsUsersOutputType>;
  ModuleInputType: ModuleInputType;
  Mutation: ResolverTypeWrapper<{}>;
  NoteEntity: ResolverTypeWrapper<NoteEntity>;
  NotesInput: NotesInput;
  NotesOutput: ResolverTypeWrapper<NotesOutput>;
  NotificationEntity: ResolverTypeWrapper<NotificationEntity>;
  NotificationpPreferencesEntity: ResolverTypeWrapper<NotificationpPreferencesEntity>;
  NotificationsInput: NotificationsInput;
  NotificationsOutput: ResolverTypeWrapper<NotificationsOutput>;
  OpentokAuthOutputType: ResolverTypeWrapper<OpentokAuthOutputType>;
  ParticipantExportDataOutputType: ResolverTypeWrapper<ParticipantExportDataOutputType>;
  PermissionEntity: ResolverTypeWrapper<PermissionEntity>;
  PermissionInputType: PermissionInputType;
  PermissionOutputType: ResolverTypeWrapper<PermissionOutputType>;
  PermissionPartialInputType: PermissionPartialInputType;
  PermissionWhereType: PermissionWhereType;
  PhoneNumberEntity: ResolverTypeWrapper<PhoneNumberEntity>;
  PhoneNumberInputType: PhoneNumberInputType;
  Query: ResolverTypeWrapper<{}>;
  QuestionCategoryEntity: ResolverTypeWrapper<QuestionCategoryEntity>;
  QuestionCategoryInputType: QuestionCategoryInputType;
  QuestionCategoryOutputType: ResolverTypeWrapper<QuestionCategoryOutputType>;
  QuestionCategoryWhereInputType: QuestionCategoryWhereInputType;
  RecordingEntity: ResolverTypeWrapper<RecordingEntity>;
  RoleAutoCompleteInputType: RoleAutoCompleteInputType;
  RoleEntity: ResolverTypeWrapper<RoleEntity>;
  RoleInputType: RoleInputType;
  RoleWhereInputType: RoleWhereInputType;
  RolesOutputType: ResolverTypeWrapper<RolesOutputType>;
  StaffEntity: ResolverTypeWrapper<StaffEntity>;
  Stream: ResolverTypeWrapper<Stream>;
  String: ResolverTypeWrapper<Scalars['String']>;
  StringShortenOutputType: ResolverTypeWrapper<StringShortenOutputType>;
  StudyArmEntity: ResolverTypeWrapper<StudyArmEntity>;
  StudyArmInputType: StudyArmInputType;
  StudyArmLibraryConfigsEntity: ResolverTypeWrapper<StudyArmLibraryConfigsEntity>;
  StudyArmLibraryConfigsInputType: StudyArmLibraryConfigsInputType;
  StudyArmOutputType: ResolverTypeWrapper<StudyArmOutputType>;
  StudyArmWhereInputType: StudyArmWhereInputType;
  StudyEntity: ResolverTypeWrapper<StudyEntity>;
  StudyInputType: StudyInputType;
  StudyOutputType: ResolverTypeWrapper<StudyOutputType>;
  StudyPermissionEntity: ResolverTypeWrapper<StudyPermissionEntity>;
  StudyPermissionWhereInput: StudyPermissionWhereInput;
  StudyPermissionsOutput: ResolverTypeWrapper<StudyPermissionsOutput>;
  StudyRoleEntity: ResolverTypeWrapper<StudyRoleEntity>;
  StudyRoleOutput: ResolverTypeWrapper<StudyRoleOutput>;
  StudyRoleWhereInput: StudyRoleWhereInput;
  StudyStaffInputType: StudyStaffInputType;
  StudyWhereInputType: StudyWhereInputType;
  SuggestedDateEntity: ResolverTypeWrapper<SuggestedDateEntity>;
  SuggestedDateWhereInputType: SuggestedDateWhereInputType;
  SymptomEntity: ResolverTypeWrapper<SymptomEntity>;
  SymptomInputType: SymptomInputType;
  SymptomOutputType: ResolverTypeWrapper<SymptomOutputType>;
  SymptomWhereInputType: SymptomWhereInputType;
  TooltipEntity: ResolverTypeWrapper<TooltipEntity>;
  TooltipInputType: TooltipInputType;
  TooltipOutputType: ResolverTypeWrapper<TooltipOutputType>;
  TooltipWhereInputType: TooltipWhereInputType;
  TranslateOutputType: ResolverTypeWrapper<TranslateOutputType>;
  TreatmentEntity: ResolverTypeWrapper<TreatmentEntity>;
  TreatmentInputType: TreatmentInputType;
  TypedExportFileContentType: ResolverTypeWrapper<TypedExportFileContentType>;
  TypedExportedFileRecordType: ResolverTypeWrapper<TypedExportedFileRecordType>;
  UpdateChartInput: UpdateChartInput;
  UpdateEmailInput: UpdateEmailInput;
  UpdateEventInput: UpdateEventInput;
  UpdateFileInput: UpdateFileInput;
  UpdateMessageInput: UpdateMessageInput;
  UpdateNoteInput: UpdateNoteInput;
  UpdateNotificationInput: UpdateNotificationInput;
  UpdateStudyPermissionInput: UpdateStudyPermissionInput;
  UpdateStudyRoleInput: UpdateStudyRoleInput;
  UpdateVoiceInput: UpdateVoiceInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  UserConferencesOutputType: ResolverTypeWrapper<UserConferencesOutputType>;
  UserEntity: ResolverTypeWrapper<UserEntity>;
  UserInfoDetailsOutputType: ResolverTypeWrapper<UserInfoDetailsOutputType>;
  UserInputType: UserInputType;
  UserLoginOutputType: ResolverTypeWrapper<UserLoginOutputType>;
  UserPermissionInputType: UserPermissionInputType;
  UserProfileDetailInputType: UserProfileDetailInputType;
  UserProfileDetailType: ResolverTypeWrapper<UserProfileDetailType>;
  UserProfileDetailsInputType: UserProfileDetailsInputType;
  UserProfileInfoInputType: UserProfileInfoInputType;
  UserStudyInputType: UserStudyInputType;
  UserSubscriptionEntity: ResolverTypeWrapper<UserSubscriptionEntity>;
  UserUpdateInputType: UserUpdateInputType;
  UserVerifiedInputType: ResolverTypeWrapper<UserVerifiedInputType>;
  UsersOutputType: ResolverTypeWrapper<UsersOutputType>;
  VoiceEntity: ResolverTypeWrapper<VoiceEntity>;
  VoicesInput: VoicesInput;
  VoicesOutput: ResolverTypeWrapper<VoicesOutput>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ActivityLevel: ActivityLevel;
  ArchiveOutput: ArchiveOutput;
  AssessmentAnswerEntity: AssessmentAnswerEntity;
  AssessmentAnswerInputType: AssessmentAnswerInputType;
  AssessmentQuestionEntity: AssessmentQuestionEntity;
  AssessmentQuestionInputType: AssessmentQuestionInputType;
  AssessmentQuestionOutputType: AssessmentQuestionOutputType;
  AssessmentQuestionWhereInputType: AssessmentQuestionWhereInputType;
  AssessmentResponseEntity: AssessmentResponseEntity;
  AssessmentResponseInputType: AssessmentResponseInputType;
  AssessmentResponseOutputType: AssessmentResponseOutputType;
  AssessmentResponseWithTokenInputType: AssessmentResponseWithTokenInputType;
  AssessmentResponsesWhereInputType: AssessmentResponsesWhereInputType;
  AssessmentsAnsweredResponseOutputType: AssessmentsAnsweredResponseOutputType;
  AssignedStaffInputType: AssignedStaffInputType;
  AuditEntity: AuditEntity;
  AuditInput: AuditInput;
  AuditOutput: AuditOutput;
  AuthOutputType: AuthOutputType;
  AutomationActionType: AutomationActionType;
  AutomationActionWhoType: AutomationActionWhoType;
  AutomationConditionType: AutomationConditionType;
  AutomationInputType: AutomationInputType;
  AutomationWhoOutputType: AutomationWhoOutputType;
  Boolean: Scalars['Boolean'];
  CallRecordingOutputType: CallRecordingOutputType;
  CanDeleteLibraryOutputType: CanDeleteLibraryOutputType;
  ChartEntity: ChartEntity;
  ChartTabEntity: ChartTabEntity;
  ChartTabInputType: ChartTabInputType;
  ChartTabOutputType: ChartTabOutputType;
  ChatMessageDetailOutputType: ChatMessageDetailOutputType;
  ClinicEntity: ClinicEntity;
  ClinicInputType: ClinicInputType;
  CoachingAssessmentForNotesOutput: CoachingAssessmentForNotesOutput;
  CoachingCallDetailOutputType: CoachingCallDetailOutputType;
  CoachingEvents: CoachingEvents;
  CommunicationCallDetailOutputType: CommunicationCallDetailOutputType;
  CommunicationCallParticipantType: CommunicationCallParticipantType;
  ConferenceEntity: ConferenceEntity;
  ConferenceInputType: ConferenceInputType;
  ConferenceOutputType: ConferenceOutputType;
  ConferenceWhereInputType: ConferenceWhereInputType;
  ConferenceWithUsersOutputType: ConferenceWithUsersOutputType;
  ConferenceWithUsersRelation: ConferenceWithUsersRelation;
  CountryInputType: CountryInputType;
  CountryPhoneNumberEntity: CountryPhoneNumberEntity;
  CountryPhoneNumberInput: CountryPhoneNumberInput;
  CreateChartInput: CreateChartInput;
  CreateEmailInput: CreateEmailInput;
  CreateEventInput: CreateEventInput;
  CreateMessageInput: CreateMessageInput;
  CreateNoteInput: CreateNoteInput;
  CreateNotificationInput: CreateNotificationInput;
  CreateStudyPermissionInput: CreateStudyPermissionInput;
  CreateStudyRoleInput: CreateStudyRoleInput;
  CreateSuggestedDateInput: CreateSuggestedDateInput;
  CreateUserSubscriptionInput: CreateUserSubscriptionInput;
  CreateVoiceInput: CreateVoiceInput;
  DateTime: Scalars['DateTime'];
  EmailDetailOutputType: EmailDetailOutputType;
  EmailEntity: EmailEntity;
  EmailsInput: EmailsInput;
  EmailsOutput: EmailsOutput;
  EventEntity: EventEntity;
  EventMetricsInputType: EventMetricsInputType;
  EventMetricsOutputType: EventMetricsOutputType;
  EventWithTimeWindow: EventWithTimeWindow;
  EventsInput: EventsInput;
  EventsOutput: EventsOutput;
  ExportContentMetadataType: ExportContentMetadataType;
  ExportFileContentMetadataType: ExportFileContentMetadataType;
  ExportFileContentResponseType: ExportFileContentResponseType;
  ExportRequestOutputType: ExportRequestOutputType;
  ExportStudyInput: ExportStudyInput;
  ExportedFileRecordType: ExportedFileRecordType;
  FamilyMemberEntity: FamilyMemberEntity;
  FamilyMemberInputType: FamilyMemberInputType;
  FileEntity: FileEntity;
  FilesInput: FilesInput;
  FilesOutput: FilesOutput;
  FitbitActivityEntity: FitbitActivityEntity;
  FitbitActivityTrendData: FitbitActivityTrendData;
  FitbitActivityTrendInputType: FitbitActivityTrendInputType;
  FitbitChartsData: FitbitChartsData;
  FitbitDistanceEntity: FitbitDistanceEntity;
  FitbitEntity: FitbitEntity;
  FitbitHeartRateEntity: FitbitHeartRateEntity;
  FitbitHistoryEntity: FitbitHistoryEntity;
  FitbitLifetimeStats: FitbitLifetimeStats;
  FitbitSleepEntity: FitbitSleepEntity;
  FitbitStepsEntity: FitbitStepsEntity;
  FitbitWeightEntity: FitbitWeightEntity;
  Float: Scalars['Float'];
  GraphDataPointsInput: GraphDataPointsInput;
  GraphDataPointsOutput: GraphDataPointsOutput;
  ID: Scalars['ID'];
  Int: Scalars['Int'];
  InviteParticipantInputType: InviteParticipantInputType;
  InviteStaffInputType: InviteStaffInputType;
  InviteStaffOutputType: InviteStaffOutputType;
  IvrCallDetailOutputType: IvrCallDetailOutputType;
  IvrQuestionAnswerOutputType: IvrQuestionAnswerOutputType;
  JSON: Scalars['JSON'];
  JSONObject: Scalars['JSONObject'];
  JournalEntryDetailOutputType: JournalEntryDetailOutputType;
  LibraryEntity: LibraryEntity;
  LibraryOutputType: LibraryOutputType;
  LibraryWhereInputType: LibraryWhereInputType;
  LimitInput: LimitInput;
  ManageChartTabInputType: ManageChartTabInputType;
  ManageChartTabResponseType: ManageChartTabResponseType;
  MedicationEntity: MedicationEntity;
  MedicationInputType: MedicationInputType;
  MedicationOutputType: MedicationOutputType;
  MedicationWhereInputType: MedicationWhereInputType;
  MemberInputType: MemberInputType;
  MessageEntity: MessageEntity;
  MessagesInput: MessagesInput;
  MessagesOutput: MessagesOutput;
  MetricsAdherence: MetricsAdherence;
  MetricsAdherenceOutput: MetricsAdherenceOutput;
  MetricsInputType: MetricsInputType;
  MetricsOutputType: MetricsOutputType;
  MetricsUsersOutputType: MetricsUsersOutputType;
  ModuleInputType: ModuleInputType;
  Mutation: {};
  NoteEntity: NoteEntity;
  NotesInput: NotesInput;
  NotesOutput: NotesOutput;
  NotificationEntity: NotificationEntity;
  NotificationpPreferencesEntity: NotificationpPreferencesEntity;
  NotificationsInput: NotificationsInput;
  NotificationsOutput: NotificationsOutput;
  OpentokAuthOutputType: OpentokAuthOutputType;
  ParticipantExportDataOutputType: ParticipantExportDataOutputType;
  PermissionEntity: PermissionEntity;
  PermissionInputType: PermissionInputType;
  PermissionOutputType: PermissionOutputType;
  PermissionPartialInputType: PermissionPartialInputType;
  PermissionWhereType: PermissionWhereType;
  PhoneNumberEntity: PhoneNumberEntity;
  PhoneNumberInputType: PhoneNumberInputType;
  Query: {};
  QuestionCategoryEntity: QuestionCategoryEntity;
  QuestionCategoryInputType: QuestionCategoryInputType;
  QuestionCategoryOutputType: QuestionCategoryOutputType;
  QuestionCategoryWhereInputType: QuestionCategoryWhereInputType;
  RecordingEntity: RecordingEntity;
  RoleAutoCompleteInputType: RoleAutoCompleteInputType;
  RoleEntity: RoleEntity;
  RoleInputType: RoleInputType;
  RoleWhereInputType: RoleWhereInputType;
  RolesOutputType: RolesOutputType;
  StaffEntity: StaffEntity;
  Stream: Stream;
  String: Scalars['String'];
  StringShortenOutputType: StringShortenOutputType;
  StudyArmEntity: StudyArmEntity;
  StudyArmInputType: StudyArmInputType;
  StudyArmLibraryConfigsEntity: StudyArmLibraryConfigsEntity;
  StudyArmLibraryConfigsInputType: StudyArmLibraryConfigsInputType;
  StudyArmOutputType: StudyArmOutputType;
  StudyArmWhereInputType: StudyArmWhereInputType;
  StudyEntity: StudyEntity;
  StudyInputType: StudyInputType;
  StudyOutputType: StudyOutputType;
  StudyPermissionEntity: StudyPermissionEntity;
  StudyPermissionWhereInput: StudyPermissionWhereInput;
  StudyPermissionsOutput: StudyPermissionsOutput;
  StudyRoleEntity: StudyRoleEntity;
  StudyRoleOutput: StudyRoleOutput;
  StudyRoleWhereInput: StudyRoleWhereInput;
  StudyStaffInputType: StudyStaffInputType;
  StudyWhereInputType: StudyWhereInputType;
  SuggestedDateEntity: SuggestedDateEntity;
  SuggestedDateWhereInputType: SuggestedDateWhereInputType;
  SymptomEntity: SymptomEntity;
  SymptomInputType: SymptomInputType;
  SymptomOutputType: SymptomOutputType;
  SymptomWhereInputType: SymptomWhereInputType;
  TooltipEntity: TooltipEntity;
  TooltipInputType: TooltipInputType;
  TooltipOutputType: TooltipOutputType;
  TooltipWhereInputType: TooltipWhereInputType;
  TranslateOutputType: TranslateOutputType;
  TreatmentEntity: TreatmentEntity;
  TreatmentInputType: TreatmentInputType;
  TypedExportFileContentType: TypedExportFileContentType;
  TypedExportedFileRecordType: TypedExportedFileRecordType;
  UpdateChartInput: UpdateChartInput;
  UpdateEmailInput: UpdateEmailInput;
  UpdateEventInput: UpdateEventInput;
  UpdateFileInput: UpdateFileInput;
  UpdateMessageInput: UpdateMessageInput;
  UpdateNoteInput: UpdateNoteInput;
  UpdateNotificationInput: UpdateNotificationInput;
  UpdateStudyPermissionInput: UpdateStudyPermissionInput;
  UpdateStudyRoleInput: UpdateStudyRoleInput;
  UpdateVoiceInput: UpdateVoiceInput;
  Upload: Scalars['Upload'];
  UserConferencesOutputType: UserConferencesOutputType;
  UserEntity: UserEntity;
  UserInfoDetailsOutputType: UserInfoDetailsOutputType;
  UserInputType: UserInputType;
  UserLoginOutputType: UserLoginOutputType;
  UserPermissionInputType: UserPermissionInputType;
  UserProfileDetailInputType: UserProfileDetailInputType;
  UserProfileDetailType: UserProfileDetailType;
  UserProfileDetailsInputType: UserProfileDetailsInputType;
  UserProfileInfoInputType: UserProfileInfoInputType;
  UserStudyInputType: UserStudyInputType;
  UserSubscriptionEntity: UserSubscriptionEntity;
  UserUpdateInputType: UserUpdateInputType;
  UserVerifiedInputType: UserVerifiedInputType;
  UsersOutputType: UsersOutputType;
  VoiceEntity: VoiceEntity;
  VoicesInput: VoicesInput;
  VoicesOutput: VoicesOutput;
};

export type OneOfDirectiveArgs = { };

export type OneOfDirectiveResolver<Result, Parent, ContextType = any, Args = OneOfDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ActivityLevelResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityLevel'] = ResolversParentTypes['ActivityLevel']> = {
  minutes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ArchiveOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ArchiveOutput'] = ResolversParentTypes['ArchiveOutput']> = {
  createdAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasAudio?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasVideo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outputMode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  partnerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resolution?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamMode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streams?: Resolver<Array<ResolversTypes['Stream']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssessmentAnswerEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssessmentAnswerEntity'] = ResolversParentTypes['AssessmentAnswerEntity']> = {
  answerDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  question?: Resolver<Maybe<ResolversTypes['AssessmentQuestionEntity']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssessmentQuestionEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssessmentQuestionEntity'] = ResolversParentTypes['AssessmentQuestionEntity']> = {
  automation?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['QuestionCategoryEntity']>, ParentType, ContextType>;
  conditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAnswered?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  questions?: Resolver<Maybe<Array<ResolversTypes['AssessmentQuestionEntity']>>, ParentType, ContextType>;
  symptomName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  symptomNameEs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tooltip?: Resolver<Maybe<ResolversTypes['TooltipEntity']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  variableName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssessmentQuestionOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssessmentQuestionOutputType'] = ResolversParentTypes['AssessmentQuestionOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['AssessmentQuestionEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssessmentResponseEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssessmentResponseEntity'] = ResolversParentTypes['AssessmentResponseEntity']> = {
  answerDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  answers?: Resolver<Maybe<Array<ResolversTypes['AssessmentAnswerEntity']>>, ParentType, ContextType>;
  conversationUUID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  incrementFollowupQuestionsCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  library?: Resolver<ResolversTypes['LibraryEntity'], ParentType, ContextType>;
  libraryId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  preIVRQuestionsRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  skippedQuestionCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skippedQuestionsBySystemCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  study?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType>;
  studyArm?: Resolver<Maybe<ResolversTypes['StudyArmEntity']>, ParentType, ContextType>;
  triggeredAutomationIndexes?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssessmentResponseOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssessmentResponseOutputType'] = ResolversParentTypes['AssessmentResponseOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['AssessmentResponseEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssessmentsAnsweredResponseOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssessmentsAnsweredResponseOutputType'] = ResolversParentTypes['AssessmentsAnsweredResponseOutputType']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  isAnswered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditEntity'] = ResolversParentTypes['AuditEntity']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  newData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notify?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  oldData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  study?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType>;
  studyArm?: Resolver<Maybe<ResolversTypes['StudyArmEntity']>, ParentType, ContextType>;
  tableName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditOutput'] = ResolversParentTypes['AuditOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['AuditEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthOutputType'] = ResolversParentTypes['AuthOutputType']> = {
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutomationWhoOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutomationWhoOutputType'] = ResolversParentTypes['AutomationWhoOutputType']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CallRecordingOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CallRecordingOutputType'] = ResolversParentTypes['CallRecordingOutputType']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  durationSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  format?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recordingId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CanDeleteLibraryOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CanDeleteLibraryOutputType'] = ResolversParentTypes['CanDeleteLibraryOutputType']> = {
  canDelete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChartEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChartEntity'] = ResolversParentTypes['ChartEntity']> = {
  category?: Resolver<ResolversTypes['ChartTabEntity'], ParentType, ContextType>;
  categoryId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  dataSource?: Resolver<ResolversTypes['AssessmentQuestionEntity'], ParentType, ContextType>;
  dataSource1?: Resolver<Maybe<ResolversTypes['AssessmentQuestionEntity']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fullWidth?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  plots?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  plots1?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  xAxis?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  yAxis?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  yAxis1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChartTabEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChartTabEntity'] = ResolversParentTypes['ChartTabEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChartTabOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChartTabOutputType'] = ResolversParentTypes['ChartTabOutputType']> = {
  chartCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageDetailOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessageDetailOutputType'] = ResolversParentTypes['ChatMessageDetailOutputType']> = {
  attachments?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  conversationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messageDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  messageId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recipientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recipientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipientRole?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  senderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  senderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  senderRole?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClinicEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClinicEntity'] = ResolversParentTypes['ClinicEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  doctorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['PhoneNumberEntity']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoachingAssessmentForNotesOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoachingAssessmentForNotesOutput'] = ResolversParentTypes['CoachingAssessmentForNotesOutput']> = {
  hasCoachingAssessment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  noteId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoachingCallDetailOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoachingCallDetailOutputType'] = ResolversParentTypes['CoachingCallDetailOutputType']> = {
  assessmentQuestions?: Resolver<Maybe<Array<ResolversTypes['IvrQuestionAnswerOutputType']>>, ParentType, ContextType>;
  callDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  coachId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  coachName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coachingCallId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  durationMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  libraryDetails?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  noteAttachments?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  noteIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recording?: Resolver<Maybe<ResolversTypes['CallRecordingOutputType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoachingEventsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CoachingEvents'] = ResolversParentTypes['CoachingEvents']> = {
  end?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  libraryId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommunicationCallDetailOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunicationCallDetailOutputType'] = ResolversParentTypes['CommunicationCallDetailOutputType']> = {
  callDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  callParticipants?: Resolver<Array<ResolversTypes['CommunicationCallParticipantType']>, ParentType, ContextType>;
  callType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  communicationCallId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  durationMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recording?: Resolver<Maybe<ResolversTypes['CallRecordingOutputType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommunicationCallParticipantTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunicationCallParticipantType'] = ResolversParentTypes['CommunicationCallParticipantType']> = {
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConferenceEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConferenceEntity'] = ResolversParentTypes['ConferenceEntity']> = {
  answerTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversationUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  dtmf?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fromUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  machineDetectionMeta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  machineDetectionStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<ResolversTypes['NoteEntity']>>, ParentType, ContextType>;
  officialTouchpoint?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recording?: Resolver<Maybe<ResolversTypes['RecordingEntity']>, ParentType, ContextType>;
  sessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  studyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConferenceOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConferenceOutputType'] = ResolversParentTypes['ConferenceOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ConferenceEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConferenceWithUsersOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConferenceWithUsersOutputType'] = ResolversParentTypes['ConferenceWithUsersOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ConferenceWithUsersRelation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConferenceWithUsersRelationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConferenceWithUsersRelation'] = ResolversParentTypes['ConferenceWithUsersRelation']> = {
  answerTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversationUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  dtmf?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fromUser?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  fromUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  machineDetectionMeta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  machineDetectionStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<ResolversTypes['NoteEntity']>>, ParentType, ContextType>;
  officialTouchpoint?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recording?: Resolver<Maybe<ResolversTypes['RecordingEntity']>, ParentType, ContextType>;
  sessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  studyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toUser?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  toUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryPhoneNumberEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryPhoneNumberEntity'] = ResolversParentTypes['CountryPhoneNumberEntity']> = {
  countryCallingCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nationalNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numberValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type EmailDetailOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailDetailOutputType'] = ResolversParentTypes['EmailDetailOutputType']> = {
  attachments?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  emailId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  emailType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isRead?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recipientId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recipientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipientRole?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  senderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  senderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  senderRole?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailEntity'] = ResolversParentTypes['EmailEntity']> = {
  actions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  labels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  receiver?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  receiverId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  senderId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  study?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType>;
  studyArm?: Resolver<Maybe<ResolversTypes['StudyArmEntity']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailsOutput'] = ResolversParentTypes['EmailsOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isGroupChat?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['EmailEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventEntity'] = ResolversParentTypes['EventEntity']> = {
  actions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  azureEventQueueScheduledMessageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  confirmed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailMessageContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  labels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  libraryConfigId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  liked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pushNotificationMessageContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receiver?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  rescheduleTimeInMinutes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schedulingStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  shouldReschedule?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  startForIVR?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  study?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType>;
  studyArm?: Resolver<Maybe<ResolversTypes['StudyArmEntity']>, ParentType, ContextType>;
  textMessageContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventMetricsOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventMetricsOutputType'] = ResolversParentTypes['EventMetricsOutputType']> = {
  completedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completedCountMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  incompleteCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  incompleteCountMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  missedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  missedCountMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCountMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventWithTimeWindowResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventWithTimeWindow'] = ResolversParentTypes['EventWithTimeWindow']> = {
  event?: Resolver<ResolversTypes['EventEntity'], ParentType, ContextType>;
  libraryConfig?: Resolver<Maybe<ResolversTypes['StudyArmLibraryConfigsEntity']>, ParentType, ContextType>;
  windowEndTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  windowStartTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventsOutput'] = ResolversParentTypes['EventsOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['EventEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportContentMetadataTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportContentMetadataType'] = ResolversParentTypes['ExportContentMetadataType']> = {
  dataTypesIncluded?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  dateRangeFrom?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dateRangeTo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  exportedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  studyArmName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  studyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalDataPoints?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalParticipants?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportFileContentMetadataTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportFileContentMetadataType'] = ResolversParentTypes['ExportFileContentMetadataType']> = {
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dataTypeDisplay?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportRequestId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fetchedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schemaVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportFileContentResponseTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportFileContentResponseType'] = ResolversParentTypes['ExportFileContentResponseType']> = {
  content?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['ExportFileContentMetadataType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportRequestOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportRequestOutputType'] = ResolversParentTypes['ExportRequestOutputType']> = {
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportParameters?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  generatedFiles?: Resolver<Maybe<Array<ResolversTypes['ExportedFileRecordType']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requestedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  requestedById?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ExportRequestStatus'], ParentType, ContextType>;
  studyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportedFileRecordTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportedFileRecordType'] = ResolversParentTypes['ExportedFileRecordType']> = {
  contentType?: Resolver<ResolversTypes['ExportFileContentType'], ParentType, ContextType>;
  dataTypeDisplay?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expectedDataStructure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schemaVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FamilyMemberEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FamilyMemberEntity'] = ResolversParentTypes['FamilyMemberEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['PhoneNumberEntity']>, ParentType, ContextType>;
  relationship?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileEntity'] = ResolversParentTypes['FileEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilesOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['FilesOutput'] = ResolversParentTypes['FilesOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['FileEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitActivityEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitActivityEntity'] = ResolversParentTypes['FitbitActivityEntity']> = {
  activityLevel?: Resolver<Maybe<Array<ResolversTypes['ActivityLevel']>>, ParentType, ContextType>;
  averageHeartRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  calories?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  distance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  distanceUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  elivation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pace?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  speed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitActivityTrendDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitActivityTrendData'] = ResolversParentTypes['FitbitActivityTrendData']> = {
  dateTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitChartsDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitChartsData'] = ResolversParentTypes['FitbitChartsData']> = {
  activity?: Resolver<Array<ResolversTypes['FitbitActivityEntity']>, ParentType, ContextType>;
  distance?: Resolver<Array<ResolversTypes['FitbitDistanceEntity']>, ParentType, ContextType>;
  heartRate?: Resolver<Array<ResolversTypes['FitbitHeartRateEntity']>, ParentType, ContextType>;
  sleep?: Resolver<Array<ResolversTypes['FitbitSleepEntity']>, ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['FitbitStepsEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitDistanceEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitDistanceEntity'] = ResolversParentTypes['FitbitDistanceEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitEntity'] = ResolversParentTypes['FitbitEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  hash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitHeartRateEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitHeartRateEntity'] = ResolversParentTypes['FitbitHeartRateEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  restingHeartRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitHistoryEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitHistoryEntity'] = ResolversParentTypes['FitbitHistoryEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitLifetimeStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitLifetimeStats'] = ResolversParentTypes['FitbitLifetimeStats']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metric?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitSleepEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitSleepEntity'] = ResolversParentTypes['FitbitSleepEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  endTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitStepsEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitStepsEntity'] = ResolversParentTypes['FitbitStepsEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitWeightEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FitbitWeightEntity'] = ResolversParentTypes['FitbitWeightEntity']> = {
  bmi?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  weight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphDataPointsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['GraphDataPointsOutput'] = ResolversParentTypes['GraphDataPointsOutput']> = {
  items?: Resolver<Array<ResolversTypes['AssessmentAnswerEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteStaffOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteStaffOutputType'] = ResolversParentTypes['InviteStaffOutputType']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IvrCallDetailOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IvrCallDetailOutputType'] = ResolversParentTypes['IvrCallDetailOutputType']> = {
  callDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  durationSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ivrCallId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  libraryDetails?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  questionsAndAnswers?: Resolver<Array<ResolversTypes['IvrQuestionAnswerOutputType']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IvrQuestionAnswerOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IvrQuestionAnswerOutputType'] = ResolversParentTypes['IvrQuestionAnswerOutputType']> = {
  answerValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  answeredAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  questionDetails?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  questionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  questionText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type JournalEntryDetailOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JournalEntryDetailOutputType'] = ResolversParentTypes['JournalEntryDetailOutputType']> = {
  actions?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  authorId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  authorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  journalEntryId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lastEditorId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastEditorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  libraryDetails?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  questionsAndAnswers?: Resolver<Maybe<Array<ResolversTypes['IvrQuestionAnswerOutputType']>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAtDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LibraryEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LibraryEntity'] = ResolversParentTypes['LibraryEntity']> = {
  assessmentResponses?: Resolver<Maybe<Array<ResolversTypes['AssessmentResponseEntity']>>, ParentType, ContextType>;
  automations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  libraryConfigs?: Resolver<Maybe<Array<ResolversTypes['StudyArmLibraryConfigsEntity']>>, ParentType, ContextType>;
  preIVRDuration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preIVRDurationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questions?: Resolver<Maybe<Array<ResolversTypes['AssessmentQuestionEntity']>>, ParentType, ContextType>;
  studies?: Resolver<Maybe<Array<ResolversTypes['StudyEntity']>>, ParentType, ContextType>;
  studyArms?: Resolver<Maybe<Array<ResolversTypes['StudyArmEntity']>>, ParentType, ContextType>;
  subsets?: Resolver<Maybe<Array<ResolversTypes['LibraryEntity']>>, ParentType, ContextType>;
  superset?: Resolver<Maybe<ResolversTypes['LibraryEntity']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<Maybe<ResolversTypes['TooltipEntity']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LibraryOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LibraryOutputType'] = ResolversParentTypes['LibraryOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['LibraryEntity']>, ParentType, ContextType>;
  types?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManageChartTabResponseTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManageChartTabResponseType'] = ResolversParentTypes['ManageChartTabResponseType']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MedicationEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationEntity'] = ResolversParentTypes['MedicationEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  treatment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MedicationOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationOutputType'] = ResolversParentTypes['MedicationOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['MedicationEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageEntity'] = ResolversParentTypes['MessageEntity']> = {
  actions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  labels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  receiver?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  receiverId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  senderId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  study?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType>;
  studyArm?: Resolver<Maybe<ResolversTypes['StudyArmEntity']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  vonageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagesOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagesOutput'] = ResolversParentTypes['MessagesOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isGroupChat?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['MessageEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricsAdherenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricsAdherence'] = ResolversParentTypes['MetricsAdherence']> = {
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  receiver?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricsAdherenceOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricsAdherenceOutput'] = ResolversParentTypes['MetricsAdherenceOutput']> = {
  adherenceItems?: Resolver<Array<ResolversTypes['MetricsAdherence']>, ParentType, ContextType>;
  completedJournals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  libraries?: Resolver<Maybe<Array<ResolversTypes['LibraryEntity']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricsOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricsOutputType'] = ResolversParentTypes['MetricsOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  enrolledCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  increasedCountRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  increasedDurationRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  increasedEnrollRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalDuration?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricsUsersOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricsUsersOutputType'] = ResolversParentTypes['MetricsUsersOutputType']> = {
  participantCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  participantCountMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  addAssessmentAnswer?: Resolver<Maybe<ResolversTypes['AssessmentResponseEntity']>, ParentType, ContextType, RequireFields<MutationAddAssessmentAnswerArgs, 'id' | 'updateAssessmentAnswerInput'>>;
  addMedication?: Resolver<Maybe<ResolversTypes['MedicationEntity']>, ParentType, ContextType, RequireFields<MutationAddMedicationArgs, 'data' | 'userId'>>;
  addSymptom?: Resolver<Maybe<ResolversTypes['SymptomEntity']>, ParentType, ContextType, RequireFields<MutationAddSymptomArgs, 'data' | 'userId'>>;
  chartTab?: Resolver<ResolversTypes['ChartTabEntity'], ParentType, ContextType, RequireFields<MutationChartTabArgs, 'id'>>;
  confirmEvent?: Resolver<Maybe<ResolversTypes['EventEntity']>, ParentType, ContextType, RequireFields<MutationConfirmEventArgs, 'confirmEventInput' | 'id'>>;
  confirmProposedTimeForEvent?: Resolver<Maybe<ResolversTypes['EventEntity']>, ParentType, ContextType, RequireFields<MutationConfirmProposedTimeForEventArgs, 'id' | 'updateEventInput'>>;
  createAssessmentQuestion?: Resolver<Maybe<ResolversTypes['AssessmentQuestionEntity']>, ParentType, ContextType, RequireFields<MutationCreateAssessmentQuestionArgs, 'question'>>;
  createAssessmentResponse?: Resolver<Maybe<ResolversTypes['AssessmentResponseEntity']>, ParentType, ContextType, RequireFields<MutationCreateAssessmentResponseArgs, 'assessmentResponse'>>;
  createAssessmentResponseWithToken?: Resolver<Maybe<ResolversTypes['AssessmentResponseEntity']>, ParentType, ContextType, RequireFields<MutationCreateAssessmentResponseWithTokenArgs, 'assessmentResponse' | 'token'>>;
  createChart?: Resolver<Maybe<ResolversTypes['ChartEntity']>, ParentType, ContextType, RequireFields<MutationCreateChartArgs, 'payload'>>;
  createChartTab?: Resolver<ResolversTypes['ChartTabEntity'], ParentType, ContextType, RequireFields<MutationCreateChartTabArgs, 'title' | 'userId'>>;
  createEmail?: Resolver<Maybe<ResolversTypes['EmailEntity']>, ParentType, ContextType, RequireFields<MutationCreateEmailArgs, 'createEmailInput' | 'files'>>;
  createEvent?: Resolver<Maybe<Array<ResolversTypes['EventEntity']>>, ParentType, ContextType, RequireFields<MutationCreateEventArgs, 'createEventInput'>>;
  createFile?: Resolver<Maybe<ResolversTypes['FileEntity']>, ParentType, ContextType, RequireFields<MutationCreateFileArgs, 'file'>>;
  createFiles?: Resolver<Maybe<Array<ResolversTypes['FileEntity']>>, ParentType, ContextType, RequireFields<MutationCreateFilesArgs, 'files'>>;
  createLibrary?: Resolver<Maybe<ResolversTypes['LibraryEntity']>, ParentType, ContextType, RequireFields<MutationCreateLibraryArgs, 'automations' | 'duration' | 'icon' | 'iconFile' | 'initialMessage' | 'preIVRDuration' | 'preIVRDurationType' | 'title' | 'type'>>;
  createLibrarySubset?: Resolver<Maybe<ResolversTypes['LibraryEntity']>, ParentType, ContextType, RequireFields<MutationCreateLibrarySubsetArgs, 'supersetId' | 'title'>>;
  createMessage?: Resolver<Maybe<ResolversTypes['MessageEntity']>, ParentType, ContextType, RequireFields<MutationCreateMessageArgs, 'createMessageInput'>>;
  createModule?: Resolver<Maybe<ResolversTypes['LibraryEntity']>, ParentType, ContextType, RequireFields<MutationCreateModuleArgs, 'module'>>;
  createNote?: Resolver<Maybe<ResolversTypes['NoteEntity']>, ParentType, ContextType, RequireFields<MutationCreateNoteArgs, 'createNoteInput' | 'files'>>;
  createNotification?: Resolver<Maybe<ResolversTypes['NotificationEntity']>, ParentType, ContextType, RequireFields<MutationCreateNotificationArgs, 'createNotificationInput'>>;
  createPermission?: Resolver<Maybe<ResolversTypes['PermissionEntity']>, ParentType, ContextType, RequireFields<MutationCreatePermissionArgs, 'permission'>>;
  createRole?: Resolver<Maybe<ResolversTypes['RoleEntity']>, ParentType, ContextType, RequireFields<MutationCreateRoleArgs, 'role'>>;
  createStudy?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType, RequireFields<MutationCreateStudyArgs, 'study'>>;
  createStudyPermission?: Resolver<Maybe<ResolversTypes['StudyPermissionEntity']>, ParentType, ContextType, RequireFields<MutationCreateStudyPermissionArgs, 'createStudyPermissionInput'>>;
  createStudyRole?: Resolver<Maybe<ResolversTypes['StudyRoleEntity']>, ParentType, ContextType, RequireFields<MutationCreateStudyRoleArgs, 'createStudyRoleInput'>>;
  createSuggestedDate?: Resolver<ResolversTypes['SuggestedDateEntity'], ParentType, ContextType, RequireFields<MutationCreateSuggestedDateArgs, 'createSuggestedDateInput'>>;
  createUser?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'user'>>;
  createUserSubscription?: Resolver<Maybe<ResolversTypes['UserSubscriptionEntity']>, ParentType, ContextType, RequireFields<MutationCreateUserSubscriptionArgs, 'createUserSubscriptionInput'>>;
  createVoice?: Resolver<Maybe<ResolversTypes['VoiceEntity']>, ParentType, ContextType, RequireFields<MutationCreateVoiceArgs, 'createVoiceInput'>>;
  deleteChart?: Resolver<Maybe<ResolversTypes['ChartEntity']>, ParentType, ContextType, RequireFields<MutationDeleteChartArgs, 'id'>>;
  deleteChartTab?: Resolver<ResolversTypes['ChartTabEntity'], ParentType, ContextType, RequireFields<MutationDeleteChartTabArgs, 'id'>>;
  deleteEmail?: Resolver<Maybe<ResolversTypes['EmailEntity']>, ParentType, ContextType, RequireFields<MutationDeleteEmailArgs, 'id'>>;
  deleteEvent?: Resolver<Maybe<ResolversTypes['EventEntity']>, ParentType, ContextType, RequireFields<MutationDeleteEventArgs, 'id'>>;
  deleteFile?: Resolver<Maybe<ResolversTypes['FileEntity']>, ParentType, ContextType, RequireFields<MutationDeleteFileArgs, 'id'>>;
  deleteLibrary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteLibraryArgs, 'id'>>;
  deleteMessage?: Resolver<Maybe<ResolversTypes['MessageEntity']>, ParentType, ContextType, RequireFields<MutationDeleteMessageArgs, 'id'>>;
  deleteNote?: Resolver<Maybe<ResolversTypes['NoteEntity']>, ParentType, ContextType, RequireFields<MutationDeleteNoteArgs, 'id'>>;
  deleteNotification?: Resolver<Maybe<ResolversTypes['NotificationEntity']>, ParentType, ContextType, RequireFields<MutationDeleteNotificationArgs, 'id'>>;
  deletePermission?: Resolver<Maybe<ResolversTypes['PermissionEntity']>, ParentType, ContextType, RequireFields<MutationDeletePermissionArgs, 'id'>>;
  deleteRole?: Resolver<Maybe<Array<ResolversTypes['RoleEntity']>>, ParentType, ContextType, RequireFields<MutationDeleteRoleArgs, 'ids'>>;
  deleteStudy?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType, RequireFields<MutationDeleteStudyArgs, 'id'>>;
  deleteStudyPermission?: Resolver<Maybe<ResolversTypes['StudyPermissionEntity']>, ParentType, ContextType, RequireFields<MutationDeleteStudyPermissionArgs, 'id'>>;
  deleteStudyRole?: Resolver<Maybe<ResolversTypes['StudyRoleEntity']>, ParentType, ContextType, RequireFields<MutationDeleteStudyRoleArgs, 'id'>>;
  deleteUser?: Resolver<Maybe<Array<ResolversTypes['UserEntity']>>, ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'ids'>>;
  deleteVoice?: Resolver<Maybe<ResolversTypes['VoiceEntity']>, ParentType, ContextType, RequireFields<MutationDeleteVoiceArgs, 'id'>>;
  inviteParticipant?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<MutationInviteParticipantArgs, 'data'>>;
  inviteStaff?: Resolver<Maybe<ResolversTypes['InviteStaffOutputType']>, ParentType, ContextType, RequireFields<MutationInviteStaffArgs, 'data' | 'studyId'>>;
  likeAllEmails?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationLikeAllEmailsArgs, 'user'>>;
  likeAllEvents?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationLikeAllEventsArgs, 'user'>>;
  likeAllMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationLikeAllMessagesArgs, 'user'>>;
  likeAllNotes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  likeAllNotifications?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationLikeAllNotificationsArgs, 'user'>>;
  likeAllVoices?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationLikeAllVoicesArgs, 'user'>>;
  manageChartTabs?: Resolver<ResolversTypes['ManageChartTabResponseType'], ParentType, ContextType, RequireFields<MutationManageChartTabsArgs, 'data' | 'userId'>>;
  requestStudyExport?: Resolver<ResolversTypes['ExportRequestOutputType'], ParentType, ContextType, RequireFields<MutationRequestStudyExportArgs, 'input'>>;
  resetPassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'newPassword' | 'token'>>;
  sendInviteEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSendInviteEmailArgs, 'email'>>;
  sendMMS?: Resolver<Maybe<Array<ResolversTypes['MessageEntity']>>, ParentType, ContextType, RequireFields<MutationSendMmsArgs, 'files' | 'text'>>;
  sendResetPasswordLink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSendResetPasswordLinkArgs, 'email'>>;
  sendSMS?: Resolver<Maybe<ResolversTypes['MessageEntity']>, ParentType, ContextType, RequireFields<MutationSendSmsArgs, 'text' | 'user'>>;
  sendVideoConferenceSMS?: Resolver<Maybe<ResolversTypes['MessageEntity']>, ParentType, ContextType, RequireFields<MutationSendVideoConferenceSmsArgs, 'user' | 'vonageSessionId'>>;
  shortenString?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationShortenStringArgs, 'originalString'>>;
  startConference?: Resolver<Maybe<ResolversTypes['ConferenceEntity']>, ParentType, ContextType, RequireFields<MutationStartConferenceArgs, 'type'>>;
  stopVideoCall?: Resolver<Maybe<ResolversTypes['ConferenceEntity']>, ParentType, ContextType, RequireFields<MutationStopVideoCallArgs, 'sessionId'>>;
  testOutboundCall?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unsubscribeUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUnsubscribeUserArgs, 'userId'>>;
  updateAssessmentAnswer?: Resolver<Maybe<ResolversTypes['AssessmentResponseEntity']>, ParentType, ContextType, RequireFields<MutationUpdateAssessmentAnswerArgs, 'id' | 'updateAssessmentAnswerInput'>>;
  updateAssessmentQuestion?: Resolver<Maybe<ResolversTypes['AssessmentQuestionEntity']>, ParentType, ContextType, RequireFields<MutationUpdateAssessmentQuestionArgs, 'id' | 'question'>>;
  updateAssessmentResponse?: Resolver<Maybe<ResolversTypes['AssessmentResponseEntity']>, ParentType, ContextType, RequireFields<MutationUpdateAssessmentResponseArgs, 'assessmentResponse' | 'id'>>;
  updateChart?: Resolver<Maybe<ResolversTypes['ChartEntity']>, ParentType, ContextType, RequireFields<MutationUpdateChartArgs, 'id' | 'payload'>>;
  updateChartTab?: Resolver<ResolversTypes['ChartTabEntity'], ParentType, ContextType, RequireFields<MutationUpdateChartTabArgs, 'id' | 'title'>>;
  updateCoachingEventStatus?: Resolver<Maybe<ResolversTypes['EventEntity']>, ParentType, ContextType, RequireFields<MutationUpdateCoachingEventStatusArgs, 'date' | 'id' | 'status'>>;
  updateConference?: Resolver<ResolversTypes['ConferenceEntity'], ParentType, ContextType, RequireFields<MutationUpdateConferenceArgs, 'id' | 'updateConferenceInput'>>;
  updateEmail?: Resolver<Maybe<ResolversTypes['EmailEntity']>, ParentType, ContextType, RequireFields<MutationUpdateEmailArgs, 'id' | 'updateEmailInput'>>;
  updateEvent?: Resolver<Maybe<ResolversTypes['EventEntity']>, ParentType, ContextType, RequireFields<MutationUpdateEventArgs, 'id' | 'updateEventInput'>>;
  updateFile?: Resolver<Maybe<ResolversTypes['FileEntity']>, ParentType, ContextType, RequireFields<MutationUpdateFileArgs, 'id' | 'updateFileInput'>>;
  updateLibrary?: Resolver<Maybe<ResolversTypes['LibraryEntity']>, ParentType, ContextType, RequireFields<MutationUpdateLibraryArgs, 'automations' | 'duration' | 'iconFile' | 'id' | 'initialMessage' | 'preIVRDuration' | 'preIVRDurationType' | 'title'>>;
  updateMessage?: Resolver<Maybe<ResolversTypes['MessageEntity']>, ParentType, ContextType, RequireFields<MutationUpdateMessageArgs, 'id' | 'updateMessageInput'>>;
  updateNote?: Resolver<Maybe<ResolversTypes['NoteEntity']>, ParentType, ContextType, RequireFields<MutationUpdateNoteArgs, 'files' | 'id' | 'updateNoteInput'>>;
  updateNotification?: Resolver<Maybe<ResolversTypes['NotificationEntity']>, ParentType, ContextType, RequireFields<MutationUpdateNotificationArgs, 'id' | 'updateNotificationInput'>>;
  updateNotificationPreference?: Resolver<Maybe<ResolversTypes['NotificationpPreferencesEntity']>, ParentType, ContextType, RequireFields<MutationUpdateNotificationPreferenceArgs, 'notificationPreference' | 'userId'>>;
  updatePermission?: Resolver<Maybe<ResolversTypes['PermissionEntity']>, ParentType, ContextType, RequireFields<MutationUpdatePermissionArgs, 'id' | 'permission'>>;
  updateRole?: Resolver<Maybe<ResolversTypes['RoleEntity']>, ParentType, ContextType, RequireFields<MutationUpdateRoleArgs, 'id' | 'role'>>;
  updateStudy?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType, RequireFields<MutationUpdateStudyArgs, 'id' | 'study' | 'updatedAtTimestamp'>>;
  updateStudyPermission?: Resolver<Maybe<ResolversTypes['StudyPermissionEntity']>, ParentType, ContextType, RequireFields<MutationUpdateStudyPermissionArgs, 'id' | 'updateStudyPermissionInput'>>;
  updateStudyRole?: Resolver<Maybe<ResolversTypes['StudyRoleEntity']>, ParentType, ContextType, RequireFields<MutationUpdateStudyRoleArgs, 'id' | 'updateStudyRoleInput'>>;
  updateUser?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'id' | 'user'>>;
  updateUserPermissions?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<MutationUpdateUserPermissionsArgs, 'userId' | 'userPermissions'>>;
  updateUserProfileDetail?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<MutationUpdateUserProfileDetailArgs, 'data' | 'id'>>;
  updateUserProfileInfoDetails?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<MutationUpdateUserProfileInfoDetailsArgs, 'data' | 'id'>>;
  updateUserProfileInformation?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<MutationUpdateUserProfileInformationArgs, 'data' | 'id'>>;
  updateVoice?: Resolver<Maybe<ResolversTypes['VoiceEntity']>, ParentType, ContextType, RequireFields<MutationUpdateVoiceArgs, 'id' | 'updateVoiceInput'>>;
  uploadIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationUploadIconArgs, 'iconFile'>>;
  validateDirectSignin?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<MutationValidateDirectSigninArgs, 'token'>>;
  verifyUser?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<MutationVerifyUserArgs, 'id'>>;
  viewAllEmails?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationViewAllEmailsArgs, 'user'>>;
  viewAllEvents?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationViewAllEventsArgs, 'user'>>;
  viewAllMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationViewAllMessagesArgs, 'user'>>;
  viewAllNotes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  viewAllNotifications?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationViewAllNotificationsArgs, 'user'>>;
  viewAllVoices?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, RequireFields<MutationViewAllVoicesArgs, 'user'>>;
};

export type NoteEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoteEntity'] = ResolversParentTypes['NoteEntity']> = {
  actions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assessmentResponse?: Resolver<Maybe<ResolversTypes['AssessmentResponseEntity']>, ParentType, ContextType>;
  conference?: Resolver<Maybe<ResolversTypes['ConferenceEntity']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  editor?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  entity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isPinned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  labels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotesOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotesOutput'] = ResolversParentTypes['NotesOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['NoteEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationEntity'] = ResolversParentTypes['NotificationEntity']> = {
  actions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isSubscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  labels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  study?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType>;
  studyArm?: Resolver<Maybe<ResolversTypes['StudyArmEntity']>, ParentType, ContextType>;
  studyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationpPreferencesEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationpPreferencesEntity'] = ResolversParentTypes['NotificationpPreferencesEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  subscription?: Resolver<ResolversTypes['UserSubscriptionEntity'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationsOutput'] = ResolversParentTypes['NotificationsOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['NotificationEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpentokAuthOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpentokAuthOutputType'] = ResolversParentTypes['OpentokAuthOutputType']> = {
  apiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ParticipantExportDataOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ParticipantExportDataOutputType'] = ResolversParentTypes['ParticipantExportDataOutputType']> = {
  avgActiveMinutes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  avgSteps?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  chatMessages?: Resolver<Array<ResolversTypes['ChatMessageDetailOutputType']>, ParentType, ContextType>;
  coachingCalls?: Resolver<Array<ResolversTypes['CoachingCallDetailOutputType']>, ParentType, ContextType>;
  communicationCalls?: Resolver<Array<ResolversTypes['CommunicationCallDetailOutputType']>, ParentType, ContextType>;
  dateAddedToArm?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  emails?: Resolver<Array<ResolversTypes['EmailDetailOutputType']>, ParentType, ContextType>;
  fitbitData?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  hoursOfCall?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isFitbitSyncedInPeriod?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ivrCalls?: Resolver<Array<ResolversTypes['IvrCallDetailOutputType']>, ParentType, ContextType>;
  journalEntries?: Resolver<Array<ResolversTypes['JournalEntryDetailOutputType']>, ParentType, ContextType>;
  numberOfEmails?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfMessages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  participantExternalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  participantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  participantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  studyArmId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  studyArmName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  studyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  studyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PermissionEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PermissionEntity'] = ResolversParentTypes['PermissionEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PermissionOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PermissionOutputType'] = ResolversParentTypes['PermissionOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['PermissionEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneNumberEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumberEntity'] = ResolversParentTypes['PhoneNumberEntity']> = {
  country?: Resolver<Maybe<ResolversTypes['CountryPhoneNumberEntity']>, ParentType, ContextType>;
  countryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPreferred?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  adherenceMetrics?: Resolver<ResolversTypes['MetricsAdherenceOutput'], ParentType, ContextType, RequireFields<QueryAdherenceMetricsArgs, 'fromDate' | 'studyArmsId' | 'toDate' | 'type' | 'userId'>>;
  allJournals?: Resolver<ResolversTypes['LibraryOutputType'], ParentType, ContextType, RequireFields<QueryAllJournalsArgs, 'limit' | 'where'>>;
  archiveSession?: Resolver<Maybe<ResolversTypes['ArchiveOutput']>, ParentType, ContextType, RequireFields<QueryArchiveSessionArgs, 'sessionId' | 'value'>>;
  assessmentAnsweredResponse?: Resolver<Array<ResolversTypes['AssessmentsAnsweredResponseOutputType']>, ParentType, ContextType, RequireFields<QueryAssessmentAnsweredResponseArgs, 'endDate' | 'libraryId' | 'startDate' | 'userId'>>;
  assessmentAnsweredResponses?: Resolver<Array<ResolversTypes['AssessmentsAnsweredResponseOutputType']>, ParentType, ContextType, RequireFields<QueryAssessmentAnsweredResponsesArgs, 'endDate' | 'libraryIds' | 'startDate' | 'userId'>>;
  assessmentQuestion?: Resolver<Maybe<ResolversTypes['AssessmentQuestionEntity']>, ParentType, ContextType, RequireFields<QueryAssessmentQuestionArgs, 'id'>>;
  assessmentQuestions?: Resolver<ResolversTypes['AssessmentQuestionOutputType'], ParentType, ContextType, RequireFields<QueryAssessmentQuestionsArgs, 'limit' | 'where'>>;
  assessmentResponse?: Resolver<Maybe<ResolversTypes['AssessmentResponseEntity']>, ParentType, ContextType, RequireFields<QueryAssessmentResponseArgs, 'id'>>;
  assessmentResponses?: Resolver<ResolversTypes['AssessmentResponseOutputType'], ParentType, ContextType, RequireFields<QueryAssessmentResponsesArgs, 'limit' | 'where'>>;
  audit?: Resolver<Maybe<ResolversTypes['AuditEntity']>, ParentType, ContextType, RequireFields<QueryAuditArgs, 'id'>>;
  audits?: Resolver<ResolversTypes['AuditOutput'], ParentType, ContextType, RequireFields<QueryAuditsArgs, 'limit' | 'where'>>;
  callConferences?: Resolver<ResolversTypes['ConferenceWithUsersOutputType'], ParentType, ContextType, RequireFields<QueryCallConferencesArgs, 'correspondingUser' | 'limit' | 'search' | 'studyId' | 'user' | 'where'>>;
  canDeleteLibrary?: Resolver<Maybe<ResolversTypes['CanDeleteLibraryOutputType']>, ParentType, ContextType, RequireFields<QueryCanDeleteLibraryArgs, 'id'>>;
  chartTabs?: Resolver<Array<ResolversTypes['ChartTabOutputType']>, ParentType, ContextType, RequireFields<QueryChartTabsArgs, 'chartCount' | 'userId'>>;
  clinicIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  coachingAssessmentForNotes?: Resolver<ResolversTypes['CoachingAssessmentForNotesOutput'], ParentType, ContextType, RequireFields<QueryCoachingAssessmentForNotesArgs, 'userId'>>;
  coachingEvents?: Resolver<Array<ResolversTypes['CoachingEvents']>, ParentType, ContextType, RequireFields<QueryCoachingEventsArgs, 'userId'>>;
  conference?: Resolver<Maybe<ResolversTypes['ConferenceEntity']>, ParentType, ContextType, RequireFields<QueryConferenceArgs, 'id'>>;
  conferences?: Resolver<ResolversTypes['ConferenceOutputType'], ParentType, ContextType, RequireFields<QueryConferencesArgs, 'limit' | 'where'>>;
  countEmails?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryCountEmailsArgs, 'search' | 'type' | 'user' | 'where'>>;
  countEvents?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryCountEventsArgs, 'search' | 'type' | 'user' | 'where'>>;
  countFiles?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryCountFilesArgs, 'where'>>;
  countMessages?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryCountMessagesArgs, 'search' | 'type' | 'user' | 'where'>>;
  countNotes?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryCountNotesArgs, 'where'>>;
  countNotifications?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryCountNotificationsArgs, 'search' | 'studyArmId' | 'studyId' | 'subscribed' | 'user' | 'where'>>;
  countVoices?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryCountVoicesArgs, 'search' | 'type' | 'user' | 'where'>>;
  dailyAssessments?: Resolver<ResolversTypes['LibraryOutputType'], ParentType, ContextType>;
  dailyJournals?: Resolver<ResolversTypes['LibraryOutputType'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['EmailEntity']>, ParentType, ContextType, RequireFields<QueryEmailArgs, 'id'>>;
  emails?: Resolver<ResolversTypes['EmailsOutput'], ParentType, ContextType, RequireFields<QueryEmailsArgs, 'correspondingUser' | 'limit' | 'search' | 'studyArmId' | 'studyId' | 'type' | 'user' | 'where'>>;
  event?: Resolver<Maybe<ResolversTypes['EventEntity']>, ParentType, ContextType, RequireFields<QueryEventArgs, 'id'>>;
  events?: Resolver<ResolversTypes['EventsOutput'], ParentType, ContextType, RequireFields<QueryEventsArgs, 'correspondingUser' | 'limit' | 'search' | 'studyArmId' | 'studyId' | 'type' | 'user' | 'where'>>;
  exportMessages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fetchOriginalString?: Resolver<ResolversTypes['StringShortenOutputType'], ParentType, ContextType, RequireFields<QueryFetchOriginalStringArgs, 'token'>>;
  file?: Resolver<Maybe<ResolversTypes['FileEntity']>, ParentType, ContextType, RequireFields<QueryFileArgs, 'id'>>;
  files?: Resolver<ResolversTypes['FilesOutput'], ParentType, ContextType, RequireFields<QueryFilesArgs, 'limit' | 'where'>>;
  fitbitActivities?: Resolver<ResolversTypes['FitbitEntity'], ParentType, ContextType, RequireFields<QueryFitbitActivitiesArgs, 'date' | 'userId'>>;
  fitbitActivitiesList?: Resolver<Array<ResolversTypes['FitbitActivityEntity']>, ParentType, ContextType, RequireFields<QueryFitbitActivitiesListArgs, 'fromDate' | 'toDate' | 'userId'>>;
  fitbitActivitiesTrend?: Resolver<Array<ResolversTypes['FitbitActivityTrendData']>, ParentType, ContextType, RequireFields<QueryFitbitActivitiesTrendArgs, 'parameters'>>;
  fitbitChartsData?: Resolver<ResolversTypes['FitbitChartsData'], ParentType, ContextType, RequireFields<QueryFitbitChartsDataArgs, 'fromDate' | 'toDate' | 'userId'>>;
  fitbitDistanceList?: Resolver<Array<ResolversTypes['FitbitDistanceEntity']>, ParentType, ContextType, RequireFields<QueryFitbitDistanceListArgs, 'fromDate' | 'toDate' | 'userId'>>;
  fitbitHeartRateList?: Resolver<Array<ResolversTypes['FitbitHeartRateEntity']>, ParentType, ContextType, RequireFields<QueryFitbitHeartRateListArgs, 'fromDate' | 'toDate' | 'userId'>>;
  fitbitHistory?: Resolver<Array<ResolversTypes['FitbitHistoryEntity']>, ParentType, ContextType, RequireFields<QueryFitbitHistoryArgs, 'fromDate' | 'toDate'>>;
  fitbitHistoryByUser?: Resolver<Array<ResolversTypes['FitbitHistoryEntity']>, ParentType, ContextType, RequireFields<QueryFitbitHistoryByUserArgs, 'fromDate' | 'toDate' | 'userId'>>;
  fitbitLifetimeStats?: Resolver<Array<ResolversTypes['FitbitLifetimeStats']>, ParentType, ContextType, RequireFields<QueryFitbitLifetimeStatsArgs, 'userId'>>;
  fitbitSleepList?: Resolver<Array<ResolversTypes['FitbitSleepEntity']>, ParentType, ContextType, RequireFields<QueryFitbitSleepListArgs, 'fromDate' | 'toDate' | 'userId'>>;
  fitbitStepsList?: Resolver<Array<ResolversTypes['FitbitStepsEntity']>, ParentType, ContextType, RequireFields<QueryFitbitStepsListArgs, 'fromDate' | 'toDate' | 'userId'>>;
  fitbitWeightList?: Resolver<Array<ResolversTypes['FitbitWeightEntity']>, ParentType, ContextType, RequireFields<QueryFitbitWeightListArgs, 'fromDate' | 'toDate' | 'userId'>>;
  getCharts?: Resolver<Maybe<Array<ResolversTypes['ChartEntity']>>, ParentType, ContextType, RequireFields<QueryGetChartsArgs, 'categoryId' | 'userId'>>;
  getExportFileContent?: Resolver<ResolversTypes['ExportFileContentResponseType'], ParentType, ContextType, RequireFields<QueryGetExportFileContentArgs, 'exportRequestId' | 'fileName'>>;
  getExportRequestDetails?: Resolver<ResolversTypes['ExportRequestOutputType'], ParentType, ContextType, RequireFields<QueryGetExportRequestDetailsArgs, 'id'>>;
  getProfileEvents?: Resolver<Array<ResolversTypes['EventWithTimeWindow']>, ParentType, ContextType, RequireFields<QueryGetProfileEventsArgs, 'limit' | 'studyId' | 'user' | 'where'>>;
  getScheduledEvents?: Resolver<Array<ResolversTypes['EventWithTimeWindow']>, ParentType, ContextType, RequireFields<QueryGetScheduledEventsArgs, 'studyArmsIds'>>;
  graphDataPoints?: Resolver<ResolversTypes['GraphDataPointsOutput'], ParentType, ContextType, RequireFields<QueryGraphDataPointsArgs, 'payload'>>;
  hello?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryHelloArgs, 'name'>>;
  libraries?: Resolver<ResolversTypes['LibraryOutputType'], ParentType, ContextType, RequireFields<QueryLibrariesArgs, 'limit' | 'showOnlyQuestions' | 'studyId' | 'where'>>;
  library?: Resolver<Maybe<ResolversTypes['LibraryEntity']>, ParentType, ContextType, RequireFields<QueryLibraryArgs, 'id'>>;
  libraryWithToken?: Resolver<Maybe<ResolversTypes['LibraryEntity']>, ParentType, ContextType, RequireFields<QueryLibraryWithTokenArgs, 'token'>>;
  medication?: Resolver<Maybe<ResolversTypes['MedicationEntity']>, ParentType, ContextType, RequireFields<QueryMedicationArgs, 'id'>>;
  medications?: Resolver<ResolversTypes['MedicationOutputType'], ParentType, ContextType, RequireFields<QueryMedicationsArgs, 'limit' | 'where'>>;
  message?: Resolver<Maybe<ResolversTypes['MessageEntity']>, ParentType, ContextType, RequireFields<QueryMessageArgs, 'id'>>;
  messages?: Resolver<ResolversTypes['MessagesOutput'], ParentType, ContextType, RequireFields<QueryMessagesArgs, 'correspondingUser' | 'limit' | 'search' | 'studyArmId' | 'studyId' | 'type' | 'user' | 'where'>>;
  metricsConferences?: Resolver<ResolversTypes['MetricsOutputType'], ParentType, ContextType, RequireFields<QueryMetricsConferencesArgs, 'limit' | 'where'>>;
  metricsEvents?: Resolver<ResolversTypes['EventMetricsOutputType'], ParentType, ContextType, RequireFields<QueryMetricsEventsArgs, 'where'>>;
  metricsUsers?: Resolver<ResolversTypes['MetricsUsersOutputType'], ParentType, ContextType, RequireFields<QueryMetricsUsersArgs, 'studyArmId' | 'studyId'>>;
  myExportRequests?: Resolver<Array<ResolversTypes['ExportRequestOutputType']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['NoteEntity']>, ParentType, ContextType, RequireFields<QueryNoteArgs, 'conferenceId' | 'id' | 'userId'>>;
  notes?: Resolver<ResolversTypes['NotesOutput'], ParentType, ContextType, RequireFields<QueryNotesArgs, 'editor' | 'limit' | 'user' | 'where'>>;
  notification?: Resolver<Maybe<ResolversTypes['NotificationEntity']>, ParentType, ContextType, RequireFields<QueryNotificationArgs, 'id'>>;
  notifications?: Resolver<ResolversTypes['NotificationsOutput'], ParentType, ContextType, RequireFields<QueryNotificationsArgs, 'limit' | 'search' | 'studyArmId' | 'studyId' | 'subscribed' | 'user' | 'where'>>;
  opentokAuth?: Resolver<ResolversTypes['OpentokAuthOutputType'], ParentType, ContextType, Partial<QueryOpentokAuthArgs>>;
  participantCoachingLibrariesForDate?: Resolver<ResolversTypes['LibraryOutputType'], ParentType, ContextType, RequireFields<QueryParticipantCoachingLibrariesForDateArgs, 'date' | 'limit' | 'studyId' | 'userId' | 'where'>>;
  permission?: Resolver<Maybe<ResolversTypes['PermissionEntity']>, ParentType, ContextType, RequireFields<QueryPermissionArgs, 'id'>>;
  permissions?: Resolver<ResolversTypes['PermissionOutputType'], ParentType, ContextType, RequireFields<QueryPermissionsArgs, 'limit' | 'where'>>;
  questionCategories?: Resolver<ResolversTypes['QuestionCategoryOutputType'], ParentType, ContextType, RequireFields<QueryQuestionCategoriesArgs, 'limit' | 'where'>>;
  questionCategory?: Resolver<Maybe<ResolversTypes['QuestionCategoryEntity']>, ParentType, ContextType, RequireFields<QueryQuestionCategoryArgs, 'id'>>;
  role?: Resolver<Maybe<ResolversTypes['RoleEntity']>, ParentType, ContextType, RequireFields<QueryRoleArgs, 'id'>>;
  roles?: Resolver<ResolversTypes['RolesOutputType'], ParentType, ContextType, RequireFields<QueryRolesArgs, 'limit' | 'where'>>;
  searchAutomationWho?: Resolver<Array<ResolversTypes['AutomationWhoOutputType']>, ParentType, ContextType, RequireFields<QuerySearchAutomationWhoArgs, 'search'>>;
  searchRoles?: Resolver<Array<ResolversTypes['RoleEntity']>, ParentType, ContextType, RequireFields<QuerySearchRolesArgs, 'name' | 'staff'>>;
  studies?: Resolver<ResolversTypes['StudyOutputType'], ParentType, ContextType, RequireFields<QueryStudiesArgs, 'limit' | 'where'>>;
  studiesWithStudyArms?: Resolver<ResolversTypes['StudyOutputType'], ParentType, ContextType, RequireFields<QueryStudiesWithStudyArmsArgs, 'limit' | 'where'>>;
  study?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType, RequireFields<QueryStudyArgs, 'id' | 'showCoachesStudyArms' | 'showLibraryConfigs'>>;
  studyArm?: Resolver<Maybe<ResolversTypes['StudyArmEntity']>, ParentType, ContextType, RequireFields<QueryStudyArmArgs, 'id'>>;
  studyArmLibraryConfigs?: Resolver<Maybe<ResolversTypes['StudyArmLibraryConfigsEntity']>, ParentType, ContextType, RequireFields<QueryStudyArmLibraryConfigsArgs, 'id'>>;
  studyArms?: Resolver<ResolversTypes['StudyArmOutputType'], ParentType, ContextType, RequireFields<QueryStudyArmsArgs, 'limit' | 'where'>>;
  studyArmsByStaff?: Resolver<Array<ResolversTypes['StudyArmEntity']>, ParentType, ContextType, RequireFields<QueryStudyArmsByStaffArgs, 'studyId' | 'userId'>>;
  studyPermission?: Resolver<Maybe<ResolversTypes['StudyPermissionEntity']>, ParentType, ContextType, RequireFields<QueryStudyPermissionArgs, 'id'>>;
  studyPermissions?: Resolver<ResolversTypes['StudyPermissionsOutput'], ParentType, ContextType, RequireFields<QueryStudyPermissionsArgs, 'limit' | 'where'>>;
  studyRole?: Resolver<Maybe<ResolversTypes['StudyRoleEntity']>, ParentType, ContextType, RequireFields<QueryStudyRoleArgs, 'id'>>;
  studyRoles?: Resolver<ResolversTypes['StudyRoleOutput'], ParentType, ContextType, RequireFields<QueryStudyRolesArgs, 'limit' | 'where'>>;
  suggestedDate?: Resolver<Maybe<ResolversTypes['SuggestedDateEntity']>, ParentType, ContextType, RequireFields<QuerySuggestedDateArgs, 'where'>>;
  symptom?: Resolver<Maybe<ResolversTypes['SymptomEntity']>, ParentType, ContextType, RequireFields<QuerySymptomArgs, 'id'>>;
  symptoms?: Resolver<ResolversTypes['SymptomOutputType'], ParentType, ContextType, RequireFields<QuerySymptomsArgs, 'limit' | 'where'>>;
  syncFitbitData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QuerySyncFitbitDataArgs, 'fromDate' | 'toDate' | 'userId'>>;
  tooltip?: Resolver<Maybe<ResolversTypes['TooltipEntity']>, ParentType, ContextType, RequireFields<QueryTooltipArgs, 'id'>>;
  tooltips?: Resolver<ResolversTypes['TooltipOutputType'], ParentType, ContextType, RequireFields<QueryTooltipsArgs, 'limit' | 'where'>>;
  translate?: Resolver<Maybe<ResolversTypes['TranslateOutputType']>, ParentType, ContextType, RequireFields<QueryTranslateArgs, 'languageCode' | 'texts'>>;
  user?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<QueryUserArgs, 'email'>>;
  userConferences?: Resolver<ResolversTypes['UserConferencesOutputType'], ParentType, ContextType, RequireFields<QueryUserConferencesArgs, 'limit' | 'studyId'>>;
  userLogin?: Resolver<ResolversTypes['UserLoginOutputType'], ParentType, ContextType, RequireFields<QueryUserLoginArgs, 'email' | 'password' | 'token'>>;
  userProfileGeneralDetails?: Resolver<Maybe<ResolversTypes['UserProfileDetailType']>, ParentType, ContextType, RequireFields<QueryUserProfileGeneralDetailsArgs, 'id'>>;
  userProfileInfoDetails?: Resolver<Maybe<ResolversTypes['UserInfoDetailsOutputType']>, ParentType, ContextType, RequireFields<QueryUserProfileInfoDetailsArgs, 'id'>>;
  userProfileInformation?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType, RequireFields<QueryUserProfileInformationArgs, 'id'>>;
  userRegistration?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType, RequireFields<QueryUserRegistrationArgs, 'email' | 'name' | 'password'>>;
  userVerified?: Resolver<ResolversTypes['UserVerifiedInputType'], ParentType, ContextType, RequireFields<QueryUserVerifiedArgs, 'email'>>;
  users?: Resolver<ResolversTypes['UsersOutputType'], ParentType, ContextType, RequireFields<QueryUsersArgs, 'filterAssigned' | 'filterParticipants' | 'limit' | 'search' | 'sortByLatestMessages' | 'staff' | 'status' | 'studyId'>>;
  usersEmails?: Resolver<ResolversTypes['UsersOutputType'], ParentType, ContextType, RequireFields<QueryUsersEmailsArgs, 'limit' | 'search' | 'studyArmId' | 'studyId' | 'type'>>;
  usersEvents?: Resolver<ResolversTypes['UsersOutputType'], ParentType, ContextType, RequireFields<QueryUsersEventsArgs, 'limit' | 'search' | 'studyArmId' | 'studyId' | 'type'>>;
  usersMessages?: Resolver<ResolversTypes['UsersOutputType'], ParentType, ContextType, RequireFields<QueryUsersMessagesArgs, 'limit' | 'search' | 'studyArmId' | 'studyId' | 'type'>>;
  usersVoices?: Resolver<ResolversTypes['UsersOutputType'], ParentType, ContextType, RequireFields<QueryUsersVoicesArgs, 'limit' | 'search' | 'studyArmId' | 'studyId' | 'type'>>;
  voice?: Resolver<Maybe<ResolversTypes['VoiceEntity']>, ParentType, ContextType, RequireFields<QueryVoiceArgs, 'id'>>;
  voices?: Resolver<ResolversTypes['VoicesOutput'], ParentType, ContextType, RequireFields<QueryVoicesArgs, 'correspondingUser' | 'limit' | 'search' | 'studyArmId' | 'studyId' | 'user' | 'where'>>;
  vonageAuth?: Resolver<ResolversTypes['AuthOutputType'], ParentType, ContextType, RequireFields<QueryVonageAuthArgs, 'userId'>>;
};

export type QuestionCategoryEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestionCategoryEntity'] = ResolversParentTypes['QuestionCategoryEntity']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questions?: Resolver<Maybe<Array<ResolversTypes['AssessmentQuestionEntity']>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestionCategoryOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestionCategoryOutputType'] = ResolversParentTypes['QuestionCategoryOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['QuestionCategoryEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordingEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingEntity'] = ResolversParentTypes['RecordingEntity']> = {
  archiveId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  conversationUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  endTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  recordingUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recordingUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleEntity'] = ResolversParentTypes['RoleEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permissions?: Resolver<Maybe<Array<ResolversTypes['PermissionEntity']>>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RolesOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RolesOutputType'] = ResolversParentTypes['RolesOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['RoleEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffEntity'] = ResolversParentTypes['StaffEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['RoleEntity'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StreamResolvers<ContextType = any, ParentType extends ResolversParentTypes['Stream'] = ResolversParentTypes['Stream']> = {
  hasAudio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasVideo?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  streamId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StringShortenOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StringShortenOutputType'] = ResolversParentTypes['StringShortenOutputType']> = {
  originalString?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyArmEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyArmEntity'] = ResolversParentTypes['StudyArmEntity']> = {
  coaches?: Resolver<Maybe<Array<ResolversTypes['UserEntity']>>, ParentType, ContextType>;
  communications?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  libraryConfigs?: Resolver<Maybe<Array<ResolversTypes['StudyArmLibraryConfigsEntity']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  users?: Resolver<Maybe<Array<ResolversTypes['UserEntity']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyArmLibraryConfigsEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyArmLibraryConfigsEntity'] = ResolversParentTypes['StudyArmLibraryConfigsEntity']> = {
  afterStart?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  beforeStart?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  library?: Resolver<ResolversTypes['LibraryEntity'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  repeat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  repeatText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyArmOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyArmOutputType'] = ResolversParentTypes['StudyArmOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['StudyArmEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyEntity'] = ResolversParentTypes['StudyEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  irb?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  moduleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modules?: Resolver<Maybe<Array<ResolversTypes['LibraryEntity']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  staff?: Resolver<Maybe<Array<ResolversTypes['UserEntity']>>, ParentType, ContextType>;
  studyArms?: Resolver<Maybe<Array<ResolversTypes['StudyArmEntity']>>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyOutputType'] = ResolversParentTypes['StudyOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['StudyEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyPermissionEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyPermissionEntity'] = ResolversParentTypes['StudyPermissionEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['PermissionEntity'], ParentType, ContextType>;
  permissionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  study?: Resolver<ResolversTypes['StudyEntity'], ParentType, ContextType>;
  studyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyPermissionsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyPermissionsOutput'] = ResolversParentTypes['StudyPermissionsOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['StudyPermissionEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyRoleEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyRoleEntity'] = ResolversParentTypes['StudyRoleEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['RoleEntity'], ParentType, ContextType>;
  study?: Resolver<ResolversTypes['StudyEntity'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyRoleOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyRoleOutput'] = ResolversParentTypes['StudyRoleOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['StudyRoleEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestedDateEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedDateEntity'] = ResolversParentTypes['SuggestedDateEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  endTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['EventEntity'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  suggester?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SymptomEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SymptomEntity'] = ResolversParentTypes['SymptomEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SymptomOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SymptomOutputType'] = ResolversParentTypes['SymptomOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SymptomEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TooltipEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['TooltipEntity'] = ResolversParentTypes['TooltipEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TooltipOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TooltipOutputType'] = ResolversParentTypes['TooltipOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['TooltipEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslateOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TranslateOutputType'] = ResolversParentTypes['TranslateOutputType']> = {
  texts?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TreatmentEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreatmentEntity'] = ResolversParentTypes['TreatmentEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  disease?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  treatmentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TypedExportFileContentTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TypedExportFileContentType'] = ResolversParentTypes['TypedExportFileContentType']> = {
  exportMetadata?: Resolver<ResolversTypes['ExportContentMetadataType'], ParentType, ContextType>;
  participants?: Resolver<Array<ResolversTypes['ParticipantExportDataOutputType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TypedExportedFileRecordTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TypedExportedFileRecordType'] = ResolversParentTypes['TypedExportedFileRecordType']> = {
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dataTypeDisplay?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expectedDataStructure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schemaVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserConferencesOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserConferencesOutputType'] = ResolversParentTypes['UserConferencesOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserEntity'] = ResolversParentTypes['UserEntity']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedStaff?: Resolver<Maybe<ResolversTypes['StaffEntity']>, ParentType, ContextType>;
  clinicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clinics?: Resolver<Maybe<Array<ResolversTypes['ClinicEntity']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  familyMembers?: Resolver<Maybe<Array<ResolversTypes['FamilyMemberEntity']>>, ParentType, ContextType>;
  fitbitAccessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitbitId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitbitRefreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitbitScopes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSubscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastMessageAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<ResolversTypes['NoteEntity']>>, ParentType, ContextType>;
  notificationPreferenceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<Array<ResolversTypes['StudyPermissionEntity']>>, ParentType, ContextType>;
  phoneNumbers?: Resolver<Maybe<Array<ResolversTypes['PhoneNumberEntity']>>, ParentType, ContextType>;
  preferredLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryRole?: Resolver<Maybe<ResolversTypes['RoleEntity']>, ParentType, ContextType>;
  privateNotes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  receiverEmails?: Resolver<Maybe<Array<ResolversTypes['EmailEntity']>>, ParentType, ContextType>;
  receiverMessages?: Resolver<Maybe<Array<ResolversTypes['MessageEntity']>>, ParentType, ContextType>;
  receiverNotifications?: Resolver<Maybe<Array<ResolversTypes['NotificationEntity']>>, ParentType, ContextType>;
  receiverVoices?: Resolver<Maybe<Array<ResolversTypes['VoiceEntity']>>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['StudyRoleEntity']>>, ParentType, ContextType>;
  senderEmails?: Resolver<Maybe<Array<ResolversTypes['EmailEntity']>>, ParentType, ContextType>;
  senderMessages?: Resolver<Maybe<Array<ResolversTypes['MessageEntity']>>, ParentType, ContextType>;
  senderNotifications?: Resolver<Maybe<Array<ResolversTypes['NotificationEntity']>>, ParentType, ContextType>;
  senderVoices?: Resolver<Maybe<Array<ResolversTypes['VoiceEntity']>>, ParentType, ContextType>;
  sexualOrientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  studies?: Resolver<Maybe<Array<ResolversTypes['StudyEntity']>>, ParentType, ContextType>;
  studyArmsId?: Resolver<Maybe<Array<ResolversTypes['Float']>>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<Array<ResolversTypes['TreatmentEntity']>>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  vonageName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vonageUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserInfoDetailsOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInfoDetailsOutputType'] = ResolversParentTypes['UserInfoDetailsOutputType']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedStaff?: Resolver<Maybe<ResolversTypes['StaffEntity']>, ParentType, ContextType>;
  clinicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clinics?: Resolver<Maybe<Array<ResolversTypes['ClinicEntity']>>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  familyMembers?: Resolver<Maybe<Array<ResolversTypes['FamilyMemberEntity']>>, ParentType, ContextType>;
  fitbitAccessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitbitId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitbitRefreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitbitScopes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  idNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSubscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastMessageAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<ResolversTypes['NoteEntity']>>, ParentType, ContextType>;
  notificationPreferenceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<Array<ResolversTypes['StudyPermissionEntity']>>, ParentType, ContextType>;
  phoneNumbers?: Resolver<Maybe<Array<ResolversTypes['PhoneNumberEntity']>>, ParentType, ContextType>;
  preferredLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryRole?: Resolver<Maybe<ResolversTypes['RoleEntity']>, ParentType, ContextType>;
  privateNotes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  receiverEmails?: Resolver<Maybe<Array<ResolversTypes['EmailEntity']>>, ParentType, ContextType>;
  receiverMessages?: Resolver<Maybe<Array<ResolversTypes['MessageEntity']>>, ParentType, ContextType>;
  receiverNotifications?: Resolver<Maybe<Array<ResolversTypes['NotificationEntity']>>, ParentType, ContextType>;
  receiverVoices?: Resolver<Maybe<Array<ResolversTypes['VoiceEntity']>>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['StudyRoleEntity']>>, ParentType, ContextType>;
  senderEmails?: Resolver<Maybe<Array<ResolversTypes['EmailEntity']>>, ParentType, ContextType>;
  senderMessages?: Resolver<Maybe<Array<ResolversTypes['MessageEntity']>>, ParentType, ContextType>;
  senderNotifications?: Resolver<Maybe<Array<ResolversTypes['NotificationEntity']>>, ParentType, ContextType>;
  senderVoices?: Resolver<Maybe<Array<ResolversTypes['VoiceEntity']>>, ParentType, ContextType>;
  sexualOrientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  studies?: Resolver<Maybe<Array<ResolversTypes['StudyEntity']>>, ParentType, ContextType>;
  studyArm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  studyArmsId?: Resolver<Maybe<Array<ResolversTypes['Float']>>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<Array<ResolversTypes['TreatmentEntity']>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  vonageName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vonageUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLoginOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLoginOutputType'] = ResolversParentTypes['UserLoginOutputType']> = {
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserProfileDetailTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserProfileDetailType'] = ResolversParentTypes['UserProfileDetailType']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedStaff?: Resolver<Maybe<ResolversTypes['StaffEntity']>, ParentType, ContextType>;
  clinicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clinics?: Resolver<Maybe<Array<ResolversTypes['ClinicEntity']>>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  familyMembers?: Resolver<Maybe<Array<ResolversTypes['FamilyMemberEntity']>>, ParentType, ContextType>;
  fitbitAccessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitbitId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitbitRefreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fitbitScopes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  idNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSubscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastMessageAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<ResolversTypes['NoteEntity']>>, ParentType, ContextType>;
  notificationPreferenceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<Array<ResolversTypes['StudyPermissionEntity']>>, ParentType, ContextType>;
  phoneNumbers?: Resolver<Maybe<Array<ResolversTypes['PhoneNumberEntity']>>, ParentType, ContextType>;
  preferredLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryRole?: Resolver<Maybe<ResolversTypes['RoleEntity']>, ParentType, ContextType>;
  privateNotes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  receiverEmails?: Resolver<Maybe<Array<ResolversTypes['EmailEntity']>>, ParentType, ContextType>;
  receiverMessages?: Resolver<Maybe<Array<ResolversTypes['MessageEntity']>>, ParentType, ContextType>;
  receiverNotifications?: Resolver<Maybe<Array<ResolversTypes['NotificationEntity']>>, ParentType, ContextType>;
  receiverVoices?: Resolver<Maybe<Array<ResolversTypes['VoiceEntity']>>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['StudyRoleEntity']>>, ParentType, ContextType>;
  senderEmails?: Resolver<Maybe<Array<ResolversTypes['EmailEntity']>>, ParentType, ContextType>;
  senderMessages?: Resolver<Maybe<Array<ResolversTypes['MessageEntity']>>, ParentType, ContextType>;
  senderNotifications?: Resolver<Maybe<Array<ResolversTypes['NotificationEntity']>>, ParentType, ContextType>;
  senderVoices?: Resolver<Maybe<Array<ResolversTypes['VoiceEntity']>>, ParentType, ContextType>;
  sexualOrientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  studies?: Resolver<Maybe<Array<ResolversTypes['StudyEntity']>>, ParentType, ContextType>;
  studyArmsId?: Resolver<Maybe<Array<ResolversTypes['Float']>>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treatments?: Resolver<Maybe<Array<ResolversTypes['TreatmentEntity']>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  vonageName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vonageUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionEntity'] = ResolversParentTypes['UserSubscriptionEntity']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fromUser?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSubscribed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notificationPreference?: Resolver<ResolversTypes['NotificationpPreferencesEntity'], ParentType, ContextType>;
  toUser?: Resolver<ResolversTypes['UserEntity'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserVerifiedInputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserVerifiedInputType'] = ResolversParentTypes['UserVerifiedInputType']> = {
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersOutputType'] = ResolversParentTypes['UsersOutputType']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoiceEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoiceEntity'] = ResolversParentTypes['VoiceEntity']> = {
  actions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  audioUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  labels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  receiver?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  receiverId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['UserEntity']>, ParentType, ContextType>;
  senderId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  study?: Resolver<Maybe<ResolversTypes['StudyEntity']>, ParentType, ContextType>;
  studyArm?: Resolver<Maybe<ResolversTypes['StudyArmEntity']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoicesOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoicesOutput'] = ResolversParentTypes['VoicesOutput']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['VoiceEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ActivityLevel?: ActivityLevelResolvers<ContextType>;
  ArchiveOutput?: ArchiveOutputResolvers<ContextType>;
  AssessmentAnswerEntity?: AssessmentAnswerEntityResolvers<ContextType>;
  AssessmentQuestionEntity?: AssessmentQuestionEntityResolvers<ContextType>;
  AssessmentQuestionOutputType?: AssessmentQuestionOutputTypeResolvers<ContextType>;
  AssessmentResponseEntity?: AssessmentResponseEntityResolvers<ContextType>;
  AssessmentResponseOutputType?: AssessmentResponseOutputTypeResolvers<ContextType>;
  AssessmentsAnsweredResponseOutputType?: AssessmentsAnsweredResponseOutputTypeResolvers<ContextType>;
  AuditEntity?: AuditEntityResolvers<ContextType>;
  AuditOutput?: AuditOutputResolvers<ContextType>;
  AuthOutputType?: AuthOutputTypeResolvers<ContextType>;
  AutomationWhoOutputType?: AutomationWhoOutputTypeResolvers<ContextType>;
  CallRecordingOutputType?: CallRecordingOutputTypeResolvers<ContextType>;
  CanDeleteLibraryOutputType?: CanDeleteLibraryOutputTypeResolvers<ContextType>;
  ChartEntity?: ChartEntityResolvers<ContextType>;
  ChartTabEntity?: ChartTabEntityResolvers<ContextType>;
  ChartTabOutputType?: ChartTabOutputTypeResolvers<ContextType>;
  ChatMessageDetailOutputType?: ChatMessageDetailOutputTypeResolvers<ContextType>;
  ClinicEntity?: ClinicEntityResolvers<ContextType>;
  CoachingAssessmentForNotesOutput?: CoachingAssessmentForNotesOutputResolvers<ContextType>;
  CoachingCallDetailOutputType?: CoachingCallDetailOutputTypeResolvers<ContextType>;
  CoachingEvents?: CoachingEventsResolvers<ContextType>;
  CommunicationCallDetailOutputType?: CommunicationCallDetailOutputTypeResolvers<ContextType>;
  CommunicationCallParticipantType?: CommunicationCallParticipantTypeResolvers<ContextType>;
  ConferenceEntity?: ConferenceEntityResolvers<ContextType>;
  ConferenceOutputType?: ConferenceOutputTypeResolvers<ContextType>;
  ConferenceWithUsersOutputType?: ConferenceWithUsersOutputTypeResolvers<ContextType>;
  ConferenceWithUsersRelation?: ConferenceWithUsersRelationResolvers<ContextType>;
  CountryPhoneNumberEntity?: CountryPhoneNumberEntityResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  EmailDetailOutputType?: EmailDetailOutputTypeResolvers<ContextType>;
  EmailEntity?: EmailEntityResolvers<ContextType>;
  EmailsOutput?: EmailsOutputResolvers<ContextType>;
  EventEntity?: EventEntityResolvers<ContextType>;
  EventMetricsOutputType?: EventMetricsOutputTypeResolvers<ContextType>;
  EventWithTimeWindow?: EventWithTimeWindowResolvers<ContextType>;
  EventsOutput?: EventsOutputResolvers<ContextType>;
  ExportContentMetadataType?: ExportContentMetadataTypeResolvers<ContextType>;
  ExportFileContentMetadataType?: ExportFileContentMetadataTypeResolvers<ContextType>;
  ExportFileContentResponseType?: ExportFileContentResponseTypeResolvers<ContextType>;
  ExportRequestOutputType?: ExportRequestOutputTypeResolvers<ContextType>;
  ExportedFileRecordType?: ExportedFileRecordTypeResolvers<ContextType>;
  FamilyMemberEntity?: FamilyMemberEntityResolvers<ContextType>;
  FileEntity?: FileEntityResolvers<ContextType>;
  FilesOutput?: FilesOutputResolvers<ContextType>;
  FitbitActivityEntity?: FitbitActivityEntityResolvers<ContextType>;
  FitbitActivityTrendData?: FitbitActivityTrendDataResolvers<ContextType>;
  FitbitChartsData?: FitbitChartsDataResolvers<ContextType>;
  FitbitDistanceEntity?: FitbitDistanceEntityResolvers<ContextType>;
  FitbitEntity?: FitbitEntityResolvers<ContextType>;
  FitbitHeartRateEntity?: FitbitHeartRateEntityResolvers<ContextType>;
  FitbitHistoryEntity?: FitbitHistoryEntityResolvers<ContextType>;
  FitbitLifetimeStats?: FitbitLifetimeStatsResolvers<ContextType>;
  FitbitSleepEntity?: FitbitSleepEntityResolvers<ContextType>;
  FitbitStepsEntity?: FitbitStepsEntityResolvers<ContextType>;
  FitbitWeightEntity?: FitbitWeightEntityResolvers<ContextType>;
  GraphDataPointsOutput?: GraphDataPointsOutputResolvers<ContextType>;
  InviteStaffOutputType?: InviteStaffOutputTypeResolvers<ContextType>;
  IvrCallDetailOutputType?: IvrCallDetailOutputTypeResolvers<ContextType>;
  IvrQuestionAnswerOutputType?: IvrQuestionAnswerOutputTypeResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JSONObject?: GraphQLScalarType;
  JournalEntryDetailOutputType?: JournalEntryDetailOutputTypeResolvers<ContextType>;
  LibraryEntity?: LibraryEntityResolvers<ContextType>;
  LibraryOutputType?: LibraryOutputTypeResolvers<ContextType>;
  ManageChartTabResponseType?: ManageChartTabResponseTypeResolvers<ContextType>;
  MedicationEntity?: MedicationEntityResolvers<ContextType>;
  MedicationOutputType?: MedicationOutputTypeResolvers<ContextType>;
  MessageEntity?: MessageEntityResolvers<ContextType>;
  MessagesOutput?: MessagesOutputResolvers<ContextType>;
  MetricsAdherence?: MetricsAdherenceResolvers<ContextType>;
  MetricsAdherenceOutput?: MetricsAdherenceOutputResolvers<ContextType>;
  MetricsOutputType?: MetricsOutputTypeResolvers<ContextType>;
  MetricsUsersOutputType?: MetricsUsersOutputTypeResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NoteEntity?: NoteEntityResolvers<ContextType>;
  NotesOutput?: NotesOutputResolvers<ContextType>;
  NotificationEntity?: NotificationEntityResolvers<ContextType>;
  NotificationpPreferencesEntity?: NotificationpPreferencesEntityResolvers<ContextType>;
  NotificationsOutput?: NotificationsOutputResolvers<ContextType>;
  OpentokAuthOutputType?: OpentokAuthOutputTypeResolvers<ContextType>;
  ParticipantExportDataOutputType?: ParticipantExportDataOutputTypeResolvers<ContextType>;
  PermissionEntity?: PermissionEntityResolvers<ContextType>;
  PermissionOutputType?: PermissionOutputTypeResolvers<ContextType>;
  PhoneNumberEntity?: PhoneNumberEntityResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QuestionCategoryEntity?: QuestionCategoryEntityResolvers<ContextType>;
  QuestionCategoryOutputType?: QuestionCategoryOutputTypeResolvers<ContextType>;
  RecordingEntity?: RecordingEntityResolvers<ContextType>;
  RoleEntity?: RoleEntityResolvers<ContextType>;
  RolesOutputType?: RolesOutputTypeResolvers<ContextType>;
  StaffEntity?: StaffEntityResolvers<ContextType>;
  Stream?: StreamResolvers<ContextType>;
  StringShortenOutputType?: StringShortenOutputTypeResolvers<ContextType>;
  StudyArmEntity?: StudyArmEntityResolvers<ContextType>;
  StudyArmLibraryConfigsEntity?: StudyArmLibraryConfigsEntityResolvers<ContextType>;
  StudyArmOutputType?: StudyArmOutputTypeResolvers<ContextType>;
  StudyEntity?: StudyEntityResolvers<ContextType>;
  StudyOutputType?: StudyOutputTypeResolvers<ContextType>;
  StudyPermissionEntity?: StudyPermissionEntityResolvers<ContextType>;
  StudyPermissionsOutput?: StudyPermissionsOutputResolvers<ContextType>;
  StudyRoleEntity?: StudyRoleEntityResolvers<ContextType>;
  StudyRoleOutput?: StudyRoleOutputResolvers<ContextType>;
  SuggestedDateEntity?: SuggestedDateEntityResolvers<ContextType>;
  SymptomEntity?: SymptomEntityResolvers<ContextType>;
  SymptomOutputType?: SymptomOutputTypeResolvers<ContextType>;
  TooltipEntity?: TooltipEntityResolvers<ContextType>;
  TooltipOutputType?: TooltipOutputTypeResolvers<ContextType>;
  TranslateOutputType?: TranslateOutputTypeResolvers<ContextType>;
  TreatmentEntity?: TreatmentEntityResolvers<ContextType>;
  TypedExportFileContentType?: TypedExportFileContentTypeResolvers<ContextType>;
  TypedExportedFileRecordType?: TypedExportedFileRecordTypeResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  UserConferencesOutputType?: UserConferencesOutputTypeResolvers<ContextType>;
  UserEntity?: UserEntityResolvers<ContextType>;
  UserInfoDetailsOutputType?: UserInfoDetailsOutputTypeResolvers<ContextType>;
  UserLoginOutputType?: UserLoginOutputTypeResolvers<ContextType>;
  UserProfileDetailType?: UserProfileDetailTypeResolvers<ContextType>;
  UserSubscriptionEntity?: UserSubscriptionEntityResolvers<ContextType>;
  UserVerifiedInputType?: UserVerifiedInputTypeResolvers<ContextType>;
  UsersOutputType?: UsersOutputTypeResolvers<ContextType>;
  VoiceEntity?: VoiceEntityResolvers<ContextType>;
  VoicesOutput?: VoicesOutputResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  oneOf?: OneOfDirectiveResolver<any, any, ContextType>;
};


type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export function AssessmentAnswerInputTypeSchema(): z.ZodObject<Properties<AssessmentAnswerInputType>> {
  return z.object<Properties<AssessmentAnswerInputType>>({
    answerDate: definedNonNullAnySchema.nullish(),
    comment: z.string().nullish(),
    id: z.number().nullish(),
    questionId: z.number(),
    value: definedNonNullAnySchema.nullish(),
    values: z.array(z.string()).nullish()
  })
}

export function AssessmentQuestionInputTypeSchema(): z.ZodObject<Properties<AssessmentQuestionInputType>> {
  return z.object<Properties<AssessmentQuestionInputType>>({
    automation: definedNonNullAnySchema.nullish(),
    category: z.lazy(() => definedNonNullAnySchema.nullish()),
    conditions: z.string().nullish(),
    createdAt: definedNonNullAnySchema.nullish(),
    deletedAt: definedNonNullAnySchema.nullish(),
    icon: z.string().nullish(),
    id: z.string().nullish(),
    identifier: z.string().nullish(),
    isAnswered: z.boolean().nullish(),
    label: z.string().nullish(),
    meta: definedNonNullAnySchema.nullish(),
    options: z.string().nullish(),
    order: z.number().nullish(),
    questions: z.array(z.lazy(() => definedNonNullAnySchema)).nullish(),
    symptomName: z.string().nullish(),
    symptomNameEs: z.string().nullish(),
    tooltip: z.lazy(() => definedNonNullAnySchema.nullish()),
    type: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish(),
    variableName: z.string().nullish()
  })
}

export function AssessmentQuestionWhereInputTypeSchema(): z.ZodObject<Properties<AssessmentQuestionWhereInputType>> {
  return z.object<Properties<AssessmentQuestionWhereInputType>>({
    id: z.number().nullish(),
    identifier: z.string().nullish(),
    label: z.string().nullish(),
    type: z.string().nullish(),
    variableName: z.string().nullish()
  })
}

export function AssessmentResponseInputTypeSchema(): z.ZodObject<Properties<AssessmentResponseInputType>> {
  return z.object<Properties<AssessmentResponseInputType>>({
    answerDate: definedNonNullAnySchema.nullish(),
    answers: z.array(z.lazy(() => definedNonNullAnySchema)),
    conversationUUID: z.string().nullish(),
    library: z.number(),
    preIVRQuestionsRequired: z.boolean().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    user: z.number().nullish()
  })
}

export function AssessmentResponseWithTokenInputTypeSchema(): z.ZodObject<Properties<AssessmentResponseWithTokenInputType>> {
  return z.object<Properties<AssessmentResponseWithTokenInputType>>({
    answers: z.array(z.lazy(() => definedNonNullAnySchema))
  })
}

export function AssessmentResponsesWhereInputTypeSchema(): z.ZodObject<Properties<AssessmentResponsesWhereInputType>> {
  return z.object<Properties<AssessmentResponsesWhereInputType>>({
    answerDate: definedNonNullAnySchema.nullish(),
    conversationUUID: z.string().nullish(),
    id: z.number().nullish(),
    libraryId: z.number().nullish(),
    libraryIds: z.array(z.number()).nullish(),
    userId: z.number().nullish()
  })
}

export function AssignedStaffInputTypeSchema(): z.ZodObject<Properties<AssignedStaffInputType>> {
  return z.object<Properties<AssignedStaffInputType>>({
    id: z.string(),
    name: z.string().nullish(),
    role: z.lazy(() => definedNonNullAnySchema.nullish())
  })
}

export function AuditInputSchema(): z.ZodObject<Properties<AuditInput>> {
  return z.object<Properties<AuditInput>>({
    action: z.string().nullish(),
    id: z.number().nullish(),
    newData: z.string().nullish(),
    notify: z.boolean().nullish(),
    oldData: z.string().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    tableName: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish(),
    userId: z.number().nullish()
  })
}

export function AutomationActionTypeSchema(): z.ZodObject<Properties<AutomationActionType>> {
  return z.object<Properties<AutomationActionType>>({
    data: z.string().nullish(),
    do: z.string(),
    where: z.string(),
    who: z.array(definedNonNullAnySchema)
  })
}

export function AutomationActionWhoTypeSchema(): z.ZodObject<Properties<AutomationActionWhoType>> {
  return z.object<Properties<AutomationActionWhoType>>({
    id: z.number(),
    name: z.string(),
    type: z.string()
  })
}

export function AutomationConditionTypeSchema(): z.ZodObject<Properties<AutomationConditionType>> {
  return z.object<Properties<AutomationConditionType>>({
    logic: z.string(),
    operator: z.string(),
    question: z.string(),
    value: z.string(),
    what: z.string()
  })
}

export function AutomationInputTypeSchema(): z.ZodObject<Properties<AutomationInputType>> {
  return z.object<Properties<AutomationInputType>>({
    actions: z.array(definedNonNullAnySchema),
    conditions: z.array(definedNonNullAnySchema)
  })
}

export function ChartTabInputTypeSchema(): z.ZodObject<Properties<ChartTabInputType>> {
  return z.object<Properties<ChartTabInputType>>({
    id: z.number().nullish(),
    title: z.string()
  })
}

export function ClinicInputTypeSchema(): z.ZodObject<Properties<ClinicInputType>> {
  return z.object<Properties<ClinicInputType>>({
    createdAt: definedNonNullAnySchema.nullish(),
    deletedAt: definedNonNullAnySchema.nullish(),
    doctorName: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    phoneNumber: z.lazy(() => definedNonNullAnySchema.nullish()),
    updatedAt: definedNonNullAnySchema.nullish()
  })
}

export function ConferenceInputTypeSchema(): z.ZodObject<Properties<ConferenceInputType>> {
  return z.object<Properties<ConferenceInputType>>({
    noteId: z.number().nullish(),
    officialTouchpoint: z.boolean().nullish(),
    status: z.string().nullish(),
    studyId: z.number().nullish(),
    type: z.string().nullish()
  })
}

export function ConferenceWhereInputTypeSchema(): z.ZodObject<Properties<ConferenceWhereInputType>> {
  return z.object<Properties<ConferenceWhereInputType>>({
    conversationUuid: z.string().nullish(),
    fromUserId: z.number().nullish(),
    id: z.number().nullish(),
    sessionId: z.string().nullish(),
    studyId: z.number().nullish(),
    toUserId: z.number().nullish(),
    type: z.string().nullish()
  })
}

export function CountryInputTypeSchema(): z.ZodObject<Properties<CountryInputType>> {
  return z.object<Properties<CountryInputType>>({
    countryCallingCode: z.string(),
    countryCode: z.string(),
    nationalNumber: z.string(),
    numberValue: z.string()
  })
}

export function CountryPhoneNumberInputSchema(): z.ZodObject<Properties<CountryPhoneNumberInput>> {
  return z.object<Properties<CountryPhoneNumberInput>>({
    countryCallingCode: z.string().nullish(),
    countryCode: z.string().nullish(),
    createdAt: definedNonNullAnySchema.nullish(),
    deletedAt: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    nationalNumber: z.string().nullish(),
    numberValue: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish()
  })
}

export function CreateChartInputSchema(): z.ZodObject<Properties<CreateChartInput>> {
  return z.object<Properties<CreateChartInput>>({
    categoryId: z.number(),
    dataSourceId: z.number(),
    dataSourceId1: z.number().nullish(),
    fullWidth: z.boolean(),
    meta: definedNonNullAnySchema.nullish(),
    plots: z.array(z.string()),
    plots1: z.array(z.string()).nullish(),
    title: z.string(),
    title1: z.string().nullish(),
    type: z.string(),
    type1: z.string().nullish(),
    userId: z.number(),
    xAxis: z.string(),
    yAxis: z.string(),
    yAxis1: z.string().nullish()
  })
}

export function CreateEmailInputSchema(): z.ZodObject<Properties<CreateEmailInput>> {
  return z.object<Properties<CreateEmailInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string(),
    type: z.string().nullish(),
    user: z.number().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function CreateEventInputSchema(): z.ZodObject<Properties<CreateEventInput>> {
  return z.object<Properties<CreateEventInput>>({
    actions: z.string().nullish(),
    azureEventQueueScheduledMessageId: z.string().nullish(),
    confirmed: z.number().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    emailMessageContent: definedNonNullAnySchema.nullish(),
    end: definedNonNullAnySchema,
    hostId: z.number().nullish(),
    labels: z.string().nullish(),
    libraryConfigId: z.number().nullish(),
    liked: z.boolean().nullish(),
    pushNotificationMessageContent: definedNonNullAnySchema.nullish(),
    rescheduleTimeInMinutes: z.number().nullish(),
    resource: z.string().nullish(),
    schedulingStatus: definedNonNullAnySchema.nullish(),
    shouldReschedule: z.boolean().nullish(),
    start: definedNonNullAnySchema,
    status: z.string().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    studyIds: z.array(z.number()),
    textMessageContent: z.string().nullish(),
    title: z.string(),
    type: z.string().nullish(),
    userIds: z.array(z.number()),
    viewed: z.boolean().nullish()
  })
}

export function CreateMessageInputSchema(): z.ZodObject<Properties<CreateMessageInput>> {
  return z.object<Properties<CreateMessageInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string(),
    type: z.string().nullish(),
    user: z.number(),
    viewed: z.boolean().nullish()
  })
}

export function CreateNoteInputSchema(): z.ZodObject<Properties<CreateNoteInput>> {
  return z.object<Properties<CreateNoteInput>>({
    actions: z.string().nullish(),
    conferenceId: z.number().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    editorId: z.number().nullish(),
    entity: z.string().nullish(),
    labels: z.string().nullish(),
    libraryId: z.number().nullish(),
    liked: z.boolean().nullish(),
    parentId: z.number().nullish(),
    status: z.string().nullish(),
    title: z.string(),
    type: z.string().nullish(),
    userId: z.number().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function CreateNotificationInputSchema(): z.ZodObject<Properties<CreateNotificationInput>> {
  return z.object<Properties<CreateNotificationInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string(),
    type: z.string().nullish(),
    user: z.number(),
    viewed: z.boolean().nullish()
  })
}

export function CreateStudyPermissionInputSchema(): z.ZodObject<Properties<CreateStudyPermissionInput>> {
  return z.object<Properties<CreateStudyPermissionInput>>({
    permissionId: z.number(),
    studyId: z.number()
  })
}

export function CreateStudyRoleInputSchema(): z.ZodObject<Properties<CreateStudyRoleInput>> {
  return z.object<Properties<CreateStudyRoleInput>>({
    id: z.number().nullish(),
    roleId: z.number(),
    studyId: z.number()
  })
}

export function CreateSuggestedDateInputSchema(): z.ZodObject<Properties<CreateSuggestedDateInput>> {
  return z.object<Properties<CreateSuggestedDateInput>>({
    endTime: definedNonNullAnySchema,
    eventId: z.number(),
    startTime: definedNonNullAnySchema
  })
}

export function CreateUserSubscriptionInputSchema(): z.ZodObject<Properties<CreateUserSubscriptionInput>> {
  return z.object<Properties<CreateUserSubscriptionInput>>({
    notificationPreference: z.string(),
    userId: z.number()
  })
}

export function CreateVoiceInputSchema(): z.ZodObject<Properties<CreateVoiceInput>> {
  return z.object<Properties<CreateVoiceInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string(),
    type: z.string().nullish(),
    url: z.string().nullish(),
    user: z.number(),
    viewed: z.boolean().nullish()
  })
}

export function EmailsInputSchema(): z.ZodObject<Properties<EmailsInput>> {
  return z.object<Properties<EmailsInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    id: z.number().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function EventMetricsInputTypeSchema(): z.ZodObject<Properties<EventMetricsInputType>> {
  return z.object<Properties<EventMetricsInputType>>({
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish()
  })
}

export const EventSchedulingStatusSchema = z.nativeEnum(EventSchedulingStatus);

export function EventsInputSchema(): z.ZodObject<Properties<EventsInput>> {
  return z.object<Properties<EventsInput>>({
    actions: z.string().nullish(),
    confirmed: z.number().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    end: definedNonNullAnySchema.nullish(),
    id: z.number().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    resource: z.string().nullish(),
    start: definedNonNullAnySchema.nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

export const ExportDataTypesEnumSchema = z.nativeEnum(ExportDataTypesEnum);

export const ExportFileContentTypeSchema = z.nativeEnum(ExportFileContentType);

export const ExportRequestStatusSchema = z.nativeEnum(ExportRequestStatus);

export function ExportStudyInputSchema(): z.ZodObject<Properties<ExportStudyInput>> {
  return z.object<Properties<ExportStudyInput>>({
    dataTypes: z.array(definedNonNullAnySchema),
    fromDate: z.string(),
    participantIds: z.array(z.number()),
    studyArmId: z.number(),
    studyId: z.number(),
    toDate: z.string()
  })
}

export function FamilyMemberInputTypeSchema(): z.ZodObject<Properties<FamilyMemberInputType>> {
  return z.object<Properties<FamilyMemberInputType>>({
    createdAt: definedNonNullAnySchema.nullish(),
    deletedAt: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    phoneNumber: z.lazy(() => definedNonNullAnySchema.nullish()),
    relationship: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish()
  })
}

export function FilesInputSchema(): z.ZodObject<Properties<FilesInput>> {
  return z.object<Properties<FilesInput>>({
    description: z.string().nullish(),
    id: z.number().nullish(),
    path: z.string().nullish(),
    size: z.number().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    url: z.string().nullish()
  })
}

export function FitbitActivityTrendInputTypeSchema(): z.ZodObject<Properties<FitbitActivityTrendInputType>> {
  return z.object<Properties<FitbitActivityTrendInputType>>({
    date: z.string().nullish(),
    period: z.string(),
    resource: z.string(),
    userId: z.number()
  })
}

export function GraphDataPointsInputSchema(): z.ZodObject<Properties<GraphDataPointsInput>> {
  return z.object<Properties<GraphDataPointsInput>>({
    fromDate: z.string(),
    questionsId: z.array(z.number()),
    toDate: z.string(),
    userId: z.number()
  })
}

export function InviteParticipantInputTypeSchema(): z.ZodObject<Properties<InviteParticipantInputType>> {
  return z.object<Properties<InviteParticipantInputType>>({
    age: z.string().nullish(),
    clinicId: z.string().nullish(),
    email: z.string(),
    name: z.string(),
    numbersForCalls: z.array(z.lazy(() => definedNonNullAnySchema)).nullish(),
    numbersForMessages: z.array(z.lazy(() => definedNonNullAnySchema)).nullish(),
    preferredLanguage: z.string().nullish(),
    sexualOrientation: z.string().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
    studyArm: z.number().nullish(),
    studyId: z.number().nullish(),
    timezone: z.string().nullish()
  })
}

export function InviteStaffInputTypeSchema(): z.ZodObject<Properties<InviteStaffInputType>> {
  return z.object<Properties<InviteStaffInputType>>({
    email: z.string(),
    name: z.string(),
    role: z.number(),
    studyArmIds: z.array(z.number()).nullish()
  })
}

export function LibraryWhereInputTypeSchema(): z.ZodObject<Properties<LibraryWhereInputType>> {
  return z.object<Properties<LibraryWhereInputType>>({
    id: z.number().nullish(),
    title: z.string().nullish(),
    type: z.array(z.string()).nullish()
  })
}

export function LimitInputSchema(): z.ZodObject<Properties<LimitInput>> {
  return z.object<Properties<LimitInput>>({
    skip: z.number().nullish(),
    take: z.number().nullish()
  })
}

export function ManageChartTabInputTypeSchema(): z.ZodObject<Properties<ManageChartTabInputType>> {
  return z.object<Properties<ManageChartTabInputType>>({
    create: z.array(z.lazy(() => definedNonNullAnySchema)),
    delete: z.array(z.number()),
    update: z.array(z.lazy(() => definedNonNullAnySchema))
  })
}

export function MedicationInputTypeSchema(): z.ZodObject<Properties<MedicationInputType>> {
  return z.object<Properties<MedicationInputType>>({
    description: z.string(),
    label: z.string(),
    treatment: z.boolean().nullish()
  })
}

export function MedicationWhereInputTypeSchema(): z.ZodObject<Properties<MedicationWhereInputType>> {
  return z.object<Properties<MedicationWhereInputType>>({
    creatorId: z.number().nullish(),
    description: z.string().nullish(),
    id: z.number().nullish(),
    label: z.string().nullish(),
    treatment: z.boolean().nullish(),
    userId: z.number().nullish()
  })
}

export function MemberInputTypeSchema(): z.ZodObject<Properties<MemberInputType>> {
  return z.object<Properties<MemberInputType>>({
    address: z.string().nullish(),
    age: z.string().nullish(),
    clinicId: z.string().nullish(),
    createdAt: definedNonNullAnySchema.nullish(),
    deletedAt: definedNonNullAnySchema.nullish(),
    description: z.string().nullish(),
    email: z.string().nullish(),
    fitbitAccessToken: z.string().nullish(),
    fitbitId: z.string().nullish(),
    fitbitRefreshToken: z.string().nullish(),
    fitbitScopes: z.string().nullish(),
    id: z.string().nullish(),
    idNumber: z.string().nullish(),
    isSubscribed: z.boolean().nullish(),
    lastMessageAt: z.number().nullish(),
    name: z.string().nullish(),
    notificationPreferenceType: z.string().nullish(),
    password: z.string().nullish(),
    preferredLanguage: z.string().nullish(),
    preferredTime: z.string().nullish(),
    privateNotes: z.boolean().nullish(),
    sexualOrientation: z.string().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
    status: z.string().nullish(),
    studyArmsId: z.array(z.number()).nullish(),
    timezone: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish(),
    vonageName: z.string().nullish(),
    vonageUuid: z.string().nullish(),
    zipCode: z.string().nullish()
  })
}

export function MessagesInputSchema(): z.ZodObject<Properties<MessagesInput>> {
  return z.object<Properties<MessagesInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    id: z.number().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function MetricsInputTypeSchema(): z.ZodObject<Properties<MetricsInputType>> {
  return z.object<Properties<MetricsInputType>>({
    fromUserId: z.number().nullish(),
    studyId: z.number().nullish(),
    toUserId: z.number().nullish(),
    type: z.string().nullish()
  })
}

export function ModuleInputTypeSchema(): z.ZodObject<Properties<ModuleInputType>> {
  return z.object<Properties<ModuleInputType>>({
    automations: z.string().nullish(),
    createdAt: definedNonNullAnySchema.nullish(),
    creator: z.lazy(() => definedNonNullAnySchema.nullish()),
    deletedAt: definedNonNullAnySchema.nullish(),
    duration: z.number().nullish(),
    icon: z.string().nullish(),
    id: z.string().nullish(),
    initialMessage: z.string().nullish(),
    preIVRDuration: z.number().nullish(),
    preIVRDurationType: z.string().nullish(),
    questions: z.array(z.lazy(() => definedNonNullAnySchema)).nullish(),
    subsets: z.array(z.lazy(() => definedNonNullAnySchema)).nullish(),
    superset: z.lazy(() => definedNonNullAnySchema.nullish()),
    title: z.string().nullish(),
    tooltip: z.lazy(() => definedNonNullAnySchema.nullish()),
    type: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish()
  })
}

export function NotesInputSchema(): z.ZodObject<Properties<NotesInput>> {
  return z.object<Properties<NotesInput>>({
    actions: z.string().nullish(),
    assessmentResponseId: z.number().nullish(),
    conferenceId: z.number().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    editor: z.number().nullish(),
    entity: z.string().nullish(),
    id: z.number().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    parentId: z.number().nullish(),
    status: z.string().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    user: z.number().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function NotificationsInputSchema(): z.ZodObject<Properties<NotificationsInput>> {
  return z.object<Properties<NotificationsInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    id: z.number().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    receiverId: z.number().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function PermissionInputTypeSchema(): z.ZodObject<Properties<PermissionInputType>> {
  return z.object<Properties<PermissionInputType>>({
    description: z.string().nullish(),
    name: z.string()
  })
}

export function PermissionPartialInputTypeSchema(): z.ZodObject<Properties<PermissionPartialInputType>> {
  return z.object<Properties<PermissionPartialInputType>>({
    description: z.string().nullish(),
    id: z.number(),
    name: z.string().nullish()
  })
}

export function PermissionWhereTypeSchema(): z.ZodObject<Properties<PermissionWhereType>> {
  return z.object<Properties<PermissionWhereType>>({
    description: z.string().nullish(),
    id: z.number().nullish(),
    name: z.string().nullish()
  })
}

export function PhoneNumberInputTypeSchema(): z.ZodObject<Properties<PhoneNumberInputType>> {
  return z.object<Properties<PhoneNumberInputType>>({
    country: z.lazy(() => definedNonNullAnySchema.nullish()),
    countryId: z.string().nullish(),
    createdAt: definedNonNullAnySchema.nullish(),
    deletedAt: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    isPreferred: z.boolean().nullish(),
    label: z.string().nullish(),
    type: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish()
  })
}

export function QuestionCategoryInputTypeSchema(): z.ZodObject<Properties<QuestionCategoryInputType>> {
  return z.object<Properties<QuestionCategoryInputType>>({
    createdAt: definedNonNullAnySchema.nullish(),
    deletedAt: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish()
  })
}

export function QuestionCategoryWhereInputTypeSchema(): z.ZodObject<Properties<QuestionCategoryWhereInputType>> {
  return z.object<Properties<QuestionCategoryWhereInputType>>({
    id: z.number().nullish(),
    name: z.string().nullish()
  })
}

export function RoleAutoCompleteInputTypeSchema(): z.ZodObject<Properties<RoleAutoCompleteInputType>> {
  return z.object<Properties<RoleAutoCompleteInputType>>({
    id: z.string(),
    name: z.string()
  })
}

export function RoleInputTypeSchema(): z.ZodObject<Properties<RoleInputType>> {
  return z.object<Properties<RoleInputType>>({
    description: z.string().nullish(),
    name: z.string()
  })
}

export function RoleWhereInputTypeSchema(): z.ZodObject<Properties<RoleWhereInputType>> {
  return z.object<Properties<RoleWhereInputType>>({
    description: z.string().nullish(),
    id: z.number().nullish(),
    name: z.string().nullish()
  })
}

export function StudyArmInputTypeSchema(): z.ZodObject<Properties<StudyArmInputType>> {
  return z.object<Properties<StudyArmInputType>>({
    communications: z.array(definedNonNullAnySchema).nullish(),
    libraryConfigs: z.array(z.lazy(() => definedNonNullAnySchema)).nullish(),
    name: z.string(),
    studyArmId: z.string(),
    userIds: z.array(z.number())
  })
}

export function StudyArmLibraryConfigsInputTypeSchema(): z.ZodObject<Properties<StudyArmLibraryConfigsInputType>> {
  return z.object<Properties<StudyArmLibraryConfigsInputType>>({
    afterStart: z.number().nullish(),
    beforeStart: z.number().nullish(),
    duration: z.number(),
    id: z.number().nullish(),
    libraryId: z.number(),
    offset: z.number(),
    order: z.number().nullish(),
    repeat: z.number().nullish(),
    repeatText: z.string().nullish(),
    time: z.string()
  })
}

export function StudyArmWhereInputTypeSchema(): z.ZodObject<Properties<StudyArmWhereInputType>> {
  return z.object<Properties<StudyArmWhereInputType>>({
    id: z.number().nullish(),
    name: z.string().nullish()
  })
}

export function StudyInputTypeSchema(): z.ZodObject<Properties<StudyInputType>> {
  return z.object<Properties<StudyInputType>>({
    displayName: z.string(),
    irb: z.string(),
    name: z.string()
  })
}

export function StudyPermissionWhereInputSchema(): z.ZodObject<Properties<StudyPermissionWhereInput>> {
  return z.object<Properties<StudyPermissionWhereInput>>({
    id: z.number().nullish(),
    permissionId: z.number().nullish(),
    studyId: z.number().nullish()
  })
}

export function StudyRoleWhereInputSchema(): z.ZodObject<Properties<StudyRoleWhereInput>> {
  return z.object<Properties<StudyRoleWhereInput>>({
    id: z.number().nullish()
  })
}

export function StudyStaffInputTypeSchema(): z.ZodObject<Properties<StudyStaffInputType>> {
  return z.object<Properties<StudyStaffInputType>>({
    roleId: z.number(),
    studyArmsIds: z.array(z.number()).nullish(),
    userId: z.number()
  })
}

export function StudyWhereInputTypeSchema(): z.ZodObject<Properties<StudyWhereInputType>> {
  return z.object<Properties<StudyWhereInputType>>({
    description: z.string().nullish(),
    id: z.number().nullish(),
    name: z.string().nullish()
  })
}

export function SuggestedDateWhereInputTypeSchema(): z.ZodObject<Properties<SuggestedDateWhereInputType>> {
  return z.object<Properties<SuggestedDateWhereInputType>>({
    eventId: z.number().nullish()
  })
}

export function SymptomInputTypeSchema(): z.ZodObject<Properties<SymptomInputType>> {
  return z.object<Properties<SymptomInputType>>({
    description: z.string(),
    frequency: z.number().nullish(),
    label: z.string()
  })
}

export function SymptomWhereInputTypeSchema(): z.ZodObject<Properties<SymptomWhereInputType>> {
  return z.object<Properties<SymptomWhereInputType>>({
    creatorId: z.number().nullish(),
    description: z.string().nullish(),
    frequency: z.number().nullish(),
    id: z.number().nullish(),
    label: z.string().nullish(),
    userId: z.number().nullish()
  })
}

export function TooltipInputTypeSchema(): z.ZodObject<Properties<TooltipInputType>> {
  return z.object<Properties<TooltipInputType>>({
    createdAt: definedNonNullAnySchema.nullish(),
    deletedAt: definedNonNullAnySchema.nullish(),
    description: z.string().nullish(),
    icon: z.string().nullish(),
    id: z.string().nullish(),
    title: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish()
  })
}

export function TooltipWhereInputTypeSchema(): z.ZodObject<Properties<TooltipWhereInputType>> {
  return z.object<Properties<TooltipWhereInputType>>({
    id: z.number().nullish(),
    title: z.string().nullish()
  })
}

export function TreatmentInputTypeSchema(): z.ZodObject<Properties<TreatmentInputType>> {
  return z.object<Properties<TreatmentInputType>>({
    createdAt: definedNonNullAnySchema.nullish(),
    deletedAt: definedNonNullAnySchema.nullish(),
    disease: z.string().nullish(),
    id: z.string().nullish(),
    treatmentType: z.string().nullish(),
    updatedAt: definedNonNullAnySchema.nullish()
  })
}

export function UpdateChartInputSchema(): z.ZodObject<Properties<UpdateChartInput>> {
  return z.object<Properties<UpdateChartInput>>({
    categoryId: z.number().nullish(),
    dataSourceId: z.number().nullish(),
    dataSourceId1: z.number().nullish(),
    fullWidth: z.boolean().nullish(),
    meta: definedNonNullAnySchema.nullish(),
    plots: z.array(z.string()).nullish(),
    plots1: z.array(z.string()).nullish(),
    title: z.string().nullish(),
    title1: z.string().nullish(),
    type: z.string().nullish(),
    type1: z.string().nullish(),
    userId: z.number().nullish(),
    xAxis: z.string().nullish(),
    yAxis: z.string().nullish(),
    yAxis1: z.string().nullish()
  })
}

export function UpdateEmailInputSchema(): z.ZodObject<Properties<UpdateEmailInput>> {
  return z.object<Properties<UpdateEmailInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function UpdateEventInputSchema(): z.ZodObject<Properties<UpdateEventInput>> {
  return z.object<Properties<UpdateEventInput>>({
    actions: z.string().nullish(),
    confirmed: z.number().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    end: definedNonNullAnySchema.nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    resource: z.string().nullish(),
    start: definedNonNullAnySchema.nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function UpdateFileInputSchema(): z.ZodObject<Properties<UpdateFileInput>> {
  return z.object<Properties<UpdateFileInput>>({
    description: z.string().nullish(),
    path: z.string().nullish(),
    size: z.number().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    url: z.string().nullish()
  })
}

export function UpdateMessageInputSchema(): z.ZodObject<Properties<UpdateMessageInput>> {
  return z.object<Properties<UpdateMessageInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function UpdateNoteInputSchema(): z.ZodObject<Properties<UpdateNoteInput>> {
  return z.object<Properties<UpdateNoteInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    editorId: z.number().nullish(),
    entity: z.string().nullish(),
    isPinned: z.boolean().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    parentId: z.number().nullish(),
    privateNotes: z.boolean().nullish(),
    status: z.string().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    userId: z.number().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function UpdateNotificationInputSchema(): z.ZodObject<Properties<UpdateNotificationInput>> {
  return z.object<Properties<UpdateNotificationInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function UpdateStudyPermissionInputSchema(): z.ZodObject<Properties<UpdateStudyPermissionInput>> {
  return z.object<Properties<UpdateStudyPermissionInput>>({
    permissionId: z.number(),
    studyId: z.number()
  })
}

export function UpdateStudyRoleInputSchema(): z.ZodObject<Properties<UpdateStudyRoleInput>> {
  return z.object<Properties<UpdateStudyRoleInput>>({
    id: z.number().nullish(),
    roleId: z.number(),
    studyId: z.number()
  })
}

export function UpdateVoiceInputSchema(): z.ZodObject<Properties<UpdateVoiceInput>> {
  return z.object<Properties<UpdateVoiceInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    url: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

export function UserInputTypeSchema(): z.ZodObject<Properties<UserInputType>> {
  return z.object<Properties<UserInputType>>({
    description: z.string().nullish(),
    email: z.string(),
    name: z.string(),
    password: z.string(),
    roleId: z.number(),
    status: z.string()
  })
}

export function UserPermissionInputTypeSchema(): z.ZodObject<Properties<UserPermissionInputType>> {
  return z.object<Properties<UserPermissionInputType>>({
    permissions: z.array(z.number()),
    roleId: z.number(),
    studyArmIds: z.array(z.number()).nullish(),
    studyId: z.number()
  })
}

export function UserProfileDetailInputTypeSchema(): z.ZodObject<Properties<UserProfileDetailInputType>> {
  return z.object<Properties<UserProfileDetailInputType>>({
    assignedStaff: z.lazy(() => definedNonNullAnySchema.nullish()),
    startDate: definedNonNullAnySchema.nullish()
  })
}

export function UserProfileDetailsInputTypeSchema(): z.ZodObject<Properties<UserProfileDetailsInputType>> {
  return z.object<Properties<UserProfileDetailsInputType>>({
    address: z.string().nullish(),
    age: z.string().nullish(),
    assignedStaff: z.lazy(() => definedNonNullAnySchema.nullish()),
    clinicId: z.string().nullish(),
    clinics: z.array(z.lazy(() => definedNonNullAnySchema)),
    familyMembers: z.array(z.lazy(() => definedNonNullAnySchema)),
    idNumber: z.string().nullish(),
    name: z.string(),
    phoneNumbers: z.array(z.lazy(() => definedNonNullAnySchema)),
    preferredLanguage: z.string().nullish(),
    preferredTime: z.string().nullish(),
    sexualOrientation: z.string().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
    treatments: z.array(z.lazy(() => definedNonNullAnySchema)),
    zipCode: z.string().nullish()
  })
}

export function UserProfileInfoInputTypeSchema(): z.ZodObject<Properties<UserProfileInfoInputType>> {
  return z.object<Properties<UserProfileInfoInputType>>({
    address: z.string().nullish(),
    clinicId: z.string().nullish(),
    clinics: z.array(z.lazy(() => definedNonNullAnySchema)),
    familyMembers: z.array(z.lazy(() => definedNonNullAnySchema)),
    idNumber: z.string().nullish(),
    name: z.string(),
    phoneNumbers: z.array(z.lazy(() => definedNonNullAnySchema)),
    preferredLanguage: z.string().nullish(),
    treatments: z.array(z.lazy(() => definedNonNullAnySchema))
  })
}

export function UserStudyInputTypeSchema(): z.ZodObject<Properties<UserStudyInputType>> {
  return z.object<Properties<UserStudyInputType>>({
    studyArmId: z.number().nullish(),
    studyId: z.number(),
    userId: z.number()
  })
}

export function UserUpdateInputTypeSchema(): z.ZodObject<Properties<UserUpdateInputType>> {
  return z.object<Properties<UserUpdateInputType>>({
    description: z.string().nullish(),
    email: z.string(),
    name: z.string(),
    privateNotes: z.boolean().nullish(),
    roleId: z.number().nullish(),
    status: z.string()
  })
}

export function VoicesInputSchema(): z.ZodObject<Properties<VoicesInput>> {
  return z.object<Properties<VoicesInput>>({
    actions: z.string().nullish(),
    data: z.string().nullish(),
    description: z.string().nullish(),
    id: z.number().nullish(),
    labels: z.string().nullish(),
    liked: z.boolean().nullish(),
    studyArmId: z.number().nullish(),
    studyId: z.number().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    url: z.string().nullish(),
    viewed: z.boolean().nullish()
  })
}

/**
 * @typedef {Object} ActivityLevel
 * @property {number} minutes
 * @property {string} name
 */

/**
 * @typedef {Object} ArchiveOutput
 * @property {number} createdAt
 * @property {string} duration
 * @property {string} hasAudio
 * @property {string} hasVideo
 * @property {string} id
 * @property {string} name
 * @property {string} outputMode
 * @property {string} partnerId
 * @property {string} projectId
 * @property {string} reason
 * @property {string} resolution
 * @property {string} sessionId
 * @property {number} size
 * @property {string} status
 * @property {string} streamMode
 * @property {Array<Stream>} streams
 * @property {string} url
 */

/**
 * @typedef {Object} AssessmentAnswerEntity
 * @property {DateTime} [answerDate]
 * @property {string} comment
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {AssessmentQuestionEntity} [question]
 * @property {DateTime} updatedAt
 * @property {JSONObject} [value]
 * @property {Array<string>} [values]
 */

/**
 * @typedef {Object} AssessmentAnswerInputType
 * @property {DateTime} [answerDate]
 * @property {string} [comment]
 * @property {number} [id]
 * @property {number} questionId
 * @property {JSONObject} [value]
 * @property {Array<string>} [values]
 */

/**
 * @typedef {Object} AssessmentQuestionEntity
 * @property {JSONObject} [automation]
 * @property {QuestionCategoryEntity} [category]
 * @property {string} [conditions]
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} [icon]
 * @property {string} id
 * @property {string} [identifier]
 * @property {boolean} [isAnswered]
 * @property {string} label
 * @property {JSONObject} [meta]
 * @property {string} [options]
 * @property {number} [order]
 * @property {Array<AssessmentQuestionEntity>} [questions]
 * @property {string} [symptomName]
 * @property {string} [symptomNameEs]
 * @property {TooltipEntity} [tooltip]
 * @property {string} [type]
 * @property {DateTime} updatedAt
 * @property {string} [variableName]
 */

/**
 * @typedef {Object} AssessmentQuestionInputType
 * @property {JSONObject} [automation]
 * @property {QuestionCategoryInputType} [category]
 * @property {string} [conditions]
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [icon]
 * @property {string} [id]
 * @property {string} [identifier]
 * @property {boolean} [isAnswered]
 * @property {string} [label]
 * @property {JSONObject} [meta]
 * @property {string} [options]
 * @property {number} [order]
 * @property {Array<AssessmentQuestionInputType>} [questions]
 * @property {string} [symptomName]
 * @property {string} [symptomNameEs]
 * @property {TooltipInputType} [tooltip]
 * @property {string} [type]
 * @property {DateTime} [updatedAt]
 * @property {string} [variableName]
 */

/**
 * @typedef {Object} AssessmentQuestionOutputType
 * @property {number} count
 * @property {Array<AssessmentQuestionEntity>} items
 */

/**
 * @typedef {Object} AssessmentQuestionWhereInputType
 * @property {number} [id]
 * @property {string} [identifier]
 * @property {string} [label]
 * @property {string} [type]
 * @property {string} [variableName]
 */

/**
 * @typedef {Object} AssessmentResponseEntity
 * @property {DateTime} [answerDate]
 * @property {Array<AssessmentAnswerEntity>} [answers]
 * @property {string} [conversationUUID]
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {number} [incrementFollowupQuestionsCount]
 * @property {LibraryEntity} library
 * @property {number} libraryId
 * @property {boolean} [preIVRQuestionsRequired]
 * @property {number} [skippedQuestionCount]
 * @property {number} [skippedQuestionsBySystemCount]
 * @property {StudyEntity} [study]
 * @property {StudyArmEntity} [studyArm]
 * @property {string} triggeredAutomationIndexes
 * @property {DateTime} updatedAt
 * @property {UserEntity} user
 * @property {number} userId
 */

/**
 * @typedef {Object} AssessmentResponseInputType
 * @property {DateTime} [answerDate]
 * @property {Array<AssessmentAnswerInputType>} answers
 * @property {string} [conversationUUID]
 * @property {number} library
 * @property {boolean} [preIVRQuestionsRequired]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {number} [user]
 */

/**
 * @typedef {Object} AssessmentResponseOutputType
 * @property {number} count
 * @property {Array<AssessmentResponseEntity>} items
 */

/**
 * @typedef {Object} AssessmentResponseWithTokenInputType
 * @property {Array<AssessmentAnswerInputType>} answers
 */

/**
 * @typedef {Object} AssessmentResponsesWhereInputType
 * @property {DateTime} [answerDate]
 * @property {string} [conversationUUID]
 * @property {number} [id]
 * @property {number} [libraryId]
 * @property {Array<number>} [libraryIds]
 * @property {number} [userId]
 */

/**
 * @typedef {Object} AssessmentsAnsweredResponseOutputType
 * @property {DateTime} date
 * @property {boolean} isAnswered
 */

/**
 * @typedef {Object} AssignedStaffInputType
 * @property {string} id
 * @property {string} [name]
 * @property {RoleAutoCompleteInputType} [role]
 */

/**
 * @typedef {Object} AuditEntity
 * @property {string} action
 * @property {number} id
 * @property {string} [newData]
 * @property {boolean} notify
 * @property {string} [oldData]
 * @property {StudyEntity} [study]
 * @property {StudyArmEntity} [studyArm]
 * @property {string} tableName
 * @property {DateTime} updatedAt
 * @property {UserEntity} [user]
 */

/**
 * @typedef {Object} AuditInput
 * @property {string} [action]
 * @property {number} [id]
 * @property {string} [newData]
 * @property {boolean} [notify]
 * @property {string} [oldData]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} [tableName]
 * @property {DateTime} [updatedAt]
 * @property {number} [userId]
 */

/**
 * @typedef {Object} AuditOutput
 * @property {number} count
 * @property {Array<AuditEntity>} items
 */

/**
 * @typedef {Object} AuthOutputType
 * @property {string} [token]
 */

/**
 * @typedef {Object} AutomationActionType
 * @property {string} [data]
 * @property {string} do
 * @property {string} where
 * @property {Array<AutomationActionWhoType>} who
 */

/**
 * @typedef {Object} AutomationActionWhoType
 * @property {number} id
 * @property {string} name
 * @property {string} type
 */

/**
 * @typedef {Object} AutomationConditionType
 * @property {string} logic
 * @property {string} operator
 * @property {string} question
 * @property {string} value
 * @property {string} what
 */

/**
 * @typedef {Object} AutomationInputType
 * @property {Array<AutomationActionType>} actions
 * @property {Array<AutomationConditionType>} conditions
 */

/**
 * @typedef {Object} AutomationWhoOutputType
 * @property {number} id
 * @property {string} name
 * @property {string} type
 */

/**
 * @typedef {Object} CallRecordingOutputType
 * @property {DateTime} createdAt
 * @property {number} [durationSeconds]
 * @property {string} format
 * @property {number} recordingId
 * @property {string} url
 */

/**
 * @typedef {Object} CanDeleteLibraryOutputType
 * @property {boolean} canDelete
 * @property {string} message
 */

/**
 * @typedef {Object} ChartEntity
 * @property {ChartTabEntity} category
 * @property {number} [categoryId]
 * @property {DateTime} createdAt
 * @property {AssessmentQuestionEntity} dataSource
 * @property {AssessmentQuestionEntity} [dataSource1]
 * @property {DateTime} [deletedAt]
 * @property {boolean} fullWidth
 * @property {string} id
 * @property {JSONObject} [meta]
 * @property {Array<string>} plots
 * @property {Array<string>} [plots1]
 * @property {string} title
 * @property {string} [title1]
 * @property {string} type
 * @property {string} [type1]
 * @property {DateTime} updatedAt
 * @property {UserEntity} user
 * @property {string} xAxis
 * @property {string} yAxis
 * @property {string} [yAxis1]
 */

/**
 * @typedef {Object} ChartTabEntity
 * @property {DateTime} createdAt
 * @property {string} id
 * @property {number} [order]
 * @property {string} title
 * @property {DateTime} updatedAt
 * @property {number} [userId]
 */

/**
 * @typedef {Object} ChartTabInputType
 * @property {number} [id]
 * @property {string} title
 */

/**
 * @typedef {Object} ChartTabOutputType
 * @property {number} chartCount
 * @property {DateTime} createdAt
 * @property {string} id
 * @property {number} [order]
 * @property {string} title
 * @property {DateTime} updatedAt
 * @property {number} [userId]
 */

/**
 * @typedef {Object} ChatMessageDetailOutputType
 * @property {Array<JSONObject>} [attachments]
 * @property {string} conversationId
 * @property {boolean} isRead
 * @property {DateTime} messageDate
 * @property {number} messageId
 * @property {number} recipientId
 * @property {string} recipientName
 * @property {string} recipientRole
 * @property {number} senderId
 * @property {string} senderName
 * @property {string} senderRole
 * @property {string} text
 */

/**
 * @typedef {Object} ClinicEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} doctorName
 * @property {string} id
 * @property {string} name
 * @property {PhoneNumberEntity} [phoneNumber]
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} ClinicInputType
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [doctorName]
 * @property {string} [id]
 * @property {string} [name]
 * @property {PhoneNumberInputType} [phoneNumber]
 * @property {DateTime} [updatedAt]
 */

/**
 * @typedef {Object} CoachingAssessmentForNotesOutput
 * @property {boolean} hasCoachingAssessment
 * @property {number} [noteId]
 */

/**
 * @typedef {Object} CoachingCallDetailOutputType
 * @property {Array<IvrQuestionAnswerOutputType>} [assessmentQuestions]
 * @property {DateTime} callDate
 * @property {number} coachId
 * @property {string} coachName
 * @property {number} coachingCallId
 * @property {number} [durationMinutes]
 * @property {JSONObject} [libraryDetails]
 * @property {Array<JSONObject>} [noteAttachments]
 * @property {Array<number>} [noteIds]
 * @property {string} [notes]
 * @property {CallRecordingOutputType} [recording]
 */

/**
 * @typedef {Object} CoachingEvents
 * @property {DateTime} [end]
 * @property {number} id
 * @property {number} [libraryId]
 * @property {DateTime} start
 * @property {string} [status]
 * @property {string} type
 */

/**
 * @typedef {Object} CommunicationCallDetailOutputType
 * @property {DateTime} callDate
 * @property {Array<CommunicationCallParticipantType>} callParticipants
 * @property {string} callType
 * @property {number} communicationCallId
 * @property {number} [durationMinutes]
 * @property {CallRecordingOutputType} [recording]
 */

/**
 * @typedef {Object} CommunicationCallParticipantType
 * @property {string} role
 * @property {number} userId
 * @property {string} userName
 */

/**
 * @typedef {Object} ConferenceEntity
 * @property {string} [answerTimestamp]
 * @property {string} [conversationUuid]
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {boolean} dtmf
 * @property {DateTime} [endDate]
 * @property {number} [eventId]
 * @property {number} [fromUserId]
 * @property {string} id
 * @property {string} [machineDetectionMeta]
 * @property {string} [machineDetectionStatus]
 * @property {string} [meta]
 * @property {Array<NoteEntity>} [notes]
 * @property {boolean} [officialTouchpoint]
 * @property {RecordingEntity} [recording]
 * @property {string} [sessionId]
 * @property {string} [status]
 * @property {number} [studyId]
 * @property {string} [title]
 * @property {number} [toUserId]
 * @property {string} [type]
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} ConferenceInputType
 * @property {number} [noteId]
 * @property {boolean} [officialTouchpoint]
 * @property {string} [status]
 * @property {number} [studyId]
 * @property {string} [type]
 */

/**
 * @typedef {Object} ConferenceOutputType
 * @property {number} count
 * @property {Array<ConferenceEntity>} items
 */

/**
 * @typedef {Object} ConferenceWhereInputType
 * @property {string} [conversationUuid]
 * @property {number} [fromUserId]
 * @property {number} [id]
 * @property {string} [sessionId]
 * @property {number} [studyId]
 * @property {number} [toUserId]
 * @property {string} [type]
 */

/**
 * @typedef {Object} ConferenceWithUsersOutputType
 * @property {number} count
 * @property {Array<ConferenceWithUsersRelation>} items
 */

/**
 * @typedef {Object} ConferenceWithUsersRelation
 * @property {string} [answerTimestamp]
 * @property {string} [conversationUuid]
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {boolean} dtmf
 * @property {DateTime} [endDate]
 * @property {number} [eventId]
 * @property {UserEntity} fromUser
 * @property {number} [fromUserId]
 * @property {string} id
 * @property {string} [machineDetectionMeta]
 * @property {string} [machineDetectionStatus]
 * @property {string} [meta]
 * @property {Array<NoteEntity>} [notes]
 * @property {boolean} [officialTouchpoint]
 * @property {RecordingEntity} [recording]
 * @property {string} [sessionId]
 * @property {string} [status]
 * @property {number} [studyId]
 * @property {string} [title]
 * @property {UserEntity} toUser
 * @property {number} [toUserId]
 * @property {string} [type]
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} CountryInputType
 * @property {string} countryCallingCode
 * @property {string} countryCode
 * @property {string} nationalNumber
 * @property {string} numberValue
 */

/**
 * @typedef {Object} CountryPhoneNumberEntity
 * @property {string} countryCallingCode
 * @property {string} countryCode
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {string} nationalNumber
 * @property {string} numberValue
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} CountryPhoneNumberInput
 * @property {string} [countryCallingCode]
 * @property {string} [countryCode]
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [id]
 * @property {string} [nationalNumber]
 * @property {string} [numberValue]
 * @property {DateTime} [updatedAt]
 */

/**
 * @typedef {Object} CreateChartInput
 * @property {number} categoryId
 * @property {number} dataSourceId
 * @property {number} [dataSourceId1]
 * @property {boolean} fullWidth
 * @property {JSONObject} [meta]
 * @property {Array<string>} plots
 * @property {Array<string>} [plots1]
 * @property {string} title
 * @property {string} [title1]
 * @property {string} type
 * @property {string} [type1]
 * @property {number} userId
 * @property {string} xAxis
 * @property {string} yAxis
 * @property {string} [yAxis1]
 */

/**
 * @typedef {Object} CreateEmailInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} title
 * @property {string} [type]
 * @property {number} [user]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} CreateEventInput
 * @property {string} [actions]
 * @property {string} [azureEventQueueScheduledMessageId]
 * @property {number} [confirmed]
 * @property {string} [data]
 * @property {string} [description]
 * @property {JSONObject} [emailMessageContent]
 * @property {DateTime} end
 * @property {number} [hostId]
 * @property {string} [labels]
 * @property {number} [libraryConfigId]
 * @property {boolean} [liked]
 * @property {JSONObject} [pushNotificationMessageContent]
 * @property {number} [rescheduleTimeInMinutes]
 * @property {string} [resource]
 * @property {EventSchedulingStatus} [schedulingStatus]
 * @property {boolean} [shouldReschedule]
 * @property {DateTime} start
 * @property {string} [status]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {Array<number>} studyIds
 * @property {string} [textMessageContent]
 * @property {string} title
 * @property {string} [type]
 * @property {Array<number>} userIds
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} CreateMessageInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} title
 * @property {string} [type]
 * @property {number} user
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} CreateNoteInput
 * @property {string} [actions]
 * @property {number} [conferenceId]
 * @property {string} [data]
 * @property {string} [description]
 * @property {number} [editorId]
 * @property {string} [entity]
 * @property {string} [labels]
 * @property {number} [libraryId]
 * @property {boolean} [liked]
 * @property {number} [parentId]
 * @property {string} [status]
 * @property {string} title
 * @property {string} [type]
 * @property {number} [userId]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} CreateNotificationInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} title
 * @property {string} [type]
 * @property {number} user
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} CreateStudyPermissionInput
 * @property {number} permissionId
 * @property {number} studyId
 */

/**
 * @typedef {Object} CreateStudyRoleInput
 * @property {number} [id]
 * @property {number} roleId
 * @property {number} studyId
 */

/**
 * @typedef {Object} CreateSuggestedDateInput
 * @property {DateTime} endTime
 * @property {number} eventId
 * @property {DateTime} startTime
 */

/**
 * @typedef {Object} CreateUserSubscriptionInput
 * @property {string} notificationPreference
 * @property {number} userId
 */

/**
 * @typedef {Object} CreateVoiceInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} title
 * @property {string} [type]
 * @property {string} [url]
 * @property {number} user
 * @property {boolean} [viewed]
 */

/**
 * A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format.
 * @typedef {*} DateTime
 */

/**
 * @typedef {Object} EmailDetailOutputType
 * @property {Array<JSONObject>} [attachments]
 * @property {string} content
 * @property {DateTime} emailDate
 * @property {number} emailId
 * @property {string} [emailType]
 * @property {boolean} [isRead]
 * @property {number} recipientId
 * @property {string} recipientName
 * @property {string} recipientRole
 * @property {number} senderId
 * @property {string} senderName
 * @property {string} senderRole
 * @property {string} [subject]
 */

/**
 * @typedef {Object} EmailEntity
 * @property {string} [actions]
 * @property {DateTime} createdAt
 * @property {string} [data]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {number} id
 * @property {string} [labels]
 * @property {boolean} liked
 * @property {UserEntity} [receiver]
 * @property {number} [receiverId]
 * @property {UserEntity} [sender]
 * @property {number} [senderId]
 * @property {StudyEntity} [study]
 * @property {StudyArmEntity} [studyArm]
 * @property {string} title
 * @property {string} [type]
 * @property {DateTime} updatedAt
 * @property {boolean} viewed
 */

/**
 * @typedef {Object} EmailsInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {number} [id]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {string} [title]
 * @property {string} [type]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} EmailsOutput
 * @property {number} count
 * @property {boolean} isGroupChat
 * @property {Array<EmailEntity>} items
 */

/**
 * @typedef {Object} EventEntity
 * @property {string} [actions]
 * @property {string} [azureEventQueueScheduledMessageId]
 * @property {number} confirmed
 * @property {DateTime} createdAt
 * @property {string} [data]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {string} [emailMessageContent]
 * @property {DateTime} end
 * @property {number} id
 * @property {string} [labels]
 * @property {number} [libraryConfigId]
 * @property {boolean} liked
 * @property {string} [pushNotificationMessageContent]
 * @property {UserEntity} [receiver]
 * @property {number} [rescheduleTimeInMinutes]
 * @property {string} [resource]
 * @property {string} schedulingStatus
 * @property {UserEntity} [sender]
 * @property {boolean} shouldReschedule
 * @property {DateTime} start
 * @property {DateTime} [startForIVR]
 * @property {string} [status]
 * @property {StudyEntity} [study]
 * @property {StudyArmEntity} [studyArm]
 * @property {string} [textMessageContent]
 * @property {string} title
 * @property {string} [type]
 * @property {DateTime} updatedAt
 * @property {boolean} viewed
 */

/**
 * @typedef {Object} EventMetricsInputType
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 */

/**
 * @typedef {Object} EventMetricsOutputType
 * @property {number} completedCount
 * @property {number} completedCountMonth
 * @property {number} incompleteCount
 * @property {number} incompleteCountMonth
 * @property {number} missedCount
 * @property {number} missedCountMonth
 * @property {number} totalCount
 * @property {number} totalCountMonth
 */

/**
 * @typedef {("CANCELED"|"COMPLETED"|"PENDING")} EventSchedulingStatus
 */

/**
 * @typedef {Object} EventWithTimeWindow
 * @property {EventEntity} event
 * @property {StudyArmLibraryConfigsEntity} [libraryConfig]
 * @property {DateTime} windowEndTime
 * @property {DateTime} windowStartTime
 */

/**
 * @typedef {Object} EventsInput
 * @property {string} [actions]
 * @property {number} [confirmed]
 * @property {string} [data]
 * @property {string} [description]
 * @property {DateTime} [end]
 * @property {number} [id]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {string} [resource]
 * @property {DateTime} [start]
 * @property {string} [title]
 * @property {string} [type]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} EventsOutput
 * @property {number} count
 * @property {Array<EventEntity>} items
 */

/**
 * @typedef {Object} ExportContentMetadataType
 * @property {Array<string>} dataTypesIncluded
 * @property {string} dateRangeFrom
 * @property {string} dateRangeTo
 * @property {string} exportedAt
 * @property {string} studyArmName
 * @property {string} studyName
 * @property {number} totalDataPoints
 * @property {number} totalParticipants
 */

/**
 * The types of data to include in the export.
 * @typedef {("CHAT_MESSAGES"|"COACHING_CALLS"|"COMMUNICATION_CALLS"|"EMAILS"|"FITBIT"|"IVR_CALLS"|"JOURNALS")} ExportDataTypesEnum
 */

/**
 * @typedef {Object} ExportFileContentMetadataType
 * @property {string} contentType
 * @property {string} dataTypeDisplay
 * @property {string} [description]
 * @property {number} exportRequestId
 * @property {string} fetchedAt
 * @property {string} fileName
 * @property {string} [schemaVersion]
 */

/**
 * @typedef {Object} ExportFileContentResponseType
 * @property {JSON} content
 * @property {ExportFileContentMetadataType} metadata
 */

/**
 * The specific content type of an exported file for type-safe access.
 * @typedef {("CHAT_MESSAGES_ONLY"|"COACHING_CALLS_ONLY"|"COMMUNICATION_CALLS_ONLY"|"EMAILS_ONLY"|"FITBIT_DATA_ONLY"|"FULL_PARTICIPANT_DATA"|"IVR_CALLS_ONLY"|"JOURNAL_ENTRIES_ONLY"|"SUMMARY_METRICS")} ExportFileContentType
 */

/**
 * @typedef {Object} ExportRequestOutputType
 * @property {DateTime} [completedAt]
 * @property {string} [errorMessage]
 * @property {JSONObject} exportParameters
 * @property {Array<ExportedFileRecordType>} [generatedFiles]
 * @property {number} id
 * @property {DateTime} requestedAt
 * @property {number} requestedById
 * @property {ExportRequestStatus} status
 * @property {number} studyId
 * @property {DateTime} updatedAt
 */

/**
 * The status of a data export request.
 * @typedef {("COMPLETED"|"FAILED"|"PENDING"|"PROCESSING")} ExportRequestStatus
 */

/**
 * @typedef {Object} ExportStudyInput
 * @property {Array<ExportDataTypesEnum>} dataTypes
 * @property {string} fromDate
 * @property {Array<number>} participantIds
 * @property {number} studyArmId
 * @property {number} studyId
 * @property {string} toDate
 */

/**
 * @typedef {Object} ExportedFileRecordType
 * @property {ExportFileContentType} contentType
 * @property {string} dataTypeDisplay
 * @property {string} [description]
 * @property {string} [expectedDataStructure]
 * @property {string} fileName
 * @property {string} format
 * @property {string} [schemaVersion]
 * @property {string} url
 */

/**
 * @typedef {Object} FamilyMemberEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {string} name
 * @property {PhoneNumberEntity} [phoneNumber]
 * @property {string} relationship
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} FamilyMemberInputType
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [id]
 * @property {string} [name]
 * @property {PhoneNumberInputType} [phoneNumber]
 * @property {string} [relationship]
 * @property {DateTime} [updatedAt]
 */

/**
 * @typedef {Object} FileEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {number} id
 * @property {string} [path]
 * @property {number} [size]
 * @property {string} title
 * @property {string} [type]
 * @property {DateTime} updatedAt
 * @property {string} [url]
 */

/**
 * @typedef {Object} FilesInput
 * @property {string} [description]
 * @property {number} [id]
 * @property {string} [path]
 * @property {number} [size]
 * @property {string} [title]
 * @property {string} [type]
 * @property {string} [url]
 */

/**
 * @typedef {Object} FilesOutput
 * @property {number} count
 * @property {Array<FileEntity>} items
 */

/**
 * @typedef {Object} FitbitActivityEntity
 * @property {Array<ActivityLevel>} [activityLevel]
 * @property {number} [averageHeartRate]
 * @property {number} [calories]
 * @property {DateTime} createdAt
 * @property {Array<JSONObject>} [data]
 * @property {DateTime} date
 * @property {DateTime} [deletedAt]
 * @property {number} [distance]
 * @property {string} [distanceUnit]
 * @property {number} duration
 * @property {number} [elivation]
 * @property {string} id
 * @property {string} name
 * @property {number} [pace]
 * @property {number} [speed]
 * @property {string} startTime
 * @property {number} [steps]
 * @property {DateTime} updatedAt
 * @property {UserEntity} [user]
 * @property {string} version
 */

/**
 * @typedef {Object} FitbitActivityTrendData
 * @property {string} dateTime
 * @property {number} value
 */

/**
 * @typedef {Object} FitbitActivityTrendInputType
 * @property {string} [date]
 * @property {string} period
 * @property {string} resource
 * @property {number} userId
 */

/**
 * @typedef {Object} FitbitChartsData
 * @property {Array<FitbitActivityEntity>} activity
 * @property {Array<FitbitDistanceEntity>} distance
 * @property {Array<FitbitHeartRateEntity>} heartRate
 * @property {Array<FitbitSleepEntity>} sleep
 * @property {Array<FitbitStepsEntity>} steps
 */

/**
 * @typedef {Object} FitbitDistanceEntity
 * @property {DateTime} createdAt
 * @property {Array<JSONObject>} [data]
 * @property {DateTime} date
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {DateTime} updatedAt
 * @property {UserEntity} [user]
 * @property {string} value
 * @property {string} version
 */

/**
 * @typedef {Object} FitbitEntity
 * @property {DateTime} createdAt
 * @property {JSONObject} [data]
 * @property {DateTime} [deletedAt]
 * @property {string} [hash]
 * @property {string} id
 * @property {string} type
 * @property {DateTime} updatedAt
 * @property {number} userId
 */

/**
 * @typedef {Object} FitbitHeartRateEntity
 * @property {DateTime} createdAt
 * @property {Array<JSONObject>} [data]
 * @property {DateTime} date
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {number} restingHeartRate
 * @property {DateTime} updatedAt
 * @property {UserEntity} [user]
 * @property {string} version
 */

/**
 * @typedef {Object} FitbitHistoryEntity
 * @property {DateTime} createdAt
 * @property {JSONObject} [data]
 * @property {string} id
 * @property {number} [statusCode]
 * @property {string} type
 * @property {string} [url]
 * @property {number} [userId]
 */

/**
 * @typedef {Object} FitbitLifetimeStats
 * @property {string} label
 * @property {string} metric
 */

/**
 * @typedef {Object} FitbitSleepEntity
 * @property {DateTime} createdAt
 * @property {Array<JSONObject>} [data]
 * @property {DateTime} date
 * @property {DateTime} [deletedAt]
 * @property {number} duration
 * @property {string} endTime
 * @property {string} id
 * @property {string} startTime
 * @property {DateTime} updatedAt
 * @property {UserEntity} [user]
 * @property {string} version
 */

/**
 * @typedef {Object} FitbitStepsEntity
 * @property {DateTime} createdAt
 * @property {Array<JSONObject>} [data]
 * @property {DateTime} date
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {DateTime} updatedAt
 * @property {UserEntity} [user]
 * @property {string} value
 * @property {string} version
 */

/**
 * @typedef {Object} FitbitWeightEntity
 * @property {number} bmi
 * @property {DateTime} createdAt
 * @property {Array<JSONObject>} [data]
 * @property {DateTime} date
 * @property {DateTime} [deletedAt]
 * @property {number} fat
 * @property {string} id
 * @property {DateTime} updatedAt
 * @property {UserEntity} [user]
 * @property {string} version
 * @property {number} weight
 */

/**
 * @typedef {Object} GraphDataPointsInput
 * @property {string} fromDate
 * @property {Array<number>} questionsId
 * @property {string} toDate
 * @property {number} userId
 */

/**
 * @typedef {Object} GraphDataPointsOutput
 * @property {Array<AssessmentAnswerEntity>} items
 */

/**
 * @typedef {Object} InviteParticipantInputType
 * @property {string} [age]
 * @property {string} [clinicId]
 * @property {string} email
 * @property {string} name
 * @property {Array<CountryInputType>} [numbersForCalls]
 * @property {Array<CountryInputType>} [numbersForMessages]
 * @property {string} [preferredLanguage]
 * @property {string} [sexualOrientation]
 * @property {DateTime} [startDate]
 * @property {number} [studyArm]
 * @property {number} [studyId]
 * @property {string} [timezone]
 */

/**
 * @typedef {Object} InviteStaffInputType
 * @property {string} email
 * @property {string} name
 * @property {number} role
 * @property {Array<number>} [studyArmIds]
 */

/**
 * @typedef {Object} InviteStaffOutputType
 * @property {Array<string>} [errors]
 * @property {Array<UserEntity>} users
 */

/**
 * @typedef {Object} IvrCallDetailOutputType
 * @property {DateTime} callDate
 * @property {number} [durationSeconds]
 * @property {number} ivrCallId
 * @property {JSONObject} [libraryDetails]
 * @property {Array<IvrQuestionAnswerOutputType>} questionsAndAnswers
 * @property {string} status
 */

/**
 * @typedef {Object} IvrQuestionAnswerOutputType
 * @property {string} [answerValue]
 * @property {DateTime} answeredAt
 * @property {JSONObject} [questionDetails]
 * @property {number} questionId
 * @property {string} questionText
 */

/**
 * The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).
 * @typedef {*} JSON
 */

/**
 * The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).
 * @typedef {*} JSONObject
 */

/**
 * @typedef {Object} JournalEntryDetailOutputType
 * @property {Array<JSONObject>} [actions]
 * @property {Array<JSONObject>} [attachments]
 * @property {number} [authorId]
 * @property {string} [authorName]
 * @property {DateTime} entryDate
 * @property {number} journalEntryId
 * @property {number} [lastEditorId]
 * @property {string} [lastEditorName]
 * @property {JSONObject} [libraryDetails]
 * @property {Array<IvrQuestionAnswerOutputType>} [questionsAndAnswers]
 * @property {string} [status]
 * @property {string} text
 * @property {string} [title]
 * @property {DateTime} [updatedAtDate]
 */

/**
 * @typedef {Object} LibraryEntity
 * @property {Array<AssessmentResponseEntity>} [assessmentResponses]
 * @property {string} [automations]
 * @property {DateTime} createdAt
 * @property {UserEntity} [creator]
 * @property {DateTime} [deletedAt]
 * @property {number} [duration]
 * @property {string} [icon]
 * @property {string} id
 * @property {string} [initialMessage]
 * @property {Array<StudyArmLibraryConfigsEntity>} [libraryConfigs]
 * @property {number} [preIVRDuration]
 * @property {string} [preIVRDurationType]
 * @property {Array<AssessmentQuestionEntity>} [questions]
 * @property {Array<StudyEntity>} [studies]
 * @property {Array<StudyArmEntity>} [studyArms]
 * @property {Array<LibraryEntity>} [subsets]
 * @property {LibraryEntity} [superset]
 * @property {string} title
 * @property {TooltipEntity} [tooltip]
 * @property {string} [type]
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} LibraryOutputType
 * @property {number} count
 * @property {Array<LibraryEntity>} items
 * @property {Array<string>} types
 */

/**
 * @typedef {Object} LibraryWhereInputType
 * @property {number} [id]
 * @property {string} [title]
 * @property {Array<string>} [type]
 */

/**
 * @typedef {Object} LimitInput
 * @property {number} [skip]
 * @property {number} [take]
 */

/**
 * @typedef {Object} ManageChartTabInputType
 * @property {Array<ChartTabInputType>} create
 * @property {Array<number>} delete
 * @property {Array<ChartTabInputType>} update
 */

/**
 * @typedef {Object} ManageChartTabResponseType
 * @property {boolean} success
 */

/**
 * @typedef {Object} MedicationEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} description
 * @property {string} id
 * @property {string} label
 * @property {boolean} treatment
 * @property {DateTime} updatedAt
 * @property {number} userId
 */

/**
 * @typedef {Object} MedicationInputType
 * @property {string} description
 * @property {string} label
 * @property {boolean} [treatment]
 */

/**
 * @typedef {Object} MedicationOutputType
 * @property {number} count
 * @property {Array<MedicationEntity>} items
 */

/**
 * @typedef {Object} MedicationWhereInputType
 * @property {number} [creatorId]
 * @property {string} [description]
 * @property {number} [id]
 * @property {string} [label]
 * @property {boolean} [treatment]
 * @property {number} [userId]
 */

/**
 * @typedef {Object} MemberInputType
 * @property {string} [address]
 * @property {string} [age]
 * @property {string} [clinicId]
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {string} [email]
 * @property {string} [fitbitAccessToken]
 * @property {string} [fitbitId]
 * @property {string} [fitbitRefreshToken]
 * @property {string} [fitbitScopes]
 * @property {string} [id]
 * @property {string} [idNumber]
 * @property {boolean} [isSubscribed]
 * @property {number} [lastMessageAt]
 * @property {string} [name]
 * @property {string} [notificationPreferenceType]
 * @property {string} [password]
 * @property {string} [preferredLanguage]
 * @property {string} [preferredTime]
 * @property {boolean} [privateNotes]
 * @property {string} [sexualOrientation]
 * @property {DateTime} [startDate]
 * @property {string} [status]
 * @property {Array<number>} [studyArmsId]
 * @property {string} [timezone]
 * @property {DateTime} [updatedAt]
 * @property {string} [vonageName]
 * @property {string} [vonageUuid]
 * @property {string} [zipCode]
 */

/**
 * @typedef {Object} MessageEntity
 * @property {string} [actions]
 * @property {DateTime} createdAt
 * @property {string} [data]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {number} id
 * @property {string} [labels]
 * @property {boolean} liked
 * @property {UserEntity} [receiver]
 * @property {number} [receiverId]
 * @property {UserEntity} [sender]
 * @property {number} [senderId]
 * @property {StudyEntity} [study]
 * @property {StudyArmEntity} [studyArm]
 * @property {string} title
 * @property {string} [type]
 * @property {DateTime} updatedAt
 * @property {boolean} viewed
 * @property {string} [vonageId]
 */

/**
 * @typedef {Object} MessagesInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {number} [id]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {string} [title]
 * @property {string} [type]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} MessagesOutput
 * @property {number} count
 * @property {boolean} isGroupChat
 * @property {Array<MessageEntity>} items
 */

/**
 * @typedef {Object} MetricsAdherence
 * @property {DateTime} [endDate]
 * @property {number} id
 * @property {UserEntity} receiver
 * @property {DateTime} startDate
 * @property {string} [status]
 * @property {string} type
 */

/**
 * @typedef {Object} MetricsAdherenceOutput
 * @property {Array<MetricsAdherence>} adherenceItems
 * @property {number} [completedJournals]
 * @property {Array<LibraryEntity>} [libraries]
 */

/**
 * @typedef {Object} MetricsInputType
 * @property {number} [fromUserId]
 * @property {number} [studyId]
 * @property {number} [toUserId]
 * @property {string} [type]
 */

/**
 * @typedef {Object} MetricsOutputType
 * @property {number} count
 * @property {number} enrolledCount
 * @property {number} increasedCountRate
 * @property {number} increasedDurationRate
 * @property {number} increasedEnrollRate
 * @property {number} totalDuration
 */

/**
 * @typedef {Object} MetricsUsersOutputType
 * @property {number} participantCount
 * @property {number} participantCountMonth
 */

/**
 * @typedef {Object} ModuleInputType
 * @property {string} [automations]
 * @property {DateTime} [createdAt]
 * @property {MemberInputType} [creator]
 * @property {DateTime} [deletedAt]
 * @property {number} [duration]
 * @property {string} [icon]
 * @property {string} [id]
 * @property {string} [initialMessage]
 * @property {number} [preIVRDuration]
 * @property {string} [preIVRDurationType]
 * @property {Array<AssessmentQuestionInputType>} [questions]
 * @property {Array<ModuleInputType>} [subsets]
 * @property {ModuleInputType} [superset]
 * @property {string} [title]
 * @property {TooltipInputType} [tooltip]
 * @property {string} [type]
 * @property {DateTime} [updatedAt]
 */

/**
 * @typedef {Object} Mutation
 * @property {AssessmentResponseEntity} [addAssessmentAnswer]
 * @property {MedicationEntity} [addMedication]
 * @property {SymptomEntity} [addSymptom]
 * @property {ChartTabEntity} chartTab
 * @property {EventEntity} [confirmEvent]
 * @property {EventEntity} [confirmProposedTimeForEvent]
 * @property {AssessmentQuestionEntity} [createAssessmentQuestion]
 * @property {AssessmentResponseEntity} [createAssessmentResponse]
 * @property {AssessmentResponseEntity} [createAssessmentResponseWithToken]
 * @property {ChartEntity} [createChart]
 * @property {ChartTabEntity} createChartTab
 * @property {EmailEntity} [createEmail]
 * @property {Array<EventEntity>} [createEvent]
 * @property {FileEntity} [createFile]
 * @property {Array<FileEntity>} [createFiles]
 * @property {LibraryEntity} [createLibrary]
 * @property {LibraryEntity} [createLibrarySubset]
 * @property {MessageEntity} [createMessage]
 * @property {LibraryEntity} [createModule]
 * @property {NoteEntity} [createNote]
 * @property {NotificationEntity} [createNotification]
 * @property {PermissionEntity} [createPermission]
 * @property {RoleEntity} [createRole]
 * @property {StudyEntity} [createStudy]
 * @property {StudyPermissionEntity} [createStudyPermission]
 * @property {StudyRoleEntity} [createStudyRole]
 * @property {SuggestedDateEntity} createSuggestedDate
 * @property {UserEntity} [createUser]
 * @property {UserSubscriptionEntity} [createUserSubscription]
 * @property {VoiceEntity} [createVoice]
 * @property {ChartEntity} [deleteChart]
 * @property {ChartTabEntity} deleteChartTab
 * @property {EmailEntity} [deleteEmail]
 * @property {EventEntity} [deleteEvent]
 * @property {FileEntity} [deleteFile]
 * @property {string} [deleteLibrary]
 * @property {MessageEntity} [deleteMessage]
 * @property {NoteEntity} [deleteNote]
 * @property {NotificationEntity} [deleteNotification]
 * @property {PermissionEntity} [deletePermission]
 * @property {Array<RoleEntity>} [deleteRole]
 * @property {StudyEntity} [deleteStudy]
 * @property {StudyPermissionEntity} [deleteStudyPermission]
 * @property {StudyRoleEntity} [deleteStudyRole]
 * @property {Array<UserEntity>} [deleteUser]
 * @property {VoiceEntity} [deleteVoice]
 * @property {UserEntity} [inviteParticipant]
 * @property {InviteStaffOutputType} [inviteStaff]
 * @property {number} [likeAllEmails]
 * @property {number} [likeAllEvents]
 * @property {number} [likeAllMessages]
 * @property {number} [likeAllNotes]
 * @property {number} [likeAllNotifications]
 * @property {number} [likeAllVoices]
 * @property {ManageChartTabResponseType} manageChartTabs
 * @property {ExportRequestOutputType} requestStudyExport
 * @property {boolean} [resetPassword]
 * @property {boolean} [sendInviteEmail]
 * @property {Array<MessageEntity>} [sendMMS]
 * @property {boolean} [sendResetPasswordLink]
 * @property {MessageEntity} [sendSMS]
 * @property {MessageEntity} [sendVideoConferenceSMS]
 * @property {string} shortenString
 * @property {ConferenceEntity} [startConference]
 * @property {ConferenceEntity} [stopVideoCall]
 * @property {boolean} [testOutboundCall]
 * @property {boolean} [unsubscribeUser]
 * @property {AssessmentResponseEntity} [updateAssessmentAnswer]
 * @property {AssessmentQuestionEntity} [updateAssessmentQuestion]
 * @property {AssessmentResponseEntity} [updateAssessmentResponse]
 * @property {ChartEntity} [updateChart]
 * @property {ChartTabEntity} updateChartTab
 * @property {EventEntity} [updateCoachingEventStatus]
 * @property {ConferenceEntity} updateConference
 * @property {EmailEntity} [updateEmail]
 * @property {EventEntity} [updateEvent]
 * @property {FileEntity} [updateFile]
 * @property {LibraryEntity} [updateLibrary]
 * @property {MessageEntity} [updateMessage]
 * @property {NoteEntity} [updateNote]
 * @property {NotificationEntity} [updateNotification]
 * @property {NotificationpPreferencesEntity} [updateNotificationPreference]
 * @property {PermissionEntity} [updatePermission]
 * @property {RoleEntity} [updateRole]
 * @property {StudyEntity} [updateStudy]
 * @property {StudyPermissionEntity} [updateStudyPermission]
 * @property {StudyRoleEntity} [updateStudyRole]
 * @property {UserEntity} [updateUser]
 * @property {UserEntity} [updateUserPermissions]
 * @property {UserEntity} [updateUserProfileDetail]
 * @property {UserEntity} [updateUserProfileInfoDetails]
 * @property {UserEntity} [updateUserProfileInformation]
 * @property {VoiceEntity} [updateVoice]
 * @property {string} [uploadIcon]
 * @property {UserEntity} [validateDirectSignin]
 * @property {UserEntity} [verifyUser]
 * @property {number} [viewAllEmails]
 * @property {number} [viewAllEvents]
 * @property {number} [viewAllMessages]
 * @property {number} [viewAllNotes]
 * @property {number} [viewAllNotifications]
 * @property {number} [viewAllVoices]
 */

/**
 * @typedef {Object} NoteEntity
 * @property {string} [actions]
 * @property {AssessmentResponseEntity} [assessmentResponse]
 * @property {ConferenceEntity} [conference]
 * @property {DateTime} createdAt
 * @property {string} [data]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {UserEntity} [editor]
 * @property {string} [entity]
 * @property {number} id
 * @property {boolean} isPinned
 * @property {string} [labels]
 * @property {boolean} liked
 * @property {number} [parentId]
 * @property {string} [status]
 * @property {string} title
 * @property {string} [type]
 * @property {DateTime} updatedAt
 * @property {UserEntity} user
 * @property {number} [userId]
 * @property {boolean} viewed
 */

/**
 * @typedef {Object} NotesInput
 * @property {string} [actions]
 * @property {number} [assessmentResponseId]
 * @property {number} [conferenceId]
 * @property {string} [data]
 * @property {string} [description]
 * @property {number} [editor]
 * @property {string} [entity]
 * @property {number} [id]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [parentId]
 * @property {string} [status]
 * @property {string} [title]
 * @property {string} [type]
 * @property {number} [user]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} NotesOutput
 * @property {number} count
 * @property {Array<NoteEntity>} items
 */

/**
 * @typedef {Object} NotificationEntity
 * @property {string} [actions]
 * @property {DateTime} createdAt
 * @property {string} [data]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {number} id
 * @property {boolean} [isSubscribed]
 * @property {string} [labels]
 * @property {boolean} liked
 * @property {StudyEntity} [study]
 * @property {StudyArmEntity} [studyArm]
 * @property {number} [studyId]
 * @property {string} title
 * @property {string} [type]
 * @property {DateTime} updatedAt
 * @property {boolean} viewed
 */

/**
 * @typedef {Object} NotificationpPreferencesEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {UserSubscriptionEntity} subscription
 * @property {string} type
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} NotificationsInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {number} [id]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [receiverId]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} [title]
 * @property {string} [type]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} NotificationsOutput
 * @property {number} count
 * @property {Array<NotificationEntity>} items
 */

/**
 * @typedef {Object} OpentokAuthOutputType
 * @property {string} [apiKey]
 * @property {string} [sessionId]
 * @property {string} [token]
 */

/**
 * @typedef {Object} ParticipantExportDataOutputType
 * @property {number} [avgActiveMinutes]
 * @property {number} [avgSteps]
 * @property {Array<ChatMessageDetailOutputType>} chatMessages
 * @property {Array<CoachingCallDetailOutputType>} coachingCalls
 * @property {Array<CommunicationCallDetailOutputType>} communicationCalls
 * @property {DateTime} dateAddedToArm
 * @property {Array<EmailDetailOutputType>} emails
 * @property {Array<JSONObject>} [fitbitData]
 * @property {number} [hoursOfCall]
 * @property {boolean} [isFitbitSyncedInPeriod]
 * @property {Array<IvrCallDetailOutputType>} ivrCalls
 * @property {Array<JournalEntryDetailOutputType>} journalEntries
 * @property {number} [numberOfEmails]
 * @property {number} [numberOfMessages]
 * @property {string} [participantExternalId]
 * @property {number} participantId
 * @property {string} participantName
 * @property {number} studyArmId
 * @property {string} studyArmName
 * @property {number} studyId
 * @property {string} studyName
 */

/**
 * @typedef {Object} PermissionEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {string} id
 * @property {string} name
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} PermissionInputType
 * @property {string} [description]
 * @property {string} name
 */

/**
 * @typedef {Object} PermissionOutputType
 * @property {number} count
 * @property {Array<PermissionEntity>} items
 */

/**
 * @typedef {Object} PermissionPartialInputType
 * @property {string} [description]
 * @property {number} id
 * @property {string} [name]
 */

/**
 * @typedef {Object} PermissionWhereType
 * @property {string} [description]
 * @property {number} [id]
 * @property {string} [name]
 */

/**
 * @typedef {Object} PhoneNumberEntity
 * @property {CountryPhoneNumberEntity} [country]
 * @property {string} [countryId]
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {boolean} isPreferred
 * @property {string} label
 * @property {string} type
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} PhoneNumberInputType
 * @property {CountryPhoneNumberInput} [country]
 * @property {string} [countryId]
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [id]
 * @property {boolean} [isPreferred]
 * @property {string} [label]
 * @property {string} [type]
 * @property {DateTime} [updatedAt]
 */

/**
 * @typedef {Object} Query
 * @property {MetricsAdherenceOutput} adherenceMetrics
 * @property {LibraryOutputType} allJournals
 * @property {ArchiveOutput} [archiveSession]
 * @property {Array<AssessmentsAnsweredResponseOutputType>} assessmentAnsweredResponse
 * @property {Array<AssessmentsAnsweredResponseOutputType>} assessmentAnsweredResponses
 * @property {AssessmentQuestionEntity} [assessmentQuestion]
 * @property {AssessmentQuestionOutputType} assessmentQuestions
 * @property {AssessmentResponseEntity} [assessmentResponse]
 * @property {AssessmentResponseOutputType} assessmentResponses
 * @property {AuditEntity} [audit]
 * @property {AuditOutput} audits
 * @property {ConferenceWithUsersOutputType} callConferences
 * @property {CanDeleteLibraryOutputType} [canDeleteLibrary]
 * @property {Array<ChartTabOutputType>} chartTabs
 * @property {Array<string>} clinicIds
 * @property {CoachingAssessmentForNotesOutput} coachingAssessmentForNotes
 * @property {Array<CoachingEvents>} coachingEvents
 * @property {ConferenceEntity} [conference]
 * @property {ConferenceOutputType} conferences
 * @property {number} countEmails
 * @property {number} countEvents
 * @property {number} countFiles
 * @property {number} countMessages
 * @property {number} countNotes
 * @property {number} countNotifications
 * @property {number} countVoices
 * @property {LibraryOutputType} dailyAssessments
 * @property {LibraryOutputType} dailyJournals
 * @property {EmailEntity} [email]
 * @property {EmailsOutput} emails
 * @property {EventEntity} [event]
 * @property {EventsOutput} events
 * @property {boolean} exportMessages
 * @property {StringShortenOutputType} fetchOriginalString
 * @property {FileEntity} [file]
 * @property {FilesOutput} files
 * @property {FitbitEntity} fitbitActivities
 * @property {Array<FitbitActivityEntity>} fitbitActivitiesList
 * @property {Array<FitbitActivityTrendData>} fitbitActivitiesTrend
 * @property {FitbitChartsData} fitbitChartsData
 * @property {Array<FitbitDistanceEntity>} fitbitDistanceList
 * @property {Array<FitbitHeartRateEntity>} fitbitHeartRateList
 * @property {Array<FitbitHistoryEntity>} fitbitHistory
 * @property {Array<FitbitHistoryEntity>} fitbitHistoryByUser
 * @property {Array<FitbitLifetimeStats>} fitbitLifetimeStats
 * @property {Array<FitbitSleepEntity>} fitbitSleepList
 * @property {Array<FitbitStepsEntity>} fitbitStepsList
 * @property {Array<FitbitWeightEntity>} fitbitWeightList
 * @property {Array<ChartEntity>} [getCharts]
 * @property {ExportFileContentResponseType} getExportFileContent
 * @property {ExportRequestOutputType} getExportRequestDetails
 * @property {Array<EventWithTimeWindow>} getProfileEvents
 * @property {Array<EventWithTimeWindow>} getScheduledEvents
 * @property {GraphDataPointsOutput} graphDataPoints
 * @property {string} hello
 * @property {LibraryOutputType} libraries
 * @property {LibraryEntity} [library]
 * @property {LibraryEntity} [libraryWithToken]
 * @property {MedicationEntity} [medication]
 * @property {MedicationOutputType} medications
 * @property {MessageEntity} [message]
 * @property {MessagesOutput} messages
 * @property {MetricsOutputType} metricsConferences
 * @property {EventMetricsOutputType} metricsEvents
 * @property {MetricsUsersOutputType} metricsUsers
 * @property {Array<ExportRequestOutputType>} myExportRequests
 * @property {NoteEntity} [note]
 * @property {NotesOutput} notes
 * @property {NotificationEntity} [notification]
 * @property {NotificationsOutput} notifications
 * @property {OpentokAuthOutputType} opentokAuth
 * @property {LibraryOutputType} participantCoachingLibrariesForDate
 * @property {PermissionEntity} [permission]
 * @property {PermissionOutputType} permissions
 * @property {QuestionCategoryOutputType} questionCategories
 * @property {QuestionCategoryEntity} [questionCategory]
 * @property {RoleEntity} [role]
 * @property {RolesOutputType} roles
 * @property {Array<AutomationWhoOutputType>} searchAutomationWho
 * @property {Array<RoleEntity>} searchRoles
 * @property {StudyOutputType} studies
 * @property {StudyOutputType} studiesWithStudyArms
 * @property {StudyEntity} [study]
 * @property {StudyArmEntity} [studyArm]
 * @property {StudyArmLibraryConfigsEntity} [studyArmLibraryConfigs]
 * @property {StudyArmOutputType} studyArms
 * @property {Array<StudyArmEntity>} studyArmsByStaff
 * @property {StudyPermissionEntity} [studyPermission]
 * @property {StudyPermissionsOutput} studyPermissions
 * @property {StudyRoleEntity} [studyRole]
 * @property {StudyRoleOutput} studyRoles
 * @property {SuggestedDateEntity} [suggestedDate]
 * @property {SymptomEntity} [symptom]
 * @property {SymptomOutputType} symptoms
 * @property {boolean} syncFitbitData
 * @property {TooltipEntity} [tooltip]
 * @property {TooltipOutputType} tooltips
 * @property {TranslateOutputType} [translate]
 * @property {UserEntity} [user]
 * @property {UserConferencesOutputType} userConferences
 * @property {UserLoginOutputType} userLogin
 * @property {UserProfileDetailType} [userProfileGeneralDetails]
 * @property {UserInfoDetailsOutputType} [userProfileInfoDetails]
 * @property {UserEntity} [userProfileInformation]
 * @property {UserEntity} userRegistration
 * @property {UserVerifiedInputType} userVerified
 * @property {UsersOutputType} users
 * @property {UsersOutputType} usersEmails
 * @property {UsersOutputType} usersEvents
 * @property {UsersOutputType} usersMessages
 * @property {UsersOutputType} usersVoices
 * @property {VoiceEntity} [voice]
 * @property {VoicesOutput} voices
 * @property {AuthOutputType} vonageAuth
 */

/**
 * @typedef {Object} QuestionCategoryEntity
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {string} name
 * @property {Array<AssessmentQuestionEntity>} [questions]
 * @property {DateTime} [updatedAt]
 */

/**
 * @typedef {Object} QuestionCategoryInputType
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [id]
 * @property {string} [name]
 * @property {DateTime} [updatedAt]
 */

/**
 * @typedef {Object} QuestionCategoryOutputType
 * @property {number} count
 * @property {Array<QuestionCategoryEntity>} items
 */

/**
 * @typedef {Object} QuestionCategoryWhereInputType
 * @property {number} [id]
 * @property {string} [name]
 */

/**
 * @typedef {Object} RecordingEntity
 * @property {string} archiveId
 * @property {string} conversationUuid
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} [endTime]
 * @property {string} id
 * @property {string} recordingUrl
 * @property {string} recordingUuid
 * @property {string} sessionId
 * @property {string} size
 * @property {string} startTime
 * @property {string} type
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} RoleAutoCompleteInputType
 * @property {string} id
 * @property {string} name
 */

/**
 * @typedef {Object} RoleEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {string} id
 * @property {string} name
 * @property {Array<PermissionEntity>} [permissions]
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} RoleInputType
 * @property {string} [description]
 * @property {string} name
 */

/**
 * @typedef {Object} RoleWhereInputType
 * @property {string} [description]
 * @property {number} [id]
 * @property {string} [name]
 */

/**
 * @typedef {Object} RolesOutputType
 * @property {number} count
 * @property {Array<RoleEntity>} items
 */

/**
 * @typedef {Object} StaffEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {RoleEntity} role
 * @property {DateTime} updatedAt
 * @property {UserEntity} user
 */

/**
 * @typedef {Object} Stream
 * @property {boolean} hasAudio
 * @property {boolean} hasVideo
 * @property {string} streamId
 */

/**
 * @typedef {Object} StringShortenOutputType
 * @property {string} originalString
 * @property {string} token
 */

/**
 * @typedef {Object} StudyArmEntity
 * @property {Array<UserEntity>} [coaches]
 * @property {JSONObject} [communications]
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {Array<StudyArmLibraryConfigsEntity>} [libraryConfigs]
 * @property {string} name
 * @property {DateTime} updatedAt
 * @property {Array<UserEntity>} [users]
 */

/**
 * @typedef {Object} StudyArmInputType
 * @property {Array<JSONObject>} [communications]
 * @property {Array<StudyArmLibraryConfigsInputType>} [libraryConfigs]
 * @property {string} name
 * @property {string} studyArmId
 * @property {Array<number>} userIds
 */

/**
 * @typedef {Object} StudyArmLibraryConfigsEntity
 * @property {number} [afterStart]
 * @property {number} [beforeStart]
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {number} duration
 * @property {string} id
 * @property {LibraryEntity} library
 * @property {number} offset
 * @property {number} [order]
 * @property {number} [repeat]
 * @property {string} [repeatText]
 * @property {string} [time]
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} StudyArmLibraryConfigsInputType
 * @property {number} [afterStart]
 * @property {number} [beforeStart]
 * @property {number} duration
 * @property {number} [id]
 * @property {number} libraryId
 * @property {number} offset
 * @property {number} [order]
 * @property {number} [repeat]
 * @property {string} [repeatText]
 * @property {string} time
 */

/**
 * @typedef {Object} StudyArmOutputType
 * @property {number} count
 * @property {Array<StudyArmEntity>} items
 */

/**
 * @typedef {Object} StudyArmWhereInputType
 * @property {number} [id]
 * @property {string} [name]
 */

/**
 * @typedef {Object} StudyEntity
 * @property {DateTime} createdAt
 * @property {UserEntity} [creator]
 * @property {number} [creatorId]
 * @property {DateTime} [deletedAt]
 * @property {string} displayName
 * @property {number} id
 * @property {string} irb
 * @property {string} [moduleId]
 * @property {Array<LibraryEntity>} [modules]
 * @property {string} name
 * @property {Array<UserEntity>} [staff]
 * @property {Array<StudyArmEntity>} [studyArms]
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} StudyInputType
 * @property {string} displayName
 * @property {string} irb
 * @property {string} name
 */

/**
 * @typedef {Object} StudyOutputType
 * @property {number} count
 * @property {Array<StudyEntity>} items
 */

/**
 * @typedef {Object} StudyPermissionEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {PermissionEntity} permission
 * @property {string} permissionId
 * @property {StudyEntity} study
 * @property {string} studyId
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} StudyPermissionWhereInput
 * @property {number} [id]
 * @property {number} [permissionId]
 * @property {number} [studyId]
 */

/**
 * @typedef {Object} StudyPermissionsOutput
 * @property {number} count
 * @property {Array<StudyPermissionEntity>} items
 */

/**
 * @typedef {Object} StudyRoleEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} id
 * @property {RoleEntity} role
 * @property {StudyEntity} study
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} StudyRoleOutput
 * @property {number} count
 * @property {Array<StudyRoleEntity>} items
 */

/**
 * @typedef {Object} StudyRoleWhereInput
 * @property {number} [id]
 */

/**
 * @typedef {Object} StudyStaffInputType
 * @property {number} roleId
 * @property {Array<number>} [studyArmsIds]
 * @property {number} userId
 */

/**
 * @typedef {Object} StudyWhereInputType
 * @property {string} [description]
 * @property {number} [id]
 * @property {string} [name]
 */

/**
 * @typedef {Object} SuggestedDateEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {DateTime} endTime
 * @property {EventEntity} event
 * @property {number} id
 * @property {DateTime} startTime
 * @property {UserEntity} suggester
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} SuggestedDateWhereInputType
 * @property {number} [eventId]
 */

/**
 * @typedef {Object} SymptomEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} description
 * @property {number} [frequency]
 * @property {string} id
 * @property {string} label
 * @property {DateTime} updatedAt
 * @property {number} userId
 */

/**
 * @typedef {Object} SymptomInputType
 * @property {string} description
 * @property {number} [frequency]
 * @property {string} label
 */

/**
 * @typedef {Object} SymptomOutputType
 * @property {number} count
 * @property {Array<SymptomEntity>} items
 */

/**
 * @typedef {Object} SymptomWhereInputType
 * @property {number} [creatorId]
 * @property {string} [description]
 * @property {number} [frequency]
 * @property {number} [id]
 * @property {string} [label]
 * @property {number} [userId]
 */

/**
 * @typedef {Object} TooltipEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {string} [icon]
 * @property {string} id
 * @property {string} title
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} TooltipInputType
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {string} [icon]
 * @property {string} [id]
 * @property {string} [title]
 * @property {DateTime} [updatedAt]
 */

/**
 * @typedef {Object} TooltipOutputType
 * @property {number} count
 * @property {Array<TooltipEntity>} items
 */

/**
 * @typedef {Object} TooltipWhereInputType
 * @property {number} [id]
 * @property {string} [title]
 */

/**
 * @typedef {Object} TranslateOutputType
 * @property {Array<string>} texts
 */

/**
 * @typedef {Object} TreatmentEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} disease
 * @property {string} id
 * @property {string} treatmentType
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} TreatmentInputType
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [disease]
 * @property {string} [id]
 * @property {string} [treatmentType]
 * @property {DateTime} [updatedAt]
 */

/**
 * @typedef {Object} TypedExportFileContentType
 * @property {ExportContentMetadataType} exportMetadata
 * @property {Array<ParticipantExportDataOutputType>} participants
 */

/**
 * @typedef {Object} TypedExportedFileRecordType
 * @property {string} contentType
 * @property {string} dataTypeDisplay
 * @property {string} [description]
 * @property {string} expectedDataStructure
 * @property {string} fileName
 * @property {string} format
 * @property {string} [schemaVersion]
 * @property {string} url
 */

/**
 * @typedef {Object} UpdateChartInput
 * @property {number} [categoryId]
 * @property {number} [dataSourceId]
 * @property {number} [dataSourceId1]
 * @property {boolean} [fullWidth]
 * @property {JSONObject} [meta]
 * @property {Array<string>} [plots]
 * @property {Array<string>} [plots1]
 * @property {string} [title]
 * @property {string} [title1]
 * @property {string} [type]
 * @property {string} [type1]
 * @property {number} [userId]
 * @property {string} [xAxis]
 * @property {string} [yAxis]
 * @property {string} [yAxis1]
 */

/**
 * @typedef {Object} UpdateEmailInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} [title]
 * @property {string} [type]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} UpdateEventInput
 * @property {string} [actions]
 * @property {number} [confirmed]
 * @property {string} [data]
 * @property {string} [description]
 * @property {DateTime} [end]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {string} [resource]
 * @property {DateTime} [start]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} [title]
 * @property {string} [type]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} UpdateFileInput
 * @property {string} [description]
 * @property {string} [path]
 * @property {number} [size]
 * @property {string} [title]
 * @property {string} [type]
 * @property {string} [url]
 */

/**
 * @typedef {Object} UpdateMessageInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} [title]
 * @property {string} [type]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} UpdateNoteInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {number} [editorId]
 * @property {string} [entity]
 * @property {boolean} [isPinned]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [parentId]
 * @property {boolean} [privateNotes]
 * @property {string} [status]
 * @property {string} [title]
 * @property {string} [type]
 * @property {number} [userId]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} UpdateNotificationInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {string} [title]
 * @property {string} [type]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} UpdateStudyPermissionInput
 * @property {number} permissionId
 * @property {number} studyId
 */

/**
 * @typedef {Object} UpdateStudyRoleInput
 * @property {number} [id]
 * @property {number} roleId
 * @property {number} studyId
 */

/**
 * @typedef {Object} UpdateVoiceInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} [title]
 * @property {string} [type]
 * @property {string} [url]
 * @property {boolean} [viewed]
 */

/**
 * The `Upload` scalar type represents a file upload.
 * @typedef {*} Upload
 */

/**
 * @typedef {Object} UserConferencesOutputType
 * @property {number} count
 * @property {Array<UserEntity>} items
 */

/**
 * @typedef {Object} UserEntity
 * @property {string} [address]
 * @property {string} [age]
 * @property {StaffEntity} [assignedStaff]
 * @property {string} [clinicId]
 * @property {Array<ClinicEntity>} [clinics]
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {string} email
 * @property {Array<FamilyMemberEntity>} [familyMembers]
 * @property {string} [fitbitAccessToken]
 * @property {string} [fitbitId]
 * @property {string} [fitbitRefreshToken]
 * @property {string} [fitbitScopes]
 * @property {string} id
 * @property {string} [idNumber]
 * @property {boolean} [isSubscribed]
 * @property {number} [lastMessageAt]
 * @property {string} name
 * @property {Array<NoteEntity>} [notes]
 * @property {string} [notificationPreferenceType]
 * @property {string} [password]
 * @property {Array<StudyPermissionEntity>} [permissions]
 * @property {Array<PhoneNumberEntity>} [phoneNumbers]
 * @property {string} [preferredLanguage]
 * @property {string} [preferredTime]
 * @property {RoleEntity} [primaryRole]
 * @property {boolean} [privateNotes]
 * @property {Array<EmailEntity>} [receiverEmails]
 * @property {Array<MessageEntity>} [receiverMessages]
 * @property {Array<NotificationEntity>} [receiverNotifications]
 * @property {Array<VoiceEntity>} [receiverVoices]
 * @property {Array<StudyRoleEntity>} [roles]
 * @property {Array<EmailEntity>} [senderEmails]
 * @property {Array<MessageEntity>} [senderMessages]
 * @property {Array<NotificationEntity>} [senderNotifications]
 * @property {Array<VoiceEntity>} [senderVoices]
 * @property {string} [sexualOrientation]
 * @property {DateTime} [startDate]
 * @property {string} [status]
 * @property {Array<StudyEntity>} [studies]
 * @property {Array<number>} [studyArmsId]
 * @property {string} [timezone]
 * @property {Array<TreatmentEntity>} [treatments]
 * @property {DateTime} updatedAt
 * @property {string} [vonageName]
 * @property {string} [vonageUuid]
 * @property {string} [zipCode]
 */

/**
 * @typedef {Object} UserInfoDetailsOutputType
 * @property {string} [address]
 * @property {string} [age]
 * @property {StaffEntity} [assignedStaff]
 * @property {string} [clinicId]
 * @property {Array<ClinicEntity>} [clinics]
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {string} [email]
 * @property {Array<FamilyMemberEntity>} [familyMembers]
 * @property {string} [fitbitAccessToken]
 * @property {string} [fitbitId]
 * @property {string} [fitbitRefreshToken]
 * @property {string} [fitbitScopes]
 * @property {string} [id]
 * @property {string} [idNumber]
 * @property {boolean} [isSubscribed]
 * @property {number} [lastMessageAt]
 * @property {string} [name]
 * @property {Array<NoteEntity>} [notes]
 * @property {string} [notificationPreferenceType]
 * @property {string} [password]
 * @property {Array<StudyPermissionEntity>} [permissions]
 * @property {Array<PhoneNumberEntity>} [phoneNumbers]
 * @property {string} [preferredLanguage]
 * @property {string} [preferredTime]
 * @property {RoleEntity} [primaryRole]
 * @property {boolean} [privateNotes]
 * @property {Array<EmailEntity>} [receiverEmails]
 * @property {Array<MessageEntity>} [receiverMessages]
 * @property {Array<NotificationEntity>} [receiverNotifications]
 * @property {Array<VoiceEntity>} [receiverVoices]
 * @property {Array<StudyRoleEntity>} [roles]
 * @property {Array<EmailEntity>} [senderEmails]
 * @property {Array<MessageEntity>} [senderMessages]
 * @property {Array<NotificationEntity>} [senderNotifications]
 * @property {Array<VoiceEntity>} [senderVoices]
 * @property {string} [sexualOrientation]
 * @property {DateTime} [startDate]
 * @property {string} [status]
 * @property {Array<StudyEntity>} [studies]
 * @property {string} [studyArm]
 * @property {Array<number>} [studyArmsId]
 * @property {string} [timezone]
 * @property {Array<TreatmentEntity>} [treatments]
 * @property {DateTime} [updatedAt]
 * @property {string} [vonageName]
 * @property {string} [vonageUuid]
 * @property {string} [zipCode]
 */

/**
 * @typedef {Object} UserInputType
 * @property {string} [description]
 * @property {string} email
 * @property {string} name
 * @property {string} password
 * @property {number} roleId
 * @property {string} status
 */

/**
 * @typedef {Object} UserLoginOutputType
 * @property {string} [token]
 * @property {UserEntity} [user]
 */

/**
 * @typedef {Object} UserPermissionInputType
 * @property {Array<number>} permissions
 * @property {number} roleId
 * @property {Array<number>} [studyArmIds]
 * @property {number} studyId
 */

/**
 * @typedef {Object} UserProfileDetailInputType
 * @property {AssignedStaffInputType} [assignedStaff]
 * @property {DateTime} [startDate]
 */

/**
 * @typedef {Object} UserProfileDetailType
 * @property {string} [address]
 * @property {string} [age]
 * @property {StaffEntity} [assignedStaff]
 * @property {string} [clinicId]
 * @property {Array<ClinicEntity>} [clinics]
 * @property {DateTime} [createdAt]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {string} [email]
 * @property {Array<FamilyMemberEntity>} [familyMembers]
 * @property {string} [fitbitAccessToken]
 * @property {string} [fitbitId]
 * @property {string} [fitbitRefreshToken]
 * @property {string} [fitbitScopes]
 * @property {string} [id]
 * @property {string} [idNumber]
 * @property {boolean} [isSubscribed]
 * @property {number} [lastMessageAt]
 * @property {string} [name]
 * @property {Array<NoteEntity>} [notes]
 * @property {string} [notificationPreferenceType]
 * @property {string} [password]
 * @property {Array<StudyPermissionEntity>} [permissions]
 * @property {Array<PhoneNumberEntity>} [phoneNumbers]
 * @property {string} [preferredLanguage]
 * @property {string} [preferredTime]
 * @property {RoleEntity} [primaryRole]
 * @property {boolean} [privateNotes]
 * @property {Array<EmailEntity>} [receiverEmails]
 * @property {Array<MessageEntity>} [receiverMessages]
 * @property {Array<NotificationEntity>} [receiverNotifications]
 * @property {Array<VoiceEntity>} [receiverVoices]
 * @property {Array<StudyRoleEntity>} [roles]
 * @property {Array<EmailEntity>} [senderEmails]
 * @property {Array<MessageEntity>} [senderMessages]
 * @property {Array<NotificationEntity>} [senderNotifications]
 * @property {Array<VoiceEntity>} [senderVoices]
 * @property {string} [sexualOrientation]
 * @property {DateTime} [startDate]
 * @property {string} [status]
 * @property {Array<StudyEntity>} [studies]
 * @property {Array<number>} [studyArmsId]
 * @property {string} [timezone]
 * @property {Array<TreatmentEntity>} [treatments]
 * @property {DateTime} [updatedAt]
 * @property {string} [vonageName]
 * @property {string} [vonageUuid]
 * @property {string} [zipCode]
 */

/**
 * @typedef {Object} UserProfileDetailsInputType
 * @property {string} [address]
 * @property {string} [age]
 * @property {AssignedStaffInputType} [assignedStaff]
 * @property {string} [clinicId]
 * @property {Array<ClinicInputType>} clinics
 * @property {Array<FamilyMemberInputType>} familyMembers
 * @property {string} [idNumber]
 * @property {string} name
 * @property {Array<PhoneNumberInputType>} phoneNumbers
 * @property {string} [preferredLanguage]
 * @property {string} [preferredTime]
 * @property {string} [sexualOrientation]
 * @property {DateTime} [startDate]
 * @property {Array<TreatmentInputType>} treatments
 * @property {string} [zipCode]
 */

/**
 * @typedef {Object} UserProfileInfoInputType
 * @property {string} [address]
 * @property {string} [clinicId]
 * @property {Array<ClinicInputType>} clinics
 * @property {Array<FamilyMemberInputType>} familyMembers
 * @property {string} [idNumber]
 * @property {string} name
 * @property {Array<PhoneNumberInputType>} phoneNumbers
 * @property {string} [preferredLanguage]
 * @property {Array<TreatmentInputType>} treatments
 */

/**
 * @typedef {Object} UserStudyInputType
 * @property {number} [studyArmId]
 * @property {number} studyId
 * @property {number} userId
 */

/**
 * @typedef {Object} UserSubscriptionEntity
 * @property {DateTime} createdAt
 * @property {DateTime} [deletedAt]
 * @property {UserEntity} fromUser
 * @property {string} id
 * @property {boolean} isSubscribed
 * @property {NotificationpPreferencesEntity} notificationPreference
 * @property {UserEntity} toUser
 * @property {DateTime} updatedAt
 */

/**
 * @typedef {Object} UserUpdateInputType
 * @property {string} [description]
 * @property {string} email
 * @property {string} name
 * @property {boolean} [privateNotes]
 * @property {number} [roleId]
 * @property {string} status
 */

/**
 * @typedef {Object} UserVerifiedInputType
 * @property {boolean} verified
 */

/**
 * @typedef {Object} UsersOutputType
 * @property {number} count
 * @property {Array<UserEntity>} items
 */

/**
 * @typedef {Object} VoiceEntity
 * @property {string} [actions]
 * @property {string} [audioUrl]
 * @property {DateTime} createdAt
 * @property {string} [data]
 * @property {DateTime} [deletedAt]
 * @property {string} [description]
 * @property {number} id
 * @property {string} [labels]
 * @property {boolean} liked
 * @property {UserEntity} [receiver]
 * @property {number} [receiverId]
 * @property {UserEntity} [sender]
 * @property {number} [senderId]
 * @property {StudyEntity} [study]
 * @property {StudyArmEntity} [studyArm]
 * @property {string} title
 * @property {string} [type]
 * @property {DateTime} updatedAt
 * @property {string} [url]
 * @property {boolean} viewed
 */

/**
 * @typedef {Object} VoicesInput
 * @property {string} [actions]
 * @property {string} [data]
 * @property {string} [description]
 * @property {number} [id]
 * @property {string} [labels]
 * @property {boolean} [liked]
 * @property {number} [studyArmId]
 * @property {number} [studyId]
 * @property {string} [title]
 * @property {string} [type]
 * @property {string} [url]
 * @property {boolean} [viewed]
 */

/**
 * @typedef {Object} VoicesOutput
 * @property {number} count
 * @property {Array<VoiceEntity>} items
 */

import { gql } from "@apollo/client/core"
export const typeDefs = gql('schema{query:Query mutation:Mutation}"Indicates exactly one field must be supplied and this field must not be `null`." directive@oneOf on INPUT_OBJECT type ActivityLevel{minutes:Float!name:String!}type ArchiveOutput{createdAt:Float!duration:String!hasAudio:String!hasVideo:String!id:String!name:String!outputMode:String!partnerId:String!projectId:String!reason:String!resolution:String!sessionId:String!size:Float!status:String!streamMode:String!streams:[Stream!]!url:String!}type AssessmentAnswerEntity{answerDate:DateTime comment:String!createdAt:DateTime!deletedAt:DateTime id:ID!question:AssessmentQuestionEntity updatedAt:DateTime!value:JSONObject values:[String!]}input AssessmentAnswerInputType{answerDate:DateTime comment:String id:Float questionId:Float!value:JSONObject values:[String!]}type AssessmentQuestionEntity{automation:JSONObject category:QuestionCategoryEntity conditions:String createdAt:DateTime!deletedAt:DateTime icon:String id:ID!identifier:String isAnswered:Boolean label:String!meta:JSONObject options:String order:Float questions:[AssessmentQuestionEntity!]symptomName:String symptomNameEs:String tooltip:TooltipEntity type:String updatedAt:DateTime!variableName:String}input AssessmentQuestionInputType{automation:JSONObject category:QuestionCategoryInputType conditions:String createdAt:DateTime deletedAt:DateTime icon:String id:ID identifier:String isAnswered:Boolean label:String meta:JSONObject options:String order:Float questions:[AssessmentQuestionInputType!]symptomName:String symptomNameEs:String tooltip:TooltipInputType type:String updatedAt:DateTime variableName:String}type AssessmentQuestionOutputType{count:Int!items:[AssessmentQuestionEntity!]!}input AssessmentQuestionWhereInputType{id:Float identifier:String label:String type:String variableName:String}type AssessmentResponseEntity{answerDate:DateTime answers:[AssessmentAnswerEntity!]conversationUUID:String createdAt:DateTime!deletedAt:DateTime id:ID!incrementFollowupQuestionsCount:Float library:LibraryEntity!libraryId:Int!preIVRQuestionsRequired:Boolean skippedQuestionCount:Float skippedQuestionsBySystemCount:Float study:StudyEntity studyArm:StudyArmEntity triggeredAutomationIndexes:String!updatedAt:DateTime!user:UserEntity!userId:Int!}input AssessmentResponseInputType{answerDate:DateTime answers:[AssessmentAnswerInputType!]!conversationUUID:String library:Float!preIVRQuestionsRequired:Boolean studyArmId:Float studyId:Float user:Float}type AssessmentResponseOutputType{count:Int!items:[AssessmentResponseEntity!]!}input AssessmentResponseWithTokenInputType{answers:[AssessmentAnswerInputType!]!}input AssessmentResponsesWhereInputType{answerDate:DateTime conversationUUID:String id:Float libraryId:Float libraryIds:[Float!]userId:Float}type AssessmentsAnsweredResponseOutputType{date:DateTime!isAnswered:Boolean!}input AssignedStaffInputType{id:ID!name:String role:RoleAutoCompleteInputType}type AuditEntity{action:String!id:Float!newData:String notify:Boolean!oldData:String study:StudyEntity studyArm:StudyArmEntity tableName:String!updatedAt:DateTime!user:UserEntity}input AuditInput{action:String id:Float newData:String notify:Boolean oldData:String studyArmId:Float studyId:Float tableName:String updatedAt:DateTime userId:Float}type AuditOutput{count:Int!items:[AuditEntity!]!}type AuthOutputType{token:String}input AutomationActionType{data:String do:String!where:String!who:[AutomationActionWhoType!]!}input AutomationActionWhoType{id:Int!name:String!type:String!}input AutomationConditionType{logic:String!operator:String!question:String!value:String!what:String!}input AutomationInputType{actions:[AutomationActionType!]!conditions:[AutomationConditionType!]!}type AutomationWhoOutputType{id:Int!name:String!type:String!}type CallRecordingOutputType{createdAt:DateTime!durationSeconds:Int format:String!recordingId:Int!url:String!}type CanDeleteLibraryOutputType{canDelete:Boolean!message:String!}type ChartEntity{category:ChartTabEntity!categoryId:Float createdAt:DateTime!dataSource:AssessmentQuestionEntity!dataSource1:AssessmentQuestionEntity deletedAt:DateTime fullWidth:Boolean!id:ID!meta:JSONObject plots:[String!]!plots1:[String!]title:String!title1:String type:String!type1:String updatedAt:DateTime!user:UserEntity!xAxis:String!yAxis:String!yAxis1:String}type ChartTabEntity{createdAt:DateTime!id:ID!order:Float title:String!updatedAt:DateTime!userId:Float}input ChartTabInputType{id:Float title:String!}type ChartTabOutputType{chartCount:Int!createdAt:DateTime!id:ID!order:Float title:String!updatedAt:DateTime!userId:Float}type ChatMessageDetailOutputType{attachments:[JSONObject!]conversationId:String!isRead:Boolean!messageDate:DateTime!messageId:Int!recipientId:Int!recipientName:String!recipientRole:String!senderId:Int!senderName:String!senderRole:String!text:String!}type ClinicEntity{createdAt:DateTime!deletedAt:DateTime doctorName:String!id:ID!name:String!phoneNumber:PhoneNumberEntity updatedAt:DateTime!}input ClinicInputType{createdAt:DateTime deletedAt:DateTime doctorName:String id:ID name:String phoneNumber:PhoneNumberInputType updatedAt:DateTime}type CoachingAssessmentForNotesOutput{hasCoachingAssessment:Boolean!noteId:Int}type CoachingCallDetailOutputType{assessmentQuestions:[IvrQuestionAnswerOutputType!]callDate:DateTime!coachId:Int!coachName:String!coachingCallId:Int!durationMinutes:Int libraryDetails:JSONObject noteAttachments:[JSONObject!]noteIds:[Int!]notes:String recording:CallRecordingOutputType}type CoachingEvents{end:DateTime id:Float!libraryId:Int start:DateTime!status:String type:String!}type CommunicationCallDetailOutputType{callDate:DateTime!callParticipants:[CommunicationCallParticipantType!]!callType:String!communicationCallId:Int!durationMinutes:Int recording:CallRecordingOutputType}type CommunicationCallParticipantType{role:String!userId:Int!userName:String!}type ConferenceEntity{answerTimestamp:String conversationUuid:String createdAt:DateTime!deletedAt:DateTime dtmf:Boolean!endDate:DateTime eventId:Int fromUserId:Int id:ID!machineDetectionMeta:String machineDetectionStatus:String meta:String notes:[NoteEntity!]officialTouchpoint:Boolean recording:RecordingEntity sessionId:String status:String studyId:Int title:String toUserId:Int type:String updatedAt:DateTime!}input ConferenceInputType{noteId:Float officialTouchpoint:Boolean status:String studyId:Float type:String}type ConferenceOutputType{count:Int!items:[ConferenceEntity!]!}input ConferenceWhereInputType{conversationUuid:String fromUserId:Float id:Float sessionId:String studyId:Float toUserId:Float type:String}type ConferenceWithUsersOutputType{count:Int!items:[ConferenceWithUsersRelation!]!}type ConferenceWithUsersRelation{answerTimestamp:String conversationUuid:String createdAt:DateTime!deletedAt:DateTime dtmf:Boolean!endDate:DateTime eventId:Int fromUser:UserEntity!fromUserId:Int id:ID!machineDetectionMeta:String machineDetectionStatus:String meta:String notes:[NoteEntity!]officialTouchpoint:Boolean recording:RecordingEntity sessionId:String status:String studyId:Int title:String toUser:UserEntity!toUserId:Int type:String updatedAt:DateTime!}input CountryInputType{countryCallingCode:String!countryCode:String!nationalNumber:String!numberValue:String!}type CountryPhoneNumberEntity{countryCallingCode:String!countryCode:String!createdAt:DateTime!deletedAt:DateTime id:ID!nationalNumber:String!numberValue:String!updatedAt:DateTime!}input CountryPhoneNumberInput{countryCallingCode:String countryCode:String createdAt:DateTime deletedAt:DateTime id:ID nationalNumber:String numberValue:String updatedAt:DateTime}input CreateChartInput{categoryId:Int!dataSourceId:Int!dataSourceId1:Int fullWidth:Boolean!meta:JSONObject plots:[String!]!plots1:[String!]title:String!title1:String type:String!type1:String userId:Int!xAxis:String!yAxis:String!yAxis1:String}input CreateEmailInput{actions:String data:String description:String labels:String liked:Boolean studyArmId:Float studyId:Float title:String!type:String user:Float viewed:Boolean}input CreateEventInput{actions:String azureEventQueueScheduledMessageId:String confirmed:Float data:String description:String emailMessageContent:JSONObject end:DateTime!hostId:Float labels:String libraryConfigId:Float liked:Boolean pushNotificationMessageContent:JSONObject rescheduleTimeInMinutes:Float resource:String schedulingStatus:EventSchedulingStatus shouldReschedule:Boolean start:DateTime!status:String studyArmId:Float studyId:Float studyIds:[Float!]!textMessageContent:String title:String!type:String userIds:[Float!]!viewed:Boolean}input CreateMessageInput{actions:String data:String description:String labels:String liked:Boolean studyArmId:Float studyId:Float title:String!type:String user:Float!viewed:Boolean}input CreateNoteInput{actions:String conferenceId:Float data:String description:String editorId:Float entity:String labels:String libraryId:Float liked:Boolean parentId:Float status:String title:String!type:String userId:Float viewed:Boolean}input CreateNotificationInput{actions:String data:String description:String labels:String liked:Boolean studyArmId:Float studyId:Float title:String!type:String user:Float!viewed:Boolean}input CreateStudyPermissionInput{permissionId:Float!studyId:Float!}input CreateStudyRoleInput{id:Float roleId:Float!studyId:Float!}input CreateSuggestedDateInput{endTime:DateTime!eventId:Int!startTime:DateTime!}input CreateUserSubscriptionInput{notificationPreference:String!userId:Float!}input CreateVoiceInput{actions:String data:String description:String labels:String liked:Boolean studyArmId:Float studyId:Float title:String!type:String url:String user:Float!viewed:Boolean}"""A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format.""" scalar DateTime type EmailDetailOutputType{attachments:[JSONObject!]content:String!emailDate:DateTime!emailId:Int!emailType:String isRead:Boolean recipientId:Int!recipientName:String!recipientRole:String!senderId:Int!senderName:String!senderRole:String!subject:String}type EmailEntity{actions:String createdAt:DateTime!data:String deletedAt:DateTime description:String id:Float!labels:String liked:Boolean!receiver:UserEntity receiverId:Float sender:UserEntity senderId:Float study:StudyEntity studyArm:StudyArmEntity title:String!type:String updatedAt:DateTime!viewed:Boolean!}input EmailsInput{actions:String data:String description:String id:Float labels:String liked:Boolean title:String type:String viewed:Boolean}type EmailsOutput{count:Int!isGroupChat:Boolean!items:[EmailEntity!]!}type EventEntity{actions:String azureEventQueueScheduledMessageId:String confirmed:Float!createdAt:DateTime!data:String deletedAt:DateTime description:String emailMessageContent:String end:DateTime!id:Float!labels:String libraryConfigId:Float liked:Boolean!pushNotificationMessageContent:String receiver:UserEntity rescheduleTimeInMinutes:Float resource:String schedulingStatus:String!sender:UserEntity shouldReschedule:Boolean!start:DateTime!startForIVR:DateTime status:String study:StudyEntity studyArm:StudyArmEntity textMessageContent:String title:String!type:String updatedAt:DateTime!viewed:Boolean!}input EventMetricsInputType{studyArmId:Float studyId:Float}type EventMetricsOutputType{completedCount:Int!completedCountMonth:Int!incompleteCount:Int!incompleteCountMonth:Int!missedCount:Int!missedCountMonth:Int!totalCount:Int!totalCountMonth:Int!}enum EventSchedulingStatus{CANCELED COMPLETED PENDING}type EventWithTimeWindow{event:EventEntity!libraryConfig:StudyArmLibraryConfigsEntity windowEndTime:DateTime!windowStartTime:DateTime!}input EventsInput{actions:String confirmed:Float data:String description:String end:DateTime id:Float labels:String liked:Boolean resource:String start:DateTime title:String type:String viewed:Boolean}type EventsOutput{count:Int!items:[EventEntity!]!}type ExportContentMetadataType{dataTypesIncluded:[String!]!dateRangeFrom:String!dateRangeTo:String!exportedAt:String!studyArmName:String!studyName:String!totalDataPoints:Int!totalParticipants:Int!}"""The types of data to include in the export.""" enum ExportDataTypesEnum{CHAT_MESSAGES COACHING_CALLS COMMUNICATION_CALLS EMAILS FITBIT IVR_CALLS JOURNALS}type ExportFileContentMetadataType{contentType:String!dataTypeDisplay:String!description:String exportRequestId:Int!fetchedAt:String!fileName:String!schemaVersion:String}type ExportFileContentResponseType{content:JSON!metadata:ExportFileContentMetadataType!}"""The specific content type of an exported file for type-safe access.""" enum ExportFileContentType{CHAT_MESSAGES_ONLY COACHING_CALLS_ONLY COMMUNICATION_CALLS_ONLY EMAILS_ONLY FITBIT_DATA_ONLY FULL_PARTICIPANT_DATA IVR_CALLS_ONLY JOURNAL_ENTRIES_ONLY SUMMARY_METRICS}type ExportRequestOutputType{completedAt:DateTime errorMessage:String exportParameters:JSONObject!generatedFiles:[ExportedFileRecordType!]id:Int!requestedAt:DateTime!requestedById:Int!status:ExportRequestStatus!studyId:Int!updatedAt:DateTime!}"""The status of a data export request.""" enum ExportRequestStatus{COMPLETED FAILED PENDING PROCESSING}input ExportStudyInput{dataTypes:[ExportDataTypesEnum!]!fromDate:String!participantIds:[Int!]!studyArmId:Int!studyId:Int!toDate:String!}type ExportedFileRecordType{contentType:ExportFileContentType!dataTypeDisplay:String!description:String expectedDataStructure:String fileName:String!format:String!schemaVersion:String url:String!}type FamilyMemberEntity{createdAt:DateTime!deletedAt:DateTime id:ID!name:String!phoneNumber:PhoneNumberEntity relationship:String!updatedAt:DateTime!}input FamilyMemberInputType{createdAt:DateTime deletedAt:DateTime id:ID name:String phoneNumber:PhoneNumberInputType relationship:String updatedAt:DateTime}type FileEntity{createdAt:DateTime!deletedAt:DateTime description:String id:Float!path:String size:Float title:String!type:String updatedAt:DateTime!url:String}input FilesInput{description:String id:Float path:String size:Float title:String type:String url:String}type FilesOutput{count:Int!items:[FileEntity!]!}type FitbitActivityEntity{activityLevel:[ActivityLevel!]averageHeartRate:Float calories:Float createdAt:DateTime!data:[JSONObject!]date:DateTime!deletedAt:DateTime distance:Float distanceUnit:String duration:Float!elivation:Float id:ID!name:String!pace:Float speed:Float startTime:String!steps:Float updatedAt:DateTime!user:UserEntity version:String!}type FitbitActivityTrendData{dateTime:String!value:Float!}input FitbitActivityTrendInputType{date:String period:String!resource:String!userId:Float!}type FitbitChartsData{activity:[FitbitActivityEntity!]!distance:[FitbitDistanceEntity!]!heartRate:[FitbitHeartRateEntity!]!sleep:[FitbitSleepEntity!]!steps:[FitbitStepsEntity!]!}type FitbitDistanceEntity{createdAt:DateTime!data:[JSONObject!]date:DateTime!deletedAt:DateTime id:ID!updatedAt:DateTime!user:UserEntity value:String!version:String!}type FitbitEntity{createdAt:DateTime!data:JSONObject deletedAt:DateTime hash:String id:ID!type:String!updatedAt:DateTime!userId:Int!}type FitbitHeartRateEntity{createdAt:DateTime!data:[JSONObject!]date:DateTime!deletedAt:DateTime id:ID!restingHeartRate:Float!updatedAt:DateTime!user:UserEntity version:String!}type FitbitHistoryEntity{createdAt:DateTime!data:JSONObject id:ID!statusCode:Float type:String!url:String userId:Float}type FitbitLifetimeStats{label:String!metric:String!}type FitbitSleepEntity{createdAt:DateTime!data:[JSONObject!]date:DateTime!deletedAt:DateTime duration:Float!endTime:String!id:ID!startTime:String!updatedAt:DateTime!user:UserEntity version:String!}type FitbitStepsEntity{createdAt:DateTime!data:[JSONObject!]date:DateTime!deletedAt:DateTime id:ID!updatedAt:DateTime!user:UserEntity value:String!version:String!}type FitbitWeightEntity{bmi:Float!createdAt:DateTime!data:[JSONObject!]date:DateTime!deletedAt:DateTime fat:Float!id:ID!updatedAt:DateTime!user:UserEntity version:String!weight:Float!}input GraphDataPointsInput{fromDate:String!questionsId:[Float!]!toDate:String!userId:Float!}type GraphDataPointsOutput{items:[AssessmentAnswerEntity!]!}input InviteParticipantInputType{age:String clinicId:String email:String!name:String!numbersForCalls:[CountryInputType!]numbersForMessages:[CountryInputType!]preferredLanguage:String sexualOrientation:String startDate:DateTime studyArm:Float studyId:Float timezone:String}input InviteStaffInputType{email:String!name:String!role:Float!studyArmIds:[Float!]}type InviteStaffOutputType{errors:[String!]users:[UserEntity!]!}type IvrCallDetailOutputType{callDate:DateTime!durationSeconds:Int ivrCallId:Int!libraryDetails:JSONObject questionsAndAnswers:[IvrQuestionAnswerOutputType!]!status:String!}type IvrQuestionAnswerOutputType{answerValue:String answeredAt:DateTime!questionDetails:JSONObject questionId:Int!questionText:String!}"""The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).""" scalar JSON """The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).""" scalar JSONObject type JournalEntryDetailOutputType{actions:[JSONObject!]attachments:[JSONObject!]authorId:Int authorName:String entryDate:DateTime!journalEntryId:Int!lastEditorId:Int lastEditorName:String libraryDetails:JSONObject questionsAndAnswers:[IvrQuestionAnswerOutputType!]status:String text:String!title:String updatedAtDate:DateTime}type LibraryEntity{assessmentResponses:[AssessmentResponseEntity!]automations:String createdAt:DateTime!creator:UserEntity deletedAt:DateTime duration:Float icon:String id:ID!initialMessage:String libraryConfigs:[StudyArmLibraryConfigsEntity!]preIVRDuration:Float preIVRDurationType:String questions:[AssessmentQuestionEntity!]studies:[StudyEntity!]studyArms:[StudyArmEntity!]subsets:[LibraryEntity!]superset:LibraryEntity title:String!tooltip:TooltipEntity type:String updatedAt:DateTime!}type LibraryOutputType{count:Int!items:[LibraryEntity!]!types:[String!]!}input LibraryWhereInputType{id:Float title:String type:[String!]}input LimitInput{skip:Float=0 take:Float=100}input ManageChartTabInputType{create:[ChartTabInputType!]!=[]delete:[Int!]!=[]update:[ChartTabInputType!]!=[]}type ManageChartTabResponseType{success:Boolean!}type MedicationEntity{createdAt:DateTime!deletedAt:DateTime description:String!id:ID!label:String!treatment:Boolean!updatedAt:DateTime!userId:Int!}input MedicationInputType{description:String!label:String!treatment:Boolean}type MedicationOutputType{count:Int!items:[MedicationEntity!]!}input MedicationWhereInputType{creatorId:Float description:String id:Float label:String treatment:Boolean userId:Float}input MemberInputType{address:String age:String clinicId:String createdAt:DateTime deletedAt:DateTime description:String email:String fitbitAccessToken:String fitbitId:String fitbitRefreshToken:String fitbitScopes:String id:ID idNumber:String isSubscribed:Boolean lastMessageAt:Float name:String notificationPreferenceType:String password:String preferredLanguage:String preferredTime:String privateNotes:Boolean sexualOrientation:String startDate:DateTime status:String studyArmsId:[Float!]timezone:String updatedAt:DateTime vonageName:String vonageUuid:String zipCode:String}type MessageEntity{actions:String createdAt:DateTime!data:String deletedAt:DateTime description:String id:Float!labels:String liked:Boolean!receiver:UserEntity receiverId:Float sender:UserEntity senderId:Float study:StudyEntity studyArm:StudyArmEntity title:String!type:String updatedAt:DateTime!viewed:Boolean!vonageId:String}input MessagesInput{actions:String data:String description:String id:Float labels:String liked:Boolean title:String type:String viewed:Boolean}type MessagesOutput{count:Int!isGroupChat:Boolean!items:[MessageEntity!]!}type MetricsAdherence{endDate:DateTime id:Float!receiver:UserEntity!startDate:DateTime!status:String type:String!}type MetricsAdherenceOutput{adherenceItems:[MetricsAdherence!]!completedJournals:Int libraries:[LibraryEntity!]}input MetricsInputType{fromUserId:Float studyId:Float toUserId:Float type:String}type MetricsOutputType{count:Int!enrolledCount:Int!increasedCountRate:Float!increasedDurationRate:Float!increasedEnrollRate:Float!totalDuration:Float!}type MetricsUsersOutputType{participantCount:Int!participantCountMonth:Int!}input ModuleInputType{automations:String createdAt:DateTime creator:MemberInputType deletedAt:DateTime duration:Float icon:String id:ID initialMessage:String preIVRDuration:Float preIVRDurationType:String questions:[AssessmentQuestionInputType!]subsets:[ModuleInputType!]superset:ModuleInputType title:String tooltip:TooltipInputType type:String updatedAt:DateTime}type Mutation{addAssessmentAnswer(id:Float!updateAssessmentAnswerInput:AssessmentAnswerInputType!):AssessmentResponseEntity addMedication(data:MedicationInputType!userId:Float!):MedicationEntity addSymptom(data:SymptomInputType!userId:Float!):SymptomEntity chartTab(id:ID!):ChartTabEntity!confirmEvent(confirmEventInput:UpdateEventInput!id:Float!):EventEntity confirmProposedTimeForEvent(id:Float!updateEventInput:UpdateEventInput!):EventEntity createAssessmentQuestion(question:AssessmentQuestionInputType!):AssessmentQuestionEntity createAssessmentResponse(assessmentResponse:AssessmentResponseInputType!):AssessmentResponseEntity createAssessmentResponseWithToken(assessmentResponse:AssessmentResponseWithTokenInputType!token:String!):AssessmentResponseEntity createChart(payload:CreateChartInput!):ChartEntity createChartTab(title:String!userId:ID!):ChartTabEntity!createEmail(createEmailInput:CreateEmailInput!files:[Upload!]=[]):EmailEntity createEvent(createEventInput:CreateEventInput!):[EventEntity!]createFile(file:Upload!):FileEntity createFiles(files:[Upload!]!):[FileEntity!]createLibrary(automations:[AutomationInputType]=[]duration:Float=0 icon:String="" iconFile:[Upload!]=[]initialMessage:String="" preIVRDuration:Float=0 preIVRDurationType:String="Weeks" questions:[AssessmentQuestionInputType]title:String!type:String=""):LibraryEntity createLibrarySubset(questionIds:[String]supersetId:Float!title:String!):LibraryEntity createMessage(createMessageInput:CreateMessageInput!):MessageEntity createModule(module:ModuleInputType!):LibraryEntity createNote(createNoteInput:CreateNoteInput!files:[Upload!]=[]):NoteEntity createNotification(createNotificationInput:CreateNotificationInput!):NotificationEntity createPermission(permission:PermissionInputType!):PermissionEntity createRole(permissions:[PermissionPartialInputType!]role:RoleInputType!userStudyList:[UserStudyInputType!]):RoleEntity createStudy(arms:[StudyArmInputType]moduleId:String staff:[StudyStaffInputType]study:StudyInputType!):StudyEntity createStudyPermission(createStudyPermissionInput:CreateStudyPermissionInput!):StudyPermissionEntity createStudyRole(createStudyRoleInput:CreateStudyRoleInput!):StudyRoleEntity createSuggestedDate(createSuggestedDateInput:CreateSuggestedDateInput!):SuggestedDateEntity!createUser(user:UserInputType!):UserEntity createUserSubscription(createUserSubscriptionInput:CreateUserSubscriptionInput!):UserSubscriptionEntity createVoice(createVoiceInput:CreateVoiceInput!):VoiceEntity deleteChart(id:Float!):ChartEntity deleteChartTab(id:ID!):ChartTabEntity!deleteEmail(id:Float!):EmailEntity deleteEvent(id:Float!):EventEntity deleteFile(id:Float!):FileEntity deleteLibrary(id:Float!):String deleteMessage(id:Float!):MessageEntity deleteNote(id:Float!):NoteEntity deleteNotification(id:Float!):NotificationEntity deletePermission(id:Float!):PermissionEntity deleteRole(ids:[Float!]!):[RoleEntity!]deleteStudy(id:Float!):StudyEntity deleteStudyPermission(id:Float!):StudyPermissionEntity deleteStudyRole(id:Float!):StudyRoleEntity deleteUser(ids:[Float!]!):[UserEntity!]deleteVoice(id:Float!):VoiceEntity inviteParticipant(data:InviteParticipantInputType!):UserEntity inviteStaff(data:[InviteStaffInputType!]!studyId:Float=null):InviteStaffOutputType likeAllEmails(user:Float=0):Float likeAllEvents(user:Float=0):Float likeAllMessages(user:Float=0):Float likeAllNotes:Float likeAllNotifications(user:Float=0):Float likeAllVoices(user:Float=0):Float manageChartTabs(data:ManageChartTabInputType!userId:ID!):ManageChartTabResponseType!requestStudyExport(input:ExportStudyInput!):ExportRequestOutputType!resetPassword(newPassword:String!token:String!):Boolean sendInviteEmail(email:String!):Boolean sendMMS(files:[Upload!]!phoneNumber:String studyArmId:Float studyId:Float text:String!user:Float):[MessageEntity!]sendResetPasswordLink(email:String!):Boolean sendSMS(phoneNumber:String studyArmId:Float studyId:Float text:String!user:Float!):MessageEntity sendVideoConferenceSMS(studyArmId:Float studyId:Float user:Float!vonageSessionId:String!):MessageEntity shortenString(originalString:String!):String!startConference(conversationUuid:String fromUserId:Float sessionId:String studyId:Float toUserId:Float type:String!):ConferenceEntity stopVideoCall(sessionId:String!):ConferenceEntity testOutboundCall:Boolean unsubscribeUser(userId:Float!):Boolean updateAssessmentAnswer(id:Float!updateAssessmentAnswerInput:AssessmentAnswerInputType!):AssessmentResponseEntity updateAssessmentQuestion(id:Float!question:AssessmentQuestionInputType!):AssessmentQuestionEntity updateAssessmentResponse(assessmentResponse:AssessmentResponseInputType!id:Float!):AssessmentResponseEntity updateChart(id:Float!payload:UpdateChartInput!):ChartEntity updateChartTab(id:ID!title:String!):ChartTabEntity!updateCoachingEventStatus(date:DateTime!id:Float!status:String!):EventEntity updateConference(id:Float!updateConferenceInput:ConferenceInputType!):ConferenceEntity!updateEmail(id:Float!updateEmailInput:UpdateEmailInput!):EmailEntity updateEvent(id:Float!updateEventInput:UpdateEventInput!):EventEntity updateFile(id:Float!updateFileInput:UpdateFileInput!):FileEntity updateLibrary(automations:[AutomationInputType]=[]duration:Float=0 iconFile:[Upload!]=[]id:Float!initialMessage:String="" preIVRDuration:Float=0 preIVRDurationType:String="Weeks" questions:[AssessmentQuestionInputType]title:String!):LibraryEntity updateMessage(id:Float!updateMessageInput:UpdateMessageInput!):MessageEntity updateNote(files:[Upload!]=[]id:Float!updateNoteInput:UpdateNoteInput!):NoteEntity updateNotification(id:Float!updateNotificationInput:UpdateNotificationInput!):NotificationEntity updateNotificationPreference(notificationPreference:String!userId:Float!):NotificationpPreferencesEntity updatePermission(id:Float!permission:PermissionInputType!):PermissionEntity updateRole(id:Float!permissions:[PermissionPartialInputType!]role:RoleInputType!userStudyList:[UserStudyInputType!]):RoleEntity updateStudy(arms:[StudyArmInputType]id:Float!moduleId:String staff:[StudyStaffInputType]study:StudyInputType!updatedAtTimestamp:DateTime!):StudyEntity updateStudyPermission(id:Float!updateStudyPermissionInput:UpdateStudyPermissionInput!):StudyPermissionEntity updateStudyRole(id:Float!updateStudyRoleInput:UpdateStudyRoleInput!):StudyRoleEntity updateUser(id:Float!user:UserUpdateInputType!):UserEntity updateUserPermissions(userId:Float!userPermissions:[UserPermissionInputType!]!):UserEntity updateUserProfileDetail(data:UserProfileDetailInputType!id:Float!):UserEntity updateUserProfileInfoDetails(data:UserProfileDetailsInputType!id:Float!):UserEntity updateUserProfileInformation(data:UserProfileInfoInputType!id:Float!):UserEntity updateVoice(id:Float!updateVoiceInput:UpdateVoiceInput!):VoiceEntity uploadIcon(iconFile:[Upload!]=[]):String validateDirectSignin(token:String!):UserEntity verifyUser(id:Float!):UserEntity viewAllEmails(user:Float=0):Float viewAllEvents(user:Float=0):Float viewAllMessages(user:Float=0):Float viewAllNotes:Float viewAllNotifications(user:Float=0):Float viewAllVoices(user:Float=0):Float}type NoteEntity{actions:String assessmentResponse:AssessmentResponseEntity conference:ConferenceEntity createdAt:DateTime!data:String deletedAt:DateTime description:String editor:UserEntity entity:String id:Float!isPinned:Boolean!labels:String liked:Boolean!parentId:Float status:String title:String!type:String updatedAt:DateTime!user:UserEntity!userId:Float viewed:Boolean!}input NotesInput{actions:String assessmentResponseId:Float conferenceId:Float data:String description:String editor:Float entity:String id:Float labels:String liked:Boolean parentId:Float status:String title:String type:String user:Float viewed:Boolean}type NotesOutput{count:Int!items:[NoteEntity!]!}type NotificationEntity{actions:String createdAt:DateTime!data:String deletedAt:DateTime description:String id:Float!isSubscribed:Boolean labels:String liked:Boolean!study:StudyEntity studyArm:StudyArmEntity studyId:Float title:String!type:String updatedAt:DateTime!viewed:Boolean!}type NotificationpPreferencesEntity{createdAt:DateTime!deletedAt:DateTime id:ID!subscription:UserSubscriptionEntity!type:String!updatedAt:DateTime!}input NotificationsInput{actions:String data:String description:String id:Float labels:String liked:Boolean receiverId:Float studyArmId:Float studyId:Float title:String type:String viewed:Boolean}type NotificationsOutput{count:Int!items:[NotificationEntity!]!}type OpentokAuthOutputType{apiKey:String sessionId:String token:String}type ParticipantExportDataOutputType{avgActiveMinutes:Float avgSteps:Float chatMessages:[ChatMessageDetailOutputType!]!coachingCalls:[CoachingCallDetailOutputType!]!communicationCalls:[CommunicationCallDetailOutputType!]!dateAddedToArm:DateTime!emails:[EmailDetailOutputType!]!fitbitData:[JSONObject!]hoursOfCall:Float isFitbitSyncedInPeriod:Boolean ivrCalls:[IvrCallDetailOutputType!]!journalEntries:[JournalEntryDetailOutputType!]!numberOfEmails:Int numberOfMessages:Int participantExternalId:String participantId:Int!participantName:String!studyArmId:Int!studyArmName:String!studyId:Int!studyName:String!}type PermissionEntity{createdAt:DateTime!deletedAt:DateTime description:String id:ID!name:String!updatedAt:DateTime!}input PermissionInputType{description:String name:String!}type PermissionOutputType{count:Int!items:[PermissionEntity!]!}input PermissionPartialInputType{description:String id:Float!name:String}input PermissionWhereType{description:String id:Float name:String}type PhoneNumberEntity{country:CountryPhoneNumberEntity countryId:ID createdAt:DateTime!deletedAt:DateTime id:ID!isPreferred:Boolean!label:String!type:String!updatedAt:DateTime!}input PhoneNumberInputType{country:CountryPhoneNumberInput countryId:ID createdAt:DateTime deletedAt:DateTime id:ID isPreferred:Boolean label:String="Mobile" type:String updatedAt:DateTime}type Query{adherenceMetrics(fromDate:String=null studyArmsId:Float=null toDate:String=null type:String=null userId:Float=null):MetricsAdherenceOutput!allJournals(limit:LimitInput={skip:0 take:500}where:LibraryWhereInputType={}):LibraryOutputType!archiveSession(sessionId:String!value:Boolean!):ArchiveOutput assessmentAnsweredResponse(endDate:DateTime!libraryId:Float!startDate:DateTime!userId:Float!):[AssessmentsAnsweredResponseOutputType!]!assessmentAnsweredResponses(endDate:DateTime!libraryIds:[Float!]!startDate:DateTime!userId:Float!):[AssessmentsAnsweredResponseOutputType!]!assessmentQuestion(id:Float!):AssessmentQuestionEntity assessmentQuestions(limit:LimitInput={skip:0 take:500}where:AssessmentQuestionWhereInputType={}):AssessmentQuestionOutputType!assessmentResponse(id:Float!):AssessmentResponseEntity assessmentResponses(limit:LimitInput={skip:0 take:500}where:AssessmentResponsesWhereInputType={}):AssessmentResponseOutputType!audit(id:Float!):AuditEntity audits(limit:LimitInput={skip:0 take:500}where:AuditInput={}):AuditOutput!callConferences(correspondingUser:Float=0 limit:LimitInput={skip:0 take:500}search:String="" studyId:Float=null user:Float=0 where:ConferenceWhereInputType={}):ConferenceWithUsersOutputType!canDeleteLibrary(id:Float!):CanDeleteLibraryOutputType chartTabs(chartCount:Boolean!=false userId:ID!):[ChartTabOutputType!]!clinicIds:[String!]!coachingAssessmentForNotes(userId:ID!):CoachingAssessmentForNotesOutput!coachingEvents(userId:Float!):[CoachingEvents!]!conference(id:Float!):ConferenceEntity conferences(limit:LimitInput={skip:0 take:500}where:ConferenceWhereInputType={}):ConferenceOutputType!countEmails(search:String="" type:String="" user:Float=0 where:EmailsInput={}):Float!countEvents(search:String="" type:String="" user:Float=0 where:EventsInput={}):Float!countFiles(where:FilesInput={}):Float!countMessages(search:String="" type:String="" user:Float=0 where:MessagesInput={}):Float!countNotes(where:NotesInput={}):Float!countNotifications(search:String="" studyArmId:Float=null studyId:Float=null subscribed:Boolean=null user:Float=0 where:NotificationsInput={}):Float!countVoices(search:String="" type:String="" user:Float=0 where:VoicesInput={}):Float!dailyAssessments:LibraryOutputType!dailyJournals:LibraryOutputType!email(id:Float!):EmailEntity emails(correspondingUser:Float=0 limit:LimitInput={skip:0 take:500}search:String="" studyArmId:Float=null studyId:Float=null type:String="" user:Float=0 where:EmailsInput={}):EmailsOutput!event(id:Float!):EventEntity events(correspondingUser:Float=0 limit:LimitInput={skip:0 take:500}search:String="" studyArmId:Float=null studyId:Float=null type:String="" user:Float=0 where:EventsInput={}):EventsOutput!exportMessages:Boolean!fetchOriginalString(token:String!):StringShortenOutputType!file(id:Float!):FileEntity files(limit:LimitInput={skip:0 take:500}where:FilesInput={}):FilesOutput!fitbitActivities(date:String!userId:Float!):FitbitEntity!fitbitActivitiesList(fromDate:String!toDate:String!userId:Float!):[FitbitActivityEntity!]!fitbitActivitiesTrend(parameters:FitbitActivityTrendInputType!):[FitbitActivityTrendData!]!fitbitChartsData(fromDate:String!toDate:String!userId:Float!):FitbitChartsData!fitbitDistanceList(fromDate:String!toDate:String!userId:Float!):[FitbitDistanceEntity!]!fitbitHeartRateList(fromDate:String!toDate:String!userId:Float!):[FitbitHeartRateEntity!]!fitbitHistory(fromDate:String!toDate:String!):[FitbitHistoryEntity!]!fitbitHistoryByUser(fromDate:String!toDate:String!userId:Float!):[FitbitHistoryEntity!]!fitbitLifetimeStats(userId:Float!):[FitbitLifetimeStats!]!fitbitSleepList(fromDate:String!toDate:String!userId:Float!):[FitbitSleepEntity!]!fitbitStepsList(fromDate:String!toDate:String!userId:Float!):[FitbitStepsEntity!]!fitbitWeightList(fromDate:String!toDate:String!userId:Float!):[FitbitWeightEntity!]!getCharts(categoryId:Float!userId:Float!):[ChartEntity!]getExportFileContent(exportRequestId:Int!fileName:String!):ExportFileContentResponseType!getExportRequestDetails(id:Int!):ExportRequestOutputType!getProfileEvents(limit:LimitInput={skip:0 take:500}studyId:Float=null user:Float!where:EventsInput={}):[EventWithTimeWindow!]!getScheduledEvents(studyArmsIds:[Float!]!):[EventWithTimeWindow!]!graphDataPoints(payload:GraphDataPointsInput!):GraphDataPointsOutput!hello(name:String!):String!libraries(limit:LimitInput={skip:0 take:500}showOnlyQuestions:Boolean=false studyId:Float=null where:LibraryWhereInputType={}):LibraryOutputType!library(id:Float!):LibraryEntity libraryWithToken(token:String!):LibraryEntity medication(id:Float!):MedicationEntity medications(limit:LimitInput={skip:0 take:500}where:MedicationWhereInputType={}):MedicationOutputType!message(id:Float!):MessageEntity messages(correspondingUser:Float=0 limit:LimitInput={skip:0 take:500}search:String="" studyArmId:Float=null studyId:Float=null type:String="" user:Float=0 where:MessagesInput={}):MessagesOutput!metricsConferences(limit:LimitInput={skip:0 take:500}where:MetricsInputType={}):MetricsOutputType!metricsEvents(where:EventMetricsInputType={}):EventMetricsOutputType!metricsUsers(studyArmId:Float=null studyId:Float=null):MetricsUsersOutputType!myExportRequests:[ExportRequestOutputType!]!note(conferenceId:Float=null id:Float=null userId:Float=null):NoteEntity notes(editor:Float=0 limit:LimitInput={skip:0 take:500}user:Float=0 where:NotesInput={}):NotesOutput!notification(id:Float!):NotificationEntity notifications(limit:LimitInput={skip:0 take:500}search:String="" studyArmId:Float=null studyId:Float=null subscribed:Boolean=null user:Float=0 where:NotificationsInput={}):NotificationsOutput!opentokAuth(joinSessionId:String):OpentokAuthOutputType!participantCoachingLibrariesForDate(date:String!limit:LimitInput={skip:0 take:500}studyId:Float=null userId:Float!where:LibraryWhereInputType={}):LibraryOutputType!permission(id:Float!):PermissionEntity permissions(limit:LimitInput={skip:0 take:500}where:PermissionWhereType={}):PermissionOutputType!questionCategories(limit:LimitInput={skip:0 take:500}where:QuestionCategoryWhereInputType={}):QuestionCategoryOutputType!questionCategory(id:Float!):QuestionCategoryEntity role(id:Float!):RoleEntity roles(limit:LimitInput={skip:0 take:500}where:RoleWhereInputType={}):RolesOutputType!searchAutomationWho(search:String=""):[AutomationWhoOutputType!]!searchRoles(name:String="" staff:Boolean=false):[RoleEntity!]!studies(limit:LimitInput={skip:0 take:500}where:StudyWhereInputType={}):StudyOutputType!studiesWithStudyArms(limit:LimitInput={skip:0 take:500}where:StudyWhereInputType={}):StudyOutputType!study(id:Float!showCoachesStudyArms:Boolean=false showLibraryConfigs:Boolean=false):StudyEntity studyArm(id:Float!):StudyArmEntity studyArmLibraryConfigs(id:Float!):StudyArmLibraryConfigsEntity studyArms(limit:LimitInput={skip:0 take:500}where:StudyArmWhereInputType={}):StudyArmOutputType!studyArmsByStaff(studyId:Float!userId:Float!):[StudyArmEntity!]!studyPermission(id:Float!):StudyPermissionEntity studyPermissions(limit:LimitInput={skip:0 take:500}where:StudyPermissionWhereInput={}):StudyPermissionsOutput!studyRole(id:Float!):StudyRoleEntity studyRoles(limit:LimitInput={skip:0 take:500}where:StudyRoleWhereInput={}):StudyRoleOutput!suggestedDate(where:SuggestedDateWhereInputType={}):SuggestedDateEntity symptom(id:Float!):SymptomEntity symptoms(limit:LimitInput={skip:0 take:500}where:SymptomWhereInputType={}):SymptomOutputType!syncFitbitData(fromDate:String!toDate:String!userId:Float!):Boolean!tooltip(id:Float!):TooltipEntity tooltips(limit:LimitInput={skip:0 take:500}where:TooltipWhereInputType={}):TooltipOutputType!translate(languageCode:String!texts:[String!]!):TranslateOutputType user(email:String="" id:Float):UserEntity userConferences(limit:LimitInput={skip:0 take:500}studyId:Float=null):UserConferencesOutputType!userLogin(email:String!password:String!token:String!):UserLoginOutputType!userProfileGeneralDetails(id:Float!):UserProfileDetailType userProfileInfoDetails(id:Float!studyId:Float):UserInfoDetailsOutputType userProfileInformation(id:Float!):UserEntity userRegistration(email:String!name:String!password:String!):UserEntity!userVerified(email:String=""):UserVerifiedInputType!users(filterAssigned:Boolean=false filterParticipants:Boolean=false limit:LimitInput={skip:0 take:1000}search:String="" sortByLatestMessages:Boolean=false staff:Boolean=false status:String="" studyId:Float=null):UsersOutputType!usersEmails(limit:LimitInput={skip:0 take:500}search:String="" studyArmId:Float=null studyId:Float=null type:String=""):UsersOutputType!usersEvents(limit:LimitInput={skip:0 take:500}search:String="" studyArmId:Float=null studyId:Float=null type:String=""):UsersOutputType!usersMessages(limit:LimitInput={skip:0 take:500}search:String="" studyArmId:Float=null studyId:Float=null type:String=""):UsersOutputType!usersVoices(limit:LimitInput={skip:0 take:500}search:String="" studyArmId:Float=null studyId:Float=null type:String=""):UsersOutputType!voice(id:Float!):VoiceEntity voices(correspondingUser:Float=0 limit:LimitInput={skip:0 take:500}search:String="" studyArmId:Float=null studyId:Float=null user:Float=0 where:VoicesInput={}):VoicesOutput!vonageAuth(userId:Float!):AuthOutputType!}type QuestionCategoryEntity{createdAt:DateTime deletedAt:DateTime id:ID!name:String!questions:[AssessmentQuestionEntity!]updatedAt:DateTime}input QuestionCategoryInputType{createdAt:DateTime deletedAt:DateTime id:ID name:String updatedAt:DateTime}type QuestionCategoryOutputType{count:Int!items:[QuestionCategoryEntity!]!}input QuestionCategoryWhereInputType{id:Float name:String}type RecordingEntity{archiveId:String!conversationUuid:String!createdAt:DateTime!deletedAt:DateTime endTime:String id:ID!recordingUrl:String!recordingUuid:String!sessionId:String!size:String!startTime:String!type:String!updatedAt:DateTime!}input RoleAutoCompleteInputType{id:ID!name:String!}type RoleEntity{createdAt:DateTime!deletedAt:DateTime description:String id:ID!name:String!permissions:[PermissionEntity!]updatedAt:DateTime!}input RoleInputType{description:String name:String!}input RoleWhereInputType{description:String id:Float name:String}type RolesOutputType{count:Int!items:[RoleEntity!]!}type StaffEntity{createdAt:DateTime!deletedAt:DateTime id:ID!role:RoleEntity!updatedAt:DateTime!user:UserEntity!}type Stream{hasAudio:Boolean!hasVideo:Boolean!streamId:String!}type StringShortenOutputType{originalString:String!token:String!}type StudyArmEntity{coaches:[UserEntity!]communications:JSONObject createdAt:DateTime!deletedAt:DateTime id:ID!libraryConfigs:[StudyArmLibraryConfigsEntity!]name:String!updatedAt:DateTime!users:[UserEntity!]}input StudyArmInputType{communications:[JSONObject!]libraryConfigs:[StudyArmLibraryConfigsInputType!]name:String!studyArmId:String!userIds:[Float!]!}type StudyArmLibraryConfigsEntity{afterStart:Float beforeStart:Float createdAt:DateTime!deletedAt:DateTime duration:Float!id:ID!library:LibraryEntity!offset:Float!order:Float repeat:Float repeatText:String time:String updatedAt:DateTime!}input StudyArmLibraryConfigsInputType{afterStart:Float beforeStart:Float duration:Float!id:Float libraryId:Float!offset:Float!order:Float repeat:Float repeatText:String time:String!}type StudyArmOutputType{count:Int!items:[StudyArmEntity!]!}input StudyArmWhereInputType{id:Float name:String}type StudyEntity{createdAt:DateTime!creator:UserEntity creatorId:Float deletedAt:DateTime displayName:String!id:Float!irb:String!moduleId:String modules:[LibraryEntity!]name:String!staff:[UserEntity!]studyArms:[StudyArmEntity!]updatedAt:DateTime!}input StudyInputType{displayName:String!irb:String!name:String!}type StudyOutputType{count:Int!items:[StudyEntity!]!}type StudyPermissionEntity{createdAt:DateTime!deletedAt:DateTime id:ID!permission:PermissionEntity!permissionId:ID!study:StudyEntity!studyId:ID!updatedAt:DateTime!}input StudyPermissionWhereInput{id:Float permissionId:Float studyId:Float}type StudyPermissionsOutput{count:Int!items:[StudyPermissionEntity!]!}type StudyRoleEntity{createdAt:DateTime!deletedAt:DateTime id:ID!role:RoleEntity!study:StudyEntity!updatedAt:DateTime!}type StudyRoleOutput{count:Int!items:[StudyRoleEntity!]!}input StudyRoleWhereInput{id:Float}input StudyStaffInputType{roleId:Float!studyArmsIds:[Float!]userId:Float!}input StudyWhereInputType{description:String id:Float name:String}type SuggestedDateEntity{createdAt:DateTime!deletedAt:DateTime endTime:DateTime!event:EventEntity!id:Float!startTime:DateTime!suggester:UserEntity!updatedAt:DateTime!}input SuggestedDateWhereInputType{eventId:Float}type SymptomEntity{createdAt:DateTime!deletedAt:DateTime description:String!frequency:Float id:ID!label:String!updatedAt:DateTime!userId:Int!}input SymptomInputType{description:String!frequency:Float label:String!}type SymptomOutputType{count:Int!items:[SymptomEntity!]!}input SymptomWhereInputType{creatorId:Float description:String frequency:Float id:Float label:String userId:Float}type TooltipEntity{createdAt:DateTime!deletedAt:DateTime description:String icon:String id:ID!title:String!updatedAt:DateTime!}input TooltipInputType{createdAt:DateTime deletedAt:DateTime description:String icon:String id:ID title:String updatedAt:DateTime}type TooltipOutputType{count:Int!items:[TooltipEntity!]!}input TooltipWhereInputType{id:Float title:String}type TranslateOutputType{texts:[String!]!}type TreatmentEntity{createdAt:DateTime!deletedAt:DateTime disease:String!id:ID!treatmentType:String!updatedAt:DateTime!}input TreatmentInputType{createdAt:DateTime deletedAt:DateTime disease:String id:ID treatmentType:String updatedAt:DateTime}type TypedExportFileContentType{exportMetadata:ExportContentMetadataType!participants:[ParticipantExportDataOutputType!]!}type TypedExportedFileRecordType{contentType:String!dataTypeDisplay:String!description:String expectedDataStructure:String!fileName:String!format:String!schemaVersion:String url:String!}input UpdateChartInput{categoryId:Int dataSourceId:Int dataSourceId1:Int fullWidth:Boolean meta:JSONObject plots:[String!]plots1:[String!]title:String title1:String type:String type1:String userId:Int xAxis:String yAxis:String yAxis1:String}input UpdateEmailInput{actions:String data:String description:String labels:String liked:Boolean studyArmId:Float studyId:Float title:String type:String viewed:Boolean}input UpdateEventInput{actions:String confirmed:Float data:String description:String end:DateTime labels:String liked:Boolean resource:String start:DateTime studyArmId:Float studyId:Float title:String type:String viewed:Boolean}input UpdateFileInput{description:String path:String size:Float title:String type:String url:String}input UpdateMessageInput{actions:String data:String description:String labels:String liked:Boolean studyArmId:Float studyId:Float title:String type:String viewed:Boolean}input UpdateNoteInput{actions:String data:String description:String editorId:Float entity:String isPinned:Boolean labels:String liked:Boolean parentId:Float privateNotes:Boolean status:String title:String type:String userId:Float viewed:Boolean}input UpdateNotificationInput{actions:String data:String description:String labels:String liked:Boolean title:String type:String viewed:Boolean}input UpdateStudyPermissionInput{permissionId:Float!studyId:Float!}input UpdateStudyRoleInput{id:Float roleId:Float!studyId:Float!}input UpdateVoiceInput{actions:String data:String description:String labels:String liked:Boolean studyArmId:Float studyId:Float title:String type:String url:String viewed:Boolean}"""The `Upload` scalar type represents a file upload.""" scalar Upload type UserConferencesOutputType{count:Int!items:[UserEntity!]!}type UserEntity{address:String age:String assignedStaff:StaffEntity clinicId:String clinics:[ClinicEntity!]createdAt:DateTime!deletedAt:DateTime description:String email:String!familyMembers:[FamilyMemberEntity!]fitbitAccessToken:String fitbitId:String fitbitRefreshToken:String fitbitScopes:String id:ID!idNumber:String isSubscribed:Boolean lastMessageAt:Float name:String!notes:[NoteEntity!]notificationPreferenceType:String password:String permissions:[StudyPermissionEntity!]phoneNumbers:[PhoneNumberEntity!]preferredLanguage:String preferredTime:String primaryRole:RoleEntity privateNotes:Boolean receiverEmails:[EmailEntity!]receiverMessages:[MessageEntity!]receiverNotifications:[NotificationEntity!]receiverVoices:[VoiceEntity!]roles:[StudyRoleEntity!]senderEmails:[EmailEntity!]senderMessages:[MessageEntity!]senderNotifications:[NotificationEntity!]senderVoices:[VoiceEntity!]sexualOrientation:String startDate:DateTime status:String studies:[StudyEntity!]studyArmsId:[Float!]timezone:String treatments:[TreatmentEntity!]updatedAt:DateTime!vonageName:String vonageUuid:String zipCode:String}type UserInfoDetailsOutputType{address:String age:String assignedStaff:StaffEntity clinicId:String clinics:[ClinicEntity!]createdAt:DateTime deletedAt:DateTime description:String email:String familyMembers:[FamilyMemberEntity!]fitbitAccessToken:String fitbitId:String fitbitRefreshToken:String fitbitScopes:String id:ID idNumber:String isSubscribed:Boolean lastMessageAt:Float name:String notes:[NoteEntity!]notificationPreferenceType:String password:String permissions:[StudyPermissionEntity!]phoneNumbers:[PhoneNumberEntity!]preferredLanguage:String preferredTime:String primaryRole:RoleEntity privateNotes:Boolean receiverEmails:[EmailEntity!]receiverMessages:[MessageEntity!]receiverNotifications:[NotificationEntity!]receiverVoices:[VoiceEntity!]roles:[StudyRoleEntity!]senderEmails:[EmailEntity!]senderMessages:[MessageEntity!]senderNotifications:[NotificationEntity!]senderVoices:[VoiceEntity!]sexualOrientation:String startDate:DateTime status:String studies:[StudyEntity!]studyArm:String studyArmsId:[Float!]timezone:String treatments:[TreatmentEntity!]updatedAt:DateTime vonageName:String vonageUuid:String zipCode:String}input UserInputType{description:String email:String!name:String!password:String!roleId:Float!status:String!}type UserLoginOutputType{token:String user:UserEntity}input UserPermissionInputType{permissions:[Int!]!roleId:Float!studyArmIds:[Int!]studyId:Float!}input UserProfileDetailInputType{assignedStaff:AssignedStaffInputType startDate:DateTime}type UserProfileDetailType{address:String age:String assignedStaff:StaffEntity clinicId:String clinics:[ClinicEntity!]createdAt:DateTime deletedAt:DateTime description:String email:String familyMembers:[FamilyMemberEntity!]fitbitAccessToken:String fitbitId:String fitbitRefreshToken:String fitbitScopes:String id:ID idNumber:String isSubscribed:Boolean lastMessageAt:Float name:String notes:[NoteEntity!]notificationPreferenceType:String password:String permissions:[StudyPermissionEntity!]phoneNumbers:[PhoneNumberEntity!]preferredLanguage:String preferredTime:String primaryRole:RoleEntity privateNotes:Boolean receiverEmails:[EmailEntity!]receiverMessages:[MessageEntity!]receiverNotifications:[NotificationEntity!]receiverVoices:[VoiceEntity!]roles:[StudyRoleEntity!]senderEmails:[EmailEntity!]senderMessages:[MessageEntity!]senderNotifications:[NotificationEntity!]senderVoices:[VoiceEntity!]sexualOrientation:String startDate:DateTime status:String studies:[StudyEntity!]studyArmsId:[Float!]timezone:String treatments:[TreatmentEntity!]updatedAt:DateTime vonageName:String vonageUuid:String zipCode:String}input UserProfileDetailsInputType{address:String age:String assignedStaff:AssignedStaffInputType clinicId:String clinics:[ClinicInputType!]!familyMembers:[FamilyMemberInputType!]!idNumber:String name:String!phoneNumbers:[PhoneNumberInputType!]!preferredLanguage:String preferredTime:String sexualOrientation:String startDate:DateTime treatments:[TreatmentInputType!]!zipCode:String}input UserProfileInfoInputType{address:String clinicId:String clinics:[ClinicInputType!]!familyMembers:[FamilyMemberInputType!]!idNumber:String name:String!phoneNumbers:[PhoneNumberInputType!]!preferredLanguage:String treatments:[TreatmentInputType!]!}input UserStudyInputType{studyArmId:Float studyId:Float!userId:Float!}type UserSubscriptionEntity{createdAt:DateTime!deletedAt:DateTime fromUser:UserEntity!id:ID!isSubscribed:Boolean!notificationPreference:NotificationpPreferencesEntity!toUser:UserEntity!updatedAt:DateTime!}input UserUpdateInputType{description:String email:String!name:String!privateNotes:Boolean roleId:Float status:String!}type UserVerifiedInputType{verified:Boolean!}type UsersOutputType{count:Int!items:[UserEntity!]!}type VoiceEntity{actions:String audioUrl:String createdAt:DateTime!data:String deletedAt:DateTime description:String id:Float!labels:String liked:Boolean!receiver:UserEntity receiverId:Float sender:UserEntity senderId:Float study:StudyEntity studyArm:StudyArmEntity title:String!type:String updatedAt:DateTime!url:String viewed:Boolean!}input VoicesInput{actions:String data:String description:String id:Float labels:String liked:Boolean studyArmId:Float studyId:Float title:String type:String url:String viewed:Boolean}type VoicesOutput{count:Int!items:[VoiceEntity!]!}');
